import React from "react";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { Form, Button, Dropdown,OverlayTrigger, Tooltip } from "react-bootstrap";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import ReactTooltip from "react-tooltip";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-calendar/dist/Calendar.css";
import { confirmAlert } from "react-confirm-alert";
import $ from "jquery";
import scrollIntoView from "scroll-into-view";
import OutsideClickHandler from "react-outside-click-handler";
import { resolve, reject } from "q";
import profile from "../../../../Common/Assets/Images/profile.png";
import ForecastLock from "../../../../Common/Assets/Images/icons/forecast-lock.svg";
import { ReassignAllModal } from "./components/ReassignAllModal";
import { ShiftReassignPopUp } from "./components/ShiftReassignPopUp";
import { DepartmentSearchView } from "./components/DepartmentSearchView";
import { schConversions } from "./commonFunctions/conversions";
import { dragDrop } from "./commonFunctions/dragDropFunc";
import { ConfirmationModal } from "../../../../Common/Components/ConfirmationModal";
import { ReactPageLoader } from "../../../../Common/Components/ReactPageLoader";
import { LaborSchedule } from "../../../../Common/Services/LaborSchedule";
import {
  ILaborScheduleDepartmentViewScheduleDto,
  ILaborScheduleScheduleDragRequestDto,
  ILaborScheduleReassignRemoveAllEmployeeShift,
  ILaborScheduleDeleteSchedule,
  ILabourBulkSelectSchedule,
} from "../../../../Common/Contracts/ILaborSchedule";
import { scheduleComponents } from "./commonFunctions/ScheduleComponents";
import { Schedule } from "./commonFunctions/Schedule";
import { Utils } from "../../../../Common/Utilis";

const tooltipMessage =
  "The schedule cannot be changed because a shift from this day has already begun.";
let scrollHeaderMountDisplay = true;
let dragDropArray: any = [];

export class PositionAfterExpend extends React.Component<any, any> {
  private positionExpendedRef: any;
  private positionSearchExpended: any;
  constructor(props: any) {
    super(props);
    this.positionSearchExpended = React.createRef();
    this.positionExpendedRef = React.createRef();
    this.state = {
      loaderTrue: true,
      tableData: [],
      tableDataFilter: [],
      cellDropdownList: [
        "Add",
        "Edit",
        "Reassign",
        "Duplicate",
        // "Split",
        "Bulk Select",
        "Delete",
        "Change Log"
      ],
      currentDate: {},
      bulkSelect: false,
      clickedDay: "",
      totalPossibleBulks: 0,
      bulkSelctShiftsCount: 0,
      bulkSelectShiftArray: [],
      viewAssignDropdown: false,
      footerAssignRow: {},
      dragType: "",
      dragStartRow: {},
      dragStartDay: "",
      dragStartRowIndex: "",
      dragStartSchedule: {},
      dragEndRow: {},
      dragEndDay: "",
      dragEndRowIndex: "",
      scrollHeaderDisplay: false,
      dragStartScrollDay: "",
      dragStartScrollIndex: "",
      dragEndScrollDay: "",
      dragEndCellType: "",
      scrollDays: [],
      scrollUnassigned: [],
      scrollHeaderHeight: "",
      EmployeeTypeTotal:"",
    };
  }

  componentDidMount = () => {
    scrollHeaderMountDisplay = false;
    this.getPosWiseScheduleData("componentMount");
    window.addEventListener("scroll", this.handleScroll, true);
  };

  componentWillUnmount = () => {
    document.removeEventListener("scroll", this.handleScroll, true);
  };

  handleScroll = (event: any) => {
    if (event.target.className === "body-sec container-fluid") {
      let scrollPostion = event.target.scrollTop;

      if (
        scrollHeaderMountDisplay &&
        scrollPostion > Number(this.state.scrollHeaderHeight)
      ) {
        this.setState({ scrollHeaderDisplay: true });
      } else {
        this.setState({ scrollHeaderDisplay: false });
      }
    }
  };

  getPosWiseScheduleData = (type: string) => {
    if (type === "ehidChange" || type === "calenderDropDown") {
      this.setState({ loaderTrue: true });
    }

    let request = {} as ILaborScheduleDepartmentViewScheduleDto;

    request.hotelID = this.props.mainParentState.hidValue;
    request.deptID = this.props.row.posId;
    request.weekStartDate = this.props.mainViewState.navigationCalenderDates[0];
    request.weekEndDate = this.props.mainViewState.navigationCalenderDates[1];
    request.ViewType = this.props.mainViewState.scheduleView;
    request.filterID = "0";
    request.sortType = this.props.mainViewState.sortingOrder;
    request.showhideShift = this.props.mainViewState.hidePosFlag
      ? "No"
      : "hideShowDept";
    request.searchName =
      this.props.mainViewState.searchedUser === ""
        ? "blankSearch"
        : this.props.mainViewState.searchedUser;

    LaborSchedule.GetLaborDepartmentScheduleData(request)
      .then(async (result: any) => {
        // 
        debugger;
        if (result.message === "Success" && result.result.length !== null) {
          const apiResult = result.result;
          dragDropArray = []; // setting to drag Drop array to blank again
          let tempScheduleData: any = [];
          let shiftType: any = "";
          let currentDate: any = {};
          let employeeTypeTotal=apiResult[0].employeeTypeTotal;
          
          for (let i = 0; i < apiResult.length; i++) {
            shiftType = apiResult[i].shiftType;
            currentDate = new Date(apiResult[i].currentDate);
            let tempRowObject: any = {};
            tempRowObject.rowNo = i;
            tempRowObject.deptId = this.props.row.deptId;
            tempRowObject.posId = this.props.row.posId;
            tempRowObject.showUserList = "showOptions";
            tempRowObject.multipleShiftVisibility = "hideDropdown";
            tempRowObject.bulkSelect = false;
            tempRowObject.shiftType = apiResult[i].shiftType;

            if (apiResult[i].shiftType === "UnAssigned") {
              tempRowObject.employeeImage = "";
              tempRowObject.employeeName = "Unassigned Shifts";
              tempRowObject.timeDetails = "";
              tempRowObject.timeDetailsSummary = "";
              tempRowObject.employeePayType = "";
              tempRowObject.actualHour = 0;
            } else {
              tempRowObject.employeeImage = apiResult[i].imagePath;
              tempRowObject.employeeName = apiResult[i].employee;
              tempRowObject.timeDetails = apiResult[i].ot;
              let displayDates: any = apiResult[i].payPeriodDate.split("_");
              tempRowObject.employeePayType = displayDates[4];
              tempRowObject.isOVertimeAllowed = displayDates[5];
              let time = apiResult[i].ot.split("/");
              tempRowObject.actualHour = Number(
                time[0].trim().replace(":", ".")
              );
              if (
                Number(time[0].trim().replace(":", ".")) >
                Number(time[1].trim().replace(":", ".")) &&
                tempRowObject.employeePayType !== "Salaried"
              ) {
                tempRowObject.timeDetailsSummary = "overtime";
              } else {
                tempRowObject.timeDetailsSummary = "undertime";
              }
            }
            let day1: any = []; //0 :date, //1:dateday, //2:intime,
            let day2: any = []; //3:outtime,  //4:deptid,
            let day3: any = []; //5:positionid,  //6:position,
            let day4: any = []; //7:IsPublishShift, //8:IsMultiShift,
            let day5: any = []; //9:uniqueno,
            let day6: any = []; //10:indate,
            let day7: any = []; //11:outdate

            for (let j = 1; j <= 7; j++) {
              let pushFlag = "";
              let multiShiftPushArray: any = [];
              let dayValues: any = [];
              let day = `day${j}`;
              let shiftObject: any = {};
              if (apiResult[i][day] === null) {
                shiftObject.shiftDate = "";
                shiftObject.shiftDay = "";
                shiftObject.shiftInTime = "";
                shiftObject.shiftOutTime = "";
                shiftObject.displayTime = "";
                shiftObject.deptId = this.props.row.deptId;
                shiftObject.positionId = this.props.row.posId;
                if (shiftType === "UnAssigned") {
                  shiftObject.shiftPosition = "";
                } else {
                  shiftObject.shiftPosition = "+";
                }
                shiftObject.optionsItems = "showOptions";
                shiftObject.shiftType = "blankShift";
                shiftObject.shiftIsMultiple = "";
                shiftObject.shiftAction = "";
                shiftObject.shiftbulkSelect = false;
                shiftObject.uniqueno = "";
                shiftObject.indate = "";
                shiftObject.outdate = "";
                shiftObject.typeMaster = "1";
                shiftObject.actualPunches = "No";
                shiftObject.isMPOR = false;
              } else {
                if (apiResult[i][day].includes("!!")) {
                  pushFlag = "multipleShift";

                  let multiShift = apiResult[i][day].split("!!");
                  for (let k = 0; k < multiShift.length; k++) {
                    dayValues = multiShift[k].split("||");
                    let pushObject: any = {};
                    pushObject.shiftDate = dayValues[0];
                    pushObject.shiftDay = dayValues[1];
                    if (dayValues[2] === "") {
                      pushObject.shiftInTime = "";
                      pushObject.shiftOutTime = "";
                      pushObject.displayTime = "";
                    } else {
                      pushObject.shiftInTime = dayValues[2];
                      pushObject.shiftOutTime = dayValues[3];
                      pushObject.displayTime = `${dayValues[2]} - ${dayValues[3]}`;
                    }
                    pushObject.deptId = dayValues[4];
                    pushObject.positionId = dayValues[5];
                    pushObject.optionsItems = "showOptions";
                    if (dayValues[2] === "") {
                      pushObject.shiftPosition = "+";
                    } else {
                      pushObject.shiftPosition = schConversions.replaceInvalidChar(
                        dayValues[6]
                      );
                    }
                    if (Number(dayValues[5]) !== Number(this.props.row.posId)) {
                      if (dayValues[7] === "Yes") {
                        pushObject.shiftType = "hideShowPublished";
                      } else {
                        pushObject.shiftType = "hideShowDeptUnpublished";
                      }
                    } else if (shiftType === "UnAssigned") {
                      pushObject.shiftType = "unassigned";
                    } else if (dayValues[7] === "Yes") {
                      pushObject.shiftType = "published";
                    } else {
                      pushObject.shiftType = "unpublished";
                    }
                    if (dayValues[2] === "") {
                      pushObject.shiftType = "blankShift";
                    }

                    pushObject.shiftIsMultiple = dayValues[8];
                    pushObject.shiftAction = "";
                    pushObject.shiftbulkSelect = false;
                    pushObject.uniqueno = dayValues[9];
                    pushObject.indate = dayValues[10];
                    pushObject.outdate = dayValues[11];
                    pushObject.typeMaster = dayValues[12];
                    pushObject.actualPunches = dayValues[13];

                    if (dayValues[12] === "3") {
                      pushObject.shiftPosition = "PTO";
                      pushObject.shiftType = "ptoRequest";
                    }
                    if (dayValues[12] === "4") {
                      pushObject.shiftPosition = "PTO";
                      pushObject.shiftType = "ptoApproved";
                    }
                    if (dayValues[12] === "5") {
                      pushObject.shiftPosition = "UTO ";
                      pushObject.shiftType = "ptoRequest";
                    }
                    if (dayValues[12] === "6") {
                      pushObject.shiftPosition = "UTO";
                      pushObject.shiftType = "ptoApproved";
                    }
                    if (dayValues[12] === "8") {
                      pushObject.shiftPosition = "Do not schedule";
                      pushObject.shiftType = "ptoApproved";
                    }
                    if (dayValues[12] === "10") {
                      pushObject.shiftPosition = "Do not schedule";
                      pushObject.shiftType = "ptoRequest";
                    }
                    pushObject.isMPOR = dayValues[14] === "Yes" ? true : false;
                    multiShiftPushArray.push(pushObject);
                  }
                } else {
                  pushFlag = "singleShift";

                  dayValues = apiResult[i][day].split("||");

                  shiftObject.shiftDate = dayValues[0];
                  shiftObject.shiftDay = dayValues[1];
                  if (dayValues[2] === "") {
                    shiftObject.shiftInTime = "";
                    shiftObject.shiftOutTime = "";
                    shiftObject.displayTime = "";
                  } else {
                    shiftObject.shiftInTime = dayValues[2];
                    shiftObject.shiftOutTime = dayValues[3];
                    shiftObject.displayTime = `${dayValues[2]} - ${dayValues[3]}`;
                  }
                  shiftObject.deptId = dayValues[4];
                  shiftObject.positionId = dayValues[5];
                  shiftObject.optionsItems = "showOptions";
                  if (dayValues[2] === "") {
                    if (this.props.mainViewState.isBannerShow) {
                      shiftObject.shiftPosition = " ";
                    } else {
                      shiftObject.shiftPosition = "+";
                    }
                  } else {
                    shiftObject.shiftPosition = schConversions.replaceInvalidChar(
                      dayValues[6]
                    );
                  }
                  if (Number(dayValues[5]) !== Number(this.props.row.posId)) {
                    if (dayValues[7] === "Yes") {
                      shiftObject.shiftType = "hideShowPublished";
                    } else {
                      shiftObject.shiftType = "hideShowDeptUnpublished";
                    }
                  } else if (shiftType === "UnAssigned") {
                    shiftObject.shiftType = "unassigned";
                  } else if (dayValues[7] === "Yes") {
                    shiftObject.shiftType = "published";
                  } else {
                    shiftObject.shiftType = "unpublished";
                  }
                  if (dayValues[2] === "") {
                    shiftObject.shiftType = "blankShift";
                  }

                  shiftObject.shiftIsMultiple = dayValues[8];
                  shiftObject.shiftAction = "";
                  shiftObject.shiftbulkSelect = false;
                  shiftObject.uniqueno = dayValues[9];
                  shiftObject.indate = dayValues[10];
                  shiftObject.outdate = dayValues[11];
                  shiftObject.typeMaster = dayValues[12];
                  shiftObject.actualPunches = dayValues[13];
                  if (dayValues[12] === "3") {
                    shiftObject.shiftPosition = "PTO";
                    shiftObject.shiftType = "ptoRequest";
                  }
                  if (dayValues[12] === "4") {
                    shiftObject.shiftPosition = "PTO";
                    shiftObject.shiftType = "ptoApproved";
                  }
                  if (dayValues[12] === "5") {
                    shiftObject.shiftPosition = "UTO ";
                    shiftObject.shiftType = "ptoRequest";
                  }
                  if (dayValues[12] === "6") {
                    shiftObject.shiftPosition = "UTO";
                    shiftObject.shiftType = "ptoApproved";
                  }
                  if (dayValues[12] === "8") {
                    shiftObject.shiftPosition = "Do not schedule";
                    shiftObject.shiftType = "ptoApproved";
                  }
                  if (dayValues[12] === "10") {
                    shiftObject.shiftPosition = "Do not schedule";
                    shiftObject.shiftType = "ptoRequest";
                  }
                  shiftObject.isMPOR = dayValues[14] === "Yes" ? true : false;
                }
              }

              if (pushFlag === "multipleShift") {
                let multiShiftAddObject: any = {};
                multiShiftAddObject.shiftDate = "";
                multiShiftAddObject.shiftDay = "";
                multiShiftAddObject.shiftInTime = "";
                multiShiftAddObject.shiftOutTime = "";
                multiShiftAddObject.displayTime = "";
                multiShiftAddObject.deptId = "";
                multiShiftAddObject.positionId = this.props.row.posId;
                multiShiftAddObject.shiftPosition = "+";
                multiShiftAddObject.shiftType = "blankShift";
                multiShiftAddObject.shiftIsMultiple = "";
                multiShiftAddObject.shiftAction = "";
                multiShiftAddObject.shiftbulkSelect = false;
                multiShiftAddObject.uniqueno = "";
                multiShiftAddObject.indate = "";
                multiShiftAddObject.outdate = "";
                multiShiftAddObject.typeMaster = "1";
                multiShiftAddObject.actualPunches = "No";
                multiShiftAddObject.isMPOR = false;
                if (!this.props.mainViewState.lockDays.includes(day)) {
                  multiShiftPushArray.push(multiShiftAddObject);
                }
                if (day === "day1") {
                  day1 = multiShiftPushArray;
                } else if (day === "day2") {
                  day2 = multiShiftPushArray;
                } else if (day === "day3") {
                  day3 = multiShiftPushArray;
                } else if (day === "day4") {
                  day4 = multiShiftPushArray;
                } else if (day === "day5") {
                  day5 = multiShiftPushArray;
                } else if (day === "day6") {
                  day6 = multiShiftPushArray;
                } else if (day === "day7") {
                  day7 = multiShiftPushArray;
                }
              } else {
                if (day === "day1") {
                  day1.push(shiftObject);
                } else if (day === "day2") {
                  day2.push(shiftObject);
                } else if (day === "day3") {
                  day3.push(shiftObject);
                } else if (day === "day4") {
                  day4.push(shiftObject);
                } else if (day === "day5") {
                  day5.push(shiftObject);
                } else if (day === "day6") {
                  day6.push(shiftObject);
                } else if (day === "day7") {
                  day7.push(shiftObject);
                }
              }
              tempRowObject.day1 = day1;
              tempRowObject.day2 = day2;
              tempRowObject.day3 = day3;
              tempRowObject.day4 = day4;
              tempRowObject.day5 = day5;
              tempRowObject.day6 = day6;
              tempRowObject.day7 = day7;
            }
            tempScheduleData.push(tempRowObject);
          }

          // Setting Table State
          this.setState(
            {
              tableData: tempScheduleData,
              dragStartSchedule: {},
              bulkSelect: false,
              loaderTrue: false,
              currentDate: currentDate,
              EmployeeTypeTotal : employeeTypeTotal,
            },
            () => {
              if (!scrollHeaderMountDisplay) {
                scrollHeaderMountDisplay = true;
              }
              if (this.positionSearchExpended.current !== null) {
                this.positionSearchExpended.current.getSearchUsersList();
              }
              this.getScrollData();
            }
          );
        } else {
          Utils.toastError(result.message, {
            // // position: toast.POSITION.BOTTOM_RIGHT,
            // // containerId: "scheduleMain",
          });
          this.setState({ loaderTrue: false });
        }
        // Scroll to the top for best user view
        scrollIntoView(this.positionExpendedRef.current, {
          align: {
            top: 0,
            left: 0,
            topOffset: 125,
            leftOffset: 0,
          },
        });
        resolve();
      })
      .catch((err: any) => {
        Utils.toastError(`Server Error, ${err}`, {
          // // position: toast.POSITION.BOTTOM_RIGHT,
          // // containerId: "scheduleMain",
        });
        this.setState({ loaderTrue: false });
        reject();
      });
  };

  getScrollData = () => {
    let { lockDays, headerDates, headerDays } = this.props.mainViewState;
    let unassignedData = this.state.tableData.filter(
      (data: any) => data.shiftType === "UnAssigned"
    );

    let unassignedDataHeight = unassignedData.length * 48;
    let parentRowFixedHeigt = Number(this.props.row.rowNo) * 84;
    let fixedHeight = this.props.mainViewState.importForecastBanner ? 249 : 200;
    let scrollHeight = unassignedDataHeight + fixedHeight + parentRowFixedHeigt;
    let headerData: any = [];
    let unassignedShifts: any = [];
    for (let i = 0; i < 7; i++) {
      let scrollDayObject: any = {};
      let scrollUnassignedObject: any = {};
      scrollDayObject.day = headerDays[i];
      scrollDayObject.date = headerDates[i];
      let dayValue = `day${i + 1}`;
      scrollDayObject.dayValue = dayValue;
      scrollUnassignedObject.dayName = dayValue;
      scrollUnassignedObject.renderType = "showOptions";
      if (lockDays.includes(dayValue)) {
        scrollDayObject.isLocked = true;
      } else {
        scrollDayObject.isLocked = false;
      }
      headerData.push(scrollDayObject);

      let tempArray: any = [];
      for (let i = 0; i < unassignedData.length; i++) {
        if (unassignedData[i][dayValue][0].shiftPosition !== "") {
          tempArray.push(unassignedData[i][dayValue][0]);
        }
        scrollUnassignedObject.dayValues = tempArray;
        if (this.state.bulkSelect && !lockDays.includes(dayValue)) {
          scrollUnassignedObject.bulkSelect = true;
        } else {
          scrollUnassignedObject.bulkSelect = false;
        }
      }
      unassignedShifts.push(scrollUnassignedObject);
    }
    this.setState({
      scrollDays: headerData,
      scrollUnassigned: unassignedShifts,
      scrollHeaderHeight: scrollHeight,
    });
  };

  changeInScrollData = (
    typeOfChange: any,
    schdeule: any,
    row: any,
    dayType: any
  ) => {
    let { scrollUnassigned } = this.state;
    if (typeOfChange === "reassign") {
      let indexOfDay =
        Number(dayType.slice(dayType.length - 1, dayType.length)) - 1;
      let dayValues = [...row.dayValues];
      let multipeIndex: any;
      for (let i = 0; i < dayValues.length; i++) {
        if (Number(dayValues[i].uniqueno) === Number(schdeule.uniqueno)) {
          multipeIndex = i;
          break;
        }
      }
      dayValues[multipeIndex].optionsItems = "reassignModalPopUp";
      scrollUnassigned[indexOfDay].renderType = "showReassign";
      scrollUnassigned[indexOfDay].dayValues = dayValues;
    } else if (typeOfChange === "delete") {
      let indexOfDay =
        Number(dayType.slice(dayType.length - 1, dayType.length)) - 1;
      let dayValues = [...row.dayValues];
      let multipeIndex: any;
      for (let i = 0; i < dayValues.length; i++) {
        if (Number(dayValues[i].uniqueno) === Number(schdeule.uniqueno)) {
          multipeIndex = i;
          break;
        }
      }
      dayValues[multipeIndex].optionsItems = "deleteModalPopup";
      scrollUnassigned[indexOfDay].renderType = "showDelete";
      scrollUnassigned[indexOfDay].dayValues = dayValues;
    }
    this.setState({ scrollUnassigned: scrollUnassigned });
  };

  optionBulkSelect = () => {
    this.props.parentBulkSelect(true);

    let totalBulkItems = 0;
    let newTableData = [...this.state.tableData];
    newTableData = newTableData.map((d) => {
      let day1: any = [];
      let day2: any = [];
      let day3: any = [];
      let day4: any = [];
      let day5: any = [];
      let day6: any = [];
      let day7: any = [];
      for (let j = 1; j <= 7; j++) {
        let dayValue = `day${j}`;
        let tempDay = [...d[dayValue]];
        for (let i = 0; i < tempDay.length; i++) {
          let lockDayCondition = false;
          let currentOffSet = schConversions.GetUTCTime(
            Number(this.props.mainViewState.offSetHour)
          );
          let scheduleCurrentDate = new Date(tempDay[i].outdate);
          let dateCompareResult = currentOffSet > scheduleCurrentDate;
          if (this.props.mainViewState.lockDays.includes(dayValue)) {
            lockDayCondition = true;
          }
          if (
            lockDayCondition ||
            tempDay[i].actualPunches === "Yes" ||
            tempDay[i].shiftPosition.trim() === "" ||
            tempDay[i].shiftPosition.trim() === "+" ||
            tempDay[i].shiftPosition.trim() === "PTO" ||
            tempDay[i].shiftPosition.trim() === "UTO" ||
            tempDay[i].shiftPosition.trim() === "Do not schedule".trim()
          ) {
          } else {
            tempDay[i].shiftAction = "bulkSelect";
            totalBulkItems = totalBulkItems + 1;
          }
        }
        if (dayValue === "day1") {
          day1 = tempDay;
        } else if (dayValue === "day2") {
          day2 = tempDay;
        } else if (dayValue === "day3") {
          day3 = tempDay;
        } else if (dayValue === "day4") {
          day4 = tempDay;
        } else if (dayValue === "day5") {
          day5 = tempDay;
        } else if (dayValue === "day6") {
          day6 = tempDay;
        } else if (dayValue === "day7") {
          day7 = tempDay;
        } else {
        }
      }
      return {
        ...d,
        day1: day1,
        day2: day2,
        day3: day3,
        day4: day4,
        day5: day5,
        day6: day6,
        day7: day7,
        bulkSelect: true,
      };
    });
    this.setState(
      (curr: any) => ({
        ...curr,
        tableData: newTableData,
        bulkSelect: true,
        totalPossibleBulks: totalBulkItems,
      }),
      () => {
        this.getScrollData();
      }
    );
  };

  footerBulkClose = () => {
    this.props.parentBulkSelect(false);

    let newTableData = [...this.state.tableData];
    newTableData = newTableData.map((d) => {
      let day1: any = [];
      let day2: any = [];
      let day3: any = [];
      let day4: any = [];
      let day5: any = [];
      let day6: any = [];
      let day7: any = [];
      for (let j = 1; j <= 7; j++) {
        let dayValue = `day${j}`;
        let tempDay = [...d[dayValue]];
        for (let i = 0; i < tempDay.length; i++) {
          tempDay[i].shiftAction = "";
          tempDay[i].shiftbulkSelect = false;
        }
        if (dayValue === "day1") {
          day1 = tempDay;
        } else if (dayValue === "day2") {
          day2 = tempDay;
        } else if (dayValue === "day3") {
          day3 = tempDay;
        } else if (dayValue === "day4") {
          day4 = tempDay;
        } else if (dayValue === "day5") {
          day5 = tempDay;
        } else if (dayValue === "day6") {
          day6 = tempDay;
        } else if (dayValue === "day7") {
          day7 = tempDay;
        } else {
        }
      }

      return {
        ...d,
        day1: day1,
        day2: day2,
        day3: day3,
        day4: day4,
        day5: day5,
        day6: day6,
        day7: day7,
        bulkSelect: false,
      };
    });
    this.setState(
      (curr: any) => ({
        ...curr,
        tableData: newTableData,
        bulkSelect: false,
        bulkSelctShiftsCount: 0,
        totalPossibleBulks: 0,
      //  bulkSelectShiftArray: [],
        viewAssignDropdown: false,
      }),
      () => {
        this.getScrollData();
      }
    );
  };

  employeeNameSelection = (e: any, rowIndex: any,row:any) => {
    // 
    let value = e.target.text;
    if (value === "Reassign All Shifts") {
      if (scheduleComponents.checkMporForRow(row)) {
        this.showMOPRAssignAllAlert(rowIndex);
      } else {
        this.showReassignAllModal(rowIndex);
      }
    }

    if (value === "Remove From Schedule") {
      let newTableData = [...this.state.tableData];
      newTableData = newTableData.map((d, index) => {
        if (index === rowIndex) {
          return {
            ...d,
            showUserList: "showConfirmationModalBox",
          };
        } else {
          return {
            ...d,
            showUserList: "showOptions",
          };
        }
      });
      this.setState((curr: any) => ({ ...curr, tableData: newTableData }));
    }
  };

  showMOPRAssignAllAlert = (rowIndex) => {
    let newTableData = [...this.state.tableData];
    newTableData = newTableData.map((d, index) => {
      if (index === rowIndex) {
        return {
          ...d,
          showUserList: "showMPORAlert",
        };
      } else {
        return {
          ...d,
          showUserList: "showOptions",
        };
      }
    });
    this.setState((curr: any) => ({ ...curr, tableData: newTableData }));
  };

  showReassignAllModal = (rowIndex) => {
    let newTableData = [...this.state.tableData];
    newTableData = newTableData.map((d, index) => {
      if (index === rowIndex) {
        return {
          ...d,
          showUserList: "showEmployeeList",
        };
      } else {
        return {
          ...d,
          showUserList: "showOptions",
        };
      }
    });
    this.setState((curr: any) => ({ ...curr, tableData: newTableData }));
  };

  employeeNameHideOutside = () => {
    let newTableData = [...this.state.tableData];
    newTableData = newTableData.map((d) => {
      return {
        ...d,
        showUserList: "showOptions",
      };
    });
    this.setState((curr: any) => ({ ...curr, tableData: newTableData }));
    this.setState({ clickedDay: "" });
  };

  multipleClickOutside = (
    row: any,
    rowIndex: any,
    dayType: any,
    schdeule: any
  ) => {
    this.setState({ clickedDay: "" });
    let newTableData = [...this.state.tableData];
    newTableData = newTableData.map((d, index) => {
      if (index === rowIndex) {
        let tempRow = [...row[dayType]];
        let multipeIndex: any;
        for (let i = 0; i < tempRow.length; i++) {
          if (Number(tempRow[i].uniqueno) === Number(schdeule.uniqueno)) {
            multipeIndex = i;
            break;
          }
        }
        let tempDay = { ...row[dayType][multipeIndex] };
        tempDay.optionsItems = "showOptions";
        tempRow[multipeIndex] = tempDay;
        let dayToAssign = tempRow;
        if (dayType === "day1") {
          return {
            ...d,
            multipleShiftVisibility: "hideDropdown",
            day1: dayToAssign,
          };
        } else if (dayType === "day2") {
          return {
            ...d,
            multipleShiftVisibility: "hideDropdown",
            day2: dayToAssign,
          };
        } else if (dayType === "day3") {
          return {
            ...d,
            multipleShiftVisibility: "hideDropdown",
            day3: dayToAssign,
          };
        } else if (dayType === "day4") {
          return {
            ...d,
            multipleShiftVisibility: "hideDropdown",
            day4: dayToAssign,
          };
        } else if (dayType === "day5") {
          return {
            ...d,
            multipleShiftVisibility: "hideDropdown",
            day5: dayToAssign,
          };
        } else if (dayType === "day6") {
          return {
            ...d,
            multipleShiftVisibility: "hideDropdown",
            day6: dayToAssign,
          };
        } else if (dayType === "day7") {
          return {
            ...d,
            multipleShiftVisibility: "hideDropdown",
            day7: dayToAssign,
          };
        } else {
        }
      } else {
      }
      return d;
    });
    this.setState((curr: any) => ({ ...curr, tableData: newTableData }));
  };

  scheduleUserListHideOutside = (row: any, rowIndex: any, dayType: any) => {
    this.setState({ clickedDay: "" });
    let newTableData = [...this.state.tableData];
    newTableData = newTableData.map((d, index) => {
      let tempDay = { ...row[dayType][0] };
      tempDay.optionsItems = "showOptions";
      let tempArray: any = [];
      tempArray.push(tempDay);
      let dayToAssign = tempArray;
      if (index === rowIndex) {
        if (dayType === "day1") {
          return {
            ...d,
            day1: dayToAssign,
          };
        } else if (dayType === "day2") {
          return {
            ...d,
            day2: dayToAssign,
          };
        } else if (dayType === "day3") {
          return {
            ...d,
            day3: dayToAssign,
          };
        } else if (dayType === "day4") {
          return {
            ...d,
            day4: dayToAssign,
          };
        } else if (dayType === "day5") {
          return {
            ...d,
            day5: dayToAssign,
          };
        } else if (dayType === "day6") {
          return {
            ...d,
            day6: dayToAssign,
          };
        } else if (dayType === "day7") {
          return {
            ...d,
            day7: dayToAssign,
          };
        } else {
        }
      } else {
      }
      return d;
    });
    this.setState((curr: any) => ({ ...curr, tableData: newTableData }));
  };

  scrollHeaderOutsideClick = (schdeule: any, data: any, dayType: any) => {
    let { scrollUnassigned } = this.state;

    let indexOfDay =
      Number(dayType.slice(dayType.length - 1, dayType.length)) - 1;
    let dayValues = [...data.dayValues];
    let multipeIndex: any;
    if(schdeule === ""){
      // dayValues[multipeIndex].optionsItems = "showOptions";
      scrollUnassigned[indexOfDay].renderType = "showOptions";
      scrollUnassigned[indexOfDay].dropMPORWarning = "";
      scrollUnassigned[indexOfDay].dayValues = dayValues;
    }
    else{
    for (let i = 0; i < dayValues.length; i++) {
      if (Number(dayValues[i].uniqueno) === Number(schdeule.uniqueno)) {
        multipeIndex = i;
        break;
      }
    }
      dayValues[multipeIndex].optionsItems = "showOptions";
      scrollUnassigned[indexOfDay].renderType = "showOptions";
      scrollUnassigned[indexOfDay].dayValues = dayValues;
    }
    this.setState({ scrollUnassigned: scrollUnassigned });
    this.setState({ clickedDay: "" });
  };
  confiamtionModalBulkSelect = (item: any) => {
    confirmAlert({
      title: "Bulk Assign confirmation",
      message:
        "Performing this action may result in shifts moving to the Unassigned section. Are you sure you want to proceed?",
      buttons: [
        {
          label: "Yes",
          onClick: () => this.bulkSeclectOption(item, "Assigned"),
        },
        {
          label: "No",
          onClick: () => this.footerBulkClose(),
        },
      ],
      closeOnEscape: false,
      closeOnClickOutside: false,
    });
  };

  confimationModalBulkDelete = (mode) => {
    if (mode) {
      this.bulkSelectAssignDropdownHide();
      this.bulkSeclectOption("", "delete");
    } else {
      this.bulkSelectAssignDropdownHide();
    }
  };
  confimationModalBulkUnassign = (mode) => {
    if (mode) {
      this.bulkSelectAssignDropdownHide();
      this.bulkSeclectOption("", "Unassigned");
    } else {
      this.bulkSelectAssignDropdownHide();
    }
  };
  confimationModalBulkReassign = (mode) => {
    if (mode) {
      this.bulkSelectAssignDropdownShow()
      this.setState({
        viewReassignConfirmModal: false
      })
    } else {
      this.bulkSelectAssignDropdownHide();
    }
  };


  slectFromSingleSearch = (row: any, item: any) => {
    if (row.employeeName === "") {
      this.confiamtionModalBulkSelect(item.employee);
      return false;
    } else {
      this.employeeNameHideOutside();

      let requestArray: any = [];
      let requestObject = {} as ILaborScheduleReassignRemoveAllEmployeeShift;
      let storage = JSON.parse(localStorage.getItem("storage")!);
      let tenantID = storage === null ? 0 : (storage.tenantID as any);
      requestObject.tenantID = tenantID;
      requestObject.hotelID = this.props.mainParentState.hidValue;
      requestObject.WeekStartDate = this.props.mainViewState.navigationCalenderDates[0];
      requestObject.WeekEndDate = this.props.mainViewState.navigationCalenderDates[1];
      requestObject.reassignEmployeeFrom = row.employeeName;
      requestObject.reassignEmployeeTo = item.employee;
      requestObject.type = "reassignAllShifts";
      requestObject.sheduleType = this.props.mainViewState.scheduleView;
      requestObject.filterValue = this.props.row.posId.toString();

      requestArray.push(requestObject);

      LaborSchedule.ReAssignAllEmployeeShift(requestArray)
        .then(async (result: any | null) => {
          if (result != null && result.saveStatus === "Success") {
            this.getPosWiseScheduleData("reassignAllShifts");
            this.props.refreshMainDepartmentView("reassignAllShifts");
            this.props.isPublishChange(true);
            toast.success(result.message, {
              // // position: toast.POSITION.BOTTOM_RIGHT,
              // // containerId: "scheduleMain",
            });
          } else {
            Utils.toastError(result.message, {
              // // position: toast.POSITION.BOTTOM_RIGHT,
              // // containerId: "scheduleMain",
            });
          }
          resolve();
        })
        .catch((err: any) => {
          Utils.toastError(`Server Error, ${err}`, {
            // // position: toast.POSITION.BOTTOM_RIGHT,
            // // containerId: "scheduleMain",
          });
          reject();
        });
    }
  };

  reassingAllMPORAlertSubmit = (rowIndex, _employename, mode) => {
    if (mode) {
      this.showReassignAllModal(rowIndex);
    } else {
      this.employeeNameHideOutside();
    }
  };

  userRemoveFromSchedule = (row: any, mode: any) => {
    this.employeeNameHideOutside();
    if (mode) {
      let requestArray: any = [];
      let requestObject = {} as ILaborScheduleReassignRemoveAllEmployeeShift;
      let storage = JSON.parse(localStorage.getItem("storage")!);
      let tenantID = storage === null ? 0 : (storage.tenantID as any);
      requestObject.tenantID = tenantID;
      requestObject.hotelID = this.props.mainParentState.hidValue;
      requestObject.WeekStartDate = this.props.mainViewState.navigationCalenderDates[0];
      requestObject.WeekEndDate = this.props.mainViewState.navigationCalenderDates[1];
      requestObject.reassignEmployeeFrom = row.employeeName;
      requestObject.reassignEmployeeTo = row.employeeName;
      requestObject.type = "removeAllShifts";
      requestObject.sheduleType = this.props.mainViewState.scheduleView;
      requestObject.filterValue = this.props.row.posId.toString();
      requestArray.push(requestObject);
      LaborSchedule.RemoveAllEmployeeShift(requestArray)
        .then(async (result: any | null) => {
          if (result != null && result.saveStatus === "Success") {
            this.getPosWiseScheduleData("removeAllShifts");
            this.props.refreshMainDepartmentView("removeAllShifts");
            this.props.isPublishChange(true);
            toast.success(`${result.message}`, {
              // // position: toast.POSITION.BOTTOM_RIGHT,
              // // containerId: "scheduleMain",
            });
          } else {
            Utils.toastError(result.message, {
              // // position: toast.POSITION.BOTTOM_RIGHT,
              // // containerId: "scheduleMain",
            });
          }
          resolve();
        })
        .catch((err: any) => {
          Utils.toastError(`Server Error, ${err}`, {
            // // position: toast.POSITION.BOTTOM_RIGHT,
            // // containerId: "scheduleMain",
          });
          reject();
        });
    }
  };

  reassignShcedule = (
    schedule: any,
    row: any,
    rowIndex: any,
    dayType: any,
    shiftType: any,
    item: any
  ) => {
    if (shiftType === "singleShift") {
      this.scheduleUserListHideOutside(row, rowIndex, dayType);
    } else {
      this.multipleClickOutside(row, rowIndex, dayType, schedule);
    }

    let reassignRequest = {} as ILaborScheduleScheduleDragRequestDto;

    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    reassignRequest.tenantID = tenantID;
    reassignRequest.deptId = schedule.deptId;
    reassignRequest.positionId = schedule.positionId;
    reassignRequest.Uniqueno = schedule.uniqueno;
    reassignRequest.date = schedule.shiftDate;
    reassignRequest.inDate = schedule.indate;
    reassignRequest.outDate = schedule.outdate;
    reassignRequest.inTime = schedule.shiftInTime;
    reassignRequest.outTime = schedule.shiftOutTime;
    reassignRequest.isAssignedStatus = "Yes";
    reassignRequest.employeeName = row.employeeName;
    reassignRequest.hotelID = this.props.mainParentState.hidValue;
    reassignRequest.payPeriodStartDate = this.props.mainViewState.navigationCalenderDates[0];
    reassignRequest.entryType = "Schedule";
    reassignRequest.isAssignedShift = "Yes";
    reassignRequest.isPublishShift =
      schedule.shiftType === "published" ||
        schedule.shiftType === "hideShowPublished"
        ? "Yes"
        : "No";
    reassignRequest.offRepeat = "No";
    reassignRequest.ptoType = -1;
    reassignRequest.dropShiptEmployee = item.employee;
    reassignRequest.dropShiptDate = schedule.shiftDate;
    reassignRequest.viewType = this.props.mainViewState.scheduleView;
    let requestArray: any = [];
    requestArray.push(reassignRequest);

    LaborSchedule.SaveLaborScheduleDragAndDropDetails(requestArray)
      .then(async (result: any | null) => {
        if (result != null && result.saveStatus === "Success") {
          this.getPosWiseScheduleData("reasignSingleShift");
          this.props.refreshMainDepartmentView("reasignSingleShift");
          this.props.isPublishChange(true);
          let assignedValue: any = "reassigned";
          if (row.shiftType === "UnAssigned") {
            assignedValue = "assigned";
          }
          toast.success(`Shift ${assignedValue} to ${item.employee}`, {
            // // position: toast.POSITION.BOTTOM_RIGHT,
            // // containerId: "scheduleMain",
          });
        } else {
          if (result.messageCode === "NoShift") {
            this.getPosWiseScheduleData("noShift");
            this.props.refreshMainDepartmentView("noShift");
          }
          Utils.toastError(result.message, {
            // // position: toast.POSITION.BOTTOM_RIGHT,
            // // containerId: "scheduleMain",
          });
        }
        resolve();
      })
      .catch((err: any) => {
        Utils.toastError(`Server Error, ${err}`, {
          // // position: toast.POSITION.BOTTOM_RIGHT,
          // // containerId: "scheduleMain",
        });
        reject();
      });
  };

  reassignScheduleFromHeader = (schedule: any, item: any) => {
    let reassignRequest = {} as ILaborScheduleScheduleDragRequestDto;

    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    reassignRequest.tenantID = tenantID;
    reassignRequest.deptId = schedule.deptId;
    reassignRequest.positionId = schedule.positionId;
    reassignRequest.Uniqueno = schedule.uniqueno;
    reassignRequest.date = schedule.shiftDate;
    reassignRequest.inDate = schedule.indate;
    reassignRequest.outDate = schedule.outdate;
    reassignRequest.inTime = schedule.shiftInTime;
    reassignRequest.outTime = schedule.shiftOutTime;
    reassignRequest.isAssignedStatus = "Yes";
    reassignRequest.employeeName = "Unassigned";
    reassignRequest.hotelID = this.props.mainParentState.hidValue;
    reassignRequest.payPeriodStartDate = this.props.mainViewState.navigationCalenderDates[0];
    reassignRequest.entryType = "Schedule";
    reassignRequest.isAssignedShift = "Yes";
    reassignRequest.isPublishShift =
      schedule.shiftType === "published" ||
        schedule.shiftType === "hideShowPublished"
        ? "Yes"
        : "No";
    reassignRequest.offRepeat = "No";
    reassignRequest.ptoType = -1;
    reassignRequest.dropShiptEmployee = item.employee;
    reassignRequest.dropShiptDate = schedule.shiftDate;
    reassignRequest.viewType = this.props.mainViewState.scheduleView;

    let requestArray: any = [];
    requestArray.push(reassignRequest);

    LaborSchedule.SaveLaborScheduleDragAndDropDetails(requestArray)
      .then(async (result: any | null) => {
        if (result != null && result.saveStatus === "Success") {
          this.getPosWiseScheduleData("reasignSingleShift");
          this.props.refreshMainDepartmentView("reasignSingleShift");
          this.props.isPublishChange(true);
          toast.success(`Shift assigned to ${item.employee}`, {
            // // position: toast.POSITION.BOTTOM_RIGHT,
            // // containerId: "scheduleMain",
          });
        } else {
          if (result.messageCode === "NoShift") {
            this.getPosWiseScheduleData("noShift");
            this.props.refreshMainDepartmentView("noShift");
          }
          Utils.toastError(result.message, {
            // // position: toast.POSITION.BOTTOM_RIGHT,
            // // containerId: "scheduleMain",
          });
        }
        resolve();
      })
      .catch((err: any) => {
        Utils.toastError(`Server Error, ${err}`, {
          // // position: toast.POSITION.BOTTOM_RIGHT,
          // // containerId: "scheduleMain",
        });
        reject();
      });
  };


  moprAlertSubmit = (
    schedule: any,
    dayType: any,
    row: any,
    rowIndex: any,
    shiftType: any,
    warningSubmit : any,
    mode: any
  ) => {
    let dateCompareResult = this.getDateComparison(schedule);
    if (mode) {
      if(warningSubmit === 'reassignWarningSubmit'){
        this.cellReassignShow(
          schedule,
          row,
          rowIndex,
          dayType,
          shiftType,
          dateCompareResult
          );
        } else if(warningSubmit === 'editWarningSubmit'){
          this.cellEditModalShow(
            schedule,
            row,
            dayType,
            shiftType,
            shiftType,
            )
            if (shiftType === "multipleShift") {
              this.multipleClickOutside(row, rowIndex, dayType, schedule);
            } else {
              this.scheduleUserListHideOutside(row, rowIndex, dayType);
            }
        } else {
          if (shiftType === "multipleShift") {
            this.multipleClickOutside(row, rowIndex, dayType, schedule);
          } else {
            this.scheduleUserListHideOutside(row, rowIndex, dayType);
          }
          this.onDropWarningSubmit(schedule, row,rowIndex, dayType, shiftType);
        }
    } else {
      if (shiftType === "multipleShift") {
        this.multipleClickOutside(row, rowIndex, dayType, schedule);
      } else {
        this.scheduleUserListHideOutside(row, rowIndex, dayType);
      }
    }
  };


  deleteSchedule = (
    schedule: any,
    dayType: any,
    row: any,
    rowIndex: any,
    shiftType: any,
    mode: any
  ) => {
    if (shiftType === "singleShift") {
      this.scheduleUserListHideOutside(row, rowIndex, dayType);
    } else {
      this.multipleClickOutside(row, rowIndex, dayType, schedule);
    }
    if (mode) {
      let requestArray: any = [];
      let requestObject = {} as ILaborScheduleDeleteSchedule;
      let storage = JSON.parse(localStorage.getItem("storage")!);
      let tenantID = storage === null ? 0 : (storage.tenantID as any);
      requestObject.tenantID = tenantID;
      requestObject.hotelID = this.props.mainParentState.hidValue;
      requestObject.shiftDate = schedule.shiftDate;
      requestObject.shiftEmployee = row.employeeName;
      requestObject.indate = schedule.indate;
      requestObject.outdate = schedule.outdate;
      requestObject.shiftInTime = schedule.shiftInTime;
      requestObject.shiftOutTime = schedule.shiftOutTime;
      requestObject.uniqueno = schedule.uniqueno;
      requestObject.WeekStartDate = this.props.mainViewState.navigationCalenderDates[0];
      requestObject.WeekEndDate = this.props.mainViewState.navigationCalenderDates[1];
      requestObject.deptID = schedule.deptId;
      requestObject.positionid = schedule.positionId;

      requestArray.push(requestObject);
      LaborSchedule.DeleteSchedule(requestArray)
        .then(async (result: any | null) => {
          if (result != null && result.saveStatus === "Success") {
            this.getPosWiseScheduleData("deleteShifts");
// <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<AUTO GENERATED BY CONFLICT EXTENSION<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< TestingUI

// ====================================AUTO GENERATED BY CONFLICT EXTENSION====================================
            // if (schedule.shiftType !== "unassigned") {
            //   this.props.isPublishChange(true);
            // }
// >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>AUTO GENERATED BY CONFLICT EXTENSION>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> Feature-T1-#1851
            if (schedule.shiftType !== "unassigned") {
              this.props.isPublishChange(true);
            }
            // this.props.isPublishChange(true);
            this.props.refreshMainDepartmentView("deleteShifts");
            toast.success("Schedule Deleted successfully", {
              // // position: toast.POSITION.BOTTOM_RIGHT,
              // // containerId: "scheduleMain",
            });
          } else {
            if (result.messageCode === "NoShift") {
              this.getPosWiseScheduleData("noShift");
              this.props.refreshMainDepartmentView("noShift");
            }
            Utils.toastError(result.message, {
              // // position: toast.POSITION.BOTTOM_RIGHT,
              // // containerId: "scheduleMain",
            });
          }
          resolve();
        })
        .catch((err: any) => {
          Utils.toastError(`Server Error, ${err}`, {
            // // position: toast.POSITION.BOTTOM_RIGHT,
            // // containerId: "scheduleMain",
          });
          reject();
        });
    }
  };

  scheduleDeleteFromScrollHeader = (schdeule: any, data: any, mode: any) => {
    this.scrollHeaderOutsideClick(schdeule, data, data.dayName);
    if (mode) {
      let requestArray: any = [];
      let requestObject = {} as ILaborScheduleDeleteSchedule;
      let storage = JSON.parse(localStorage.getItem("storage")!);
      let tenantID = storage === null ? 0 : (storage.tenantID as any);
      requestObject.tenantID = tenantID;
      requestObject.hotelID = this.props.mainParentState.hidValue;
      requestObject.shiftDate = schdeule.shiftDate;
      requestObject.shiftEmployee = "Unassigned";
      requestObject.indate = schdeule.indate;
      requestObject.outdate = schdeule.outdate;
      requestObject.shiftInTime = schdeule.shiftInTime;
      requestObject.shiftOutTime = schdeule.shiftOutTime;
      requestObject.uniqueno = schdeule.uniqueno;
      requestObject.WeekStartDate = this.props.mainViewState.navigationCalenderDates[0];
      requestObject.WeekEndDate = this.props.mainViewState.navigationCalenderDates[1];
      requestObject.deptID = schdeule.deptId;
      requestObject.positionid = schdeule.positionId;

      requestArray.push(requestObject);
      LaborSchedule.DeleteSchedule(requestArray)
        .then(async (result: any | null) => {
          if (result != null && result.saveStatus === "Success") {
            this.props.isPublishChange(true);
            this.getPosWiseScheduleData("deleteShifts");
            this.props.refreshMainDepartmentView("deleteShifts");
            toast.success("Schedule Deleted successfully", {
              // // position: toast.POSITION.BOTTOM_RIGHT,
              // // containerId: "scheduleMain",
            });
          } else {
            if (result.messageCode === "NoShift") {
              this.getPosWiseScheduleData("noShift");
              this.props.refreshMainDepartmentView("noShift");
            }
            Utils.toastError(result.message, {
              // // position: toast.POSITION.BOTTOM_RIGHT,
              // // containerId: "scheduleMain",
            });
          }
          resolve();
        })
        .catch((err: any) => {
          Utils.toastError(`Server Error, ${err}`, {
            // // position: toast.POSITION.BOTTOM_RIGHT,
            // // containerId: "scheduleMain",
          });
          reject();
        });
    }
  };

  getDateComparison = (schdeule) => {
    let currentOffSet = schConversions.GetUTCTime(
      Number(this.state.offSetHour)
    );
    debugger;
    let currentDate = this.state.currentDate;
    let dateDay: any = currentDate.getDate();
    let mnth: any = currentDate.getMonth() + 1;
    let nyear: any = currentDate.getFullYear();
    let nhrs: any = currentOffSet.getHours();
    let nminut: any = currentOffSet.getMinutes();
    let ndate: any =
    mnth + "/" + dateDay + "/" + nyear + " " + nhrs + ":" + nminut;
  let dtnew: any = new Date(ndate);
    let scheduleCurrentDate = new Date(schdeule.outdate);
    return dtnew > scheduleCurrentDate;
  };


  showMOPRAssignAlert = (
    schdeule: any,
    row: any,
    rowIndex: any,
    dayType: any,
    type: any,
    dateCompareResult: any
  ) => {
    if (
      dateCompareResult &&
      row.shiftType !== "UnAssigned" &&
      type !== "scrollHeader"
    ) {
      Utils.toastError("Schedule can only be reassigned for a future time", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "scheduleMain",
      });
    } else {
      // if (type === "scrollHeader") {
      //   this.changeInScrollData("reassign", schdeule, row, dayType);
      // }
      //  else
      if (type === "multipleShift") {
        let newTableData = [...this.state.tableData];
        newTableData = newTableData.map((d, index) => {
          if (index === rowIndex) {
            let tempRow = [...row[dayType]];
            let multipeIndex: any;
            for (let i = 0; i < tempRow.length; i++) {
              if (Number(tempRow[i].uniqueno) === Number(schdeule.uniqueno)) {
                multipeIndex = i;
                break;
              }
            }
            let tempDay = { ...row[dayType][multipeIndex] };
            tempDay.optionsItems = "mporAlert";
            tempRow[multipeIndex] = tempDay;
            let dayToAssign = tempRow;
            if (dayType === "day1") {
              return {
                ...d,
                multipleShiftVisibility: "parentMporAlert",
                day1: dayToAssign,
              };
            } else if (dayType === "day2") {
              return {
                ...d,
                multipleShiftVisibility: "parentMporAlert",
                day2: dayToAssign,
              };
            } else if (dayType === "day3") {
              return {
                ...d,
                multipleShiftVisibility: "parentMporAlert",
                day3: dayToAssign,
              };
            } else if (dayType === "day4") {
              return {
                ...d,
                multipleShiftVisibility: "parentMporAlert",
                day4: dayToAssign,
              };
            } else if (dayType === "day5") {
              return {
                ...d,
                multipleShiftVisibility: "parentMporAlert",
                day5: dayToAssign,
              };
            } else if (dayType === "day6") {
              return {
                ...d,
                multipleShiftVisibility: "parentMporAlert",
                day6: dayToAssign,
              };
            } else if (dayType === "day7") {
              return {
                ...d,
                multipleShiftVisibility: "parentMporAlert",
                day7: dayToAssign,
              };
            } else {
            }
          } else {
          }
          return d;
        });
        this.setState((curr: any) => ({ ...curr, tableData: newTableData }));
      } else {
        let newTableData = [...this.state.tableData];
        newTableData = newTableData.map((d, index) => {
          if (index === rowIndex) {
            // 
            let tempDay = { ...row[dayType][0] };
            tempDay.optionsItems = "mporAlert";
            let tempArray: any = [];
            tempArray.push(tempDay);
            let dayToAssign = tempArray;
            if (dayType === "day1") {
              return {
                ...d,
                day1: dayToAssign,
              };
            } else if (dayType === "day2") {
              return {
                ...d,
                day2: dayToAssign,
              };
            } else if (dayType === "day3") {
              return {
                ...d,
                day3: dayToAssign,
              };
            } else if (dayType === "day4") {
              return {
                ...d,
                day4: dayToAssign,
              };
            } else if (dayType === "day5") {
              return {
                ...d,
                day5: dayToAssign,
              };
            } else if (dayType === "day6") {
              return {
                ...d,
                day6: dayToAssign,
              };
            } else if (dayType === "day7") {
              return {
                ...d,
                day7: dayToAssign,
              };
            } else {
            }
          } else {
          }
          return d;
        });
        this.setState((curr: any) => ({ ...curr, tableData: newTableData }));
      }
    }
  };

  cellEditModalShow = (
    schdeule: any,
    row: any,
    dayType: any,
    type: any,
    shiftType:any
  )=>{
    // 
     // let scheduleCurrentDate = new Date(schdeule.outdate);
    // let dateCompareResult = currentOffSet > scheduleCurrentDate;
    let dateCompareResult = this.getDateComparison(schdeule);

    if (
      false &&
      row.shiftType !== "UnAssigned" &&
      type !== "scrollHeader"
    ) {
      Utils.toastError("Schedule can only be edited for a future time", {
// <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<AUTO GENERATED BY CONFLICT EXTENSION<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< TestingUI
          // // position: toast.POSITION.BOTTOM_RIGHT,
          // // containerId: "scheduleMain",
// ====================================AUTO GENERATED BY CONFLICT EXTENSION====================================
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "scheduleMain",
// >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>AUTO GENERATED BY CONFLICT EXTENSION>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> Feature-T1-#1851
      });
    } else {
      
      // let scheduleInDate = new Date(schdeule.indate);
      // let nonEditableResult = currentOffSet > scheduleInDate;
       // let scheduleCurrentDate = new Date(schdeule.outdate);
    // let dateCompareResult = currentOffSet > scheduleCurrentDate;
    let nonEditableResult = this.getDateComparison(schdeule);

      let nonEditableProp = "canEdit";
      // if (nonEditableResult) {
      //   nonEditableProp = "canNotEdit";
      // }
      if (schdeule.actualPunches === "Yes") {
        nonEditableProp = "canNotEdit";
      }

      this.props.openAddEditForm(
        "edit",
        schdeule,
        shiftType,
        row,
        dayType,
        nonEditableProp
      );
  }
}

  cellReassignShow = (
    schdeule: any,
    row: any,
    rowIndex: any,
    dayType: any,
    type: any,
    dateCompareResult: any
  ) => {
    if (
      dateCompareResult &&
      row.shiftType !== "UnAssigned" &&
      type !== "scrollHeader"
    ) {
      Utils.toastError("Schedule can only be reassigned for a future time", {
// <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<AUTO GENERATED BY CONFLICT EXTENSION<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< TestingUI
          // // position: toast.POSITION.BOTTOM_RIGHT,
          // // containerId: "scheduleMain",
// ====================================AUTO GENERATED BY CONFLICT EXTENSION====================================
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "scheduleMain",
// >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>AUTO GENERATED BY CONFLICT EXTENSION>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> Feature-T1-#1851
      });
    } else {
      if (type === "scrollHeader") {
        this.changeInScrollData("reassign", schdeule, row, dayType);
      } else if (type === "multipleShift") {
        let newTableData = [...this.state.tableData];
        newTableData = newTableData.map((d, index) => {
          if (index === rowIndex) {
            let tempRow = [...row[dayType]];
            let multipeIndex: any;
            for (let i = 0; i < tempRow.length; i++) {
              if (Number(tempRow[i].uniqueno) === Number(schdeule.uniqueno)) {
                multipeIndex = i;
                break;
              }
            }
            let tempDay = { ...row[dayType][multipeIndex] };
            tempDay.optionsItems = "reassignUserList";
            tempRow[multipeIndex] = tempDay;
            let dayToAssign = tempRow;
            if (dayType === "day1") {
              return {
                ...d,
                multipleShiftVisibility: "ReassignDropdown",
                day1: dayToAssign,
              };
            } else if (dayType === "day2") {
              return {
                ...d,
                multipleShiftVisibility: "ReassignDropdown",
                day2: dayToAssign,
              };
            } else if (dayType === "day3") {
              return {
                ...d,
                multipleShiftVisibility: "ReassignDropdown",
                day3: dayToAssign,
              };
            } else if (dayType === "day4") {
              return {
                ...d,
                multipleShiftVisibility: "ReassignDropdown",
                day4: dayToAssign,
              };
            } else if (dayType === "day5") {
              return {
                ...d,
                multipleShiftVisibility: "ReassignDropdown",
                day5: dayToAssign,
              };
            } else if (dayType === "day6") {
              return {
                ...d,
                multipleShiftVisibility: "ReassignDropdown",
                day6: dayToAssign,
              };
            } else if (dayType === "day7") {
              return {
                ...d,
                multipleShiftVisibility: "ReassignDropdown",
                day7: dayToAssign,
              };
            } else {
            }
          } else {
          }
          return d;
        });
        this.setState((curr: any) => ({ ...curr, tableData: newTableData }));
      } else {
        let newTableData = [...this.state.tableData];
        newTableData = newTableData.map((d, index) => {
          if (index === rowIndex) {
            let tempDay = { ...row[dayType][0] };
            tempDay.optionsItems = "reassignUserList";
            let tempArray: any = [];
            tempArray.push(tempDay);
            let dayToAssign = tempArray;
            if (dayType === "day1") {
              return {
                ...d,
                day1: dayToAssign,
              };
            } else if (dayType === "day2") {
              return {
                ...d,
                day2: dayToAssign,
              };
            } else if (dayType === "day3") {
              return {
                ...d,
                day3: dayToAssign,
              };
            } else if (dayType === "day4") {
              return {
                ...d,
                day4: dayToAssign,
              };
            } else if (dayType === "day5") {
              return {
                ...d,
                day5: dayToAssign,
              };
            } else if (dayType === "day6") {
              return {
                ...d,
                day6: dayToAssign,
              };
            } else if (dayType === "day7") {
              return {
                ...d,
                day7: dayToAssign,
              };
            } else {
            }
          } else {
          }
          return d;
        });
        this.setState((curr: any) => ({ ...curr, tableData: newTableData }));
      }
    }
  };

  cellDropdownSelection = (
    item: any,
    schdeule: any,
    shiftType: any,
    row: any,
    rowIndex: any,
    dayType: any,
    type: any
  ) => {
    
    this.setState({ clickedDay: dayType });
    // let currentOffSet = schConversions.GetUTCTime(
    //   Number(this.props.mainViewState.offSetHour)
    // );
    // let scheduleCurrentDate = new Date(schdeule.outdate);
    // let dateCompareResult = currentOffSet > scheduleCurrentDate;
    let dateCompareResult = this.getDateComparison(schdeule);

    if (item === "Bulk Select") {
      this.optionBulkSelect();
    } else if (item === "Add") {
      this.props.openAddEditForm(
        "add",
        schdeule,
        shiftType,
        row,
        dayType,
        "canEdit"
      );
    } else if (item === "Edit") {
      if (false) {
        Utils.toastError("Schedule can only be edited for a future time", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "scheduleMain",
        });
      } else {
          if(type === "singleShift"){
      if(scheduleComponents.checkMporAlert(row, schdeule)){
        let newTableData = [...this.state.tableData];
        newTableData = newTableData.map((d, index) => {
          if (index === rowIndex) {
            let tempDay = { ...row[dayType][0] };
            tempDay.optionsItems = "editMPORAlert";
            let tempArray: any = [];
            tempArray.push(tempDay);
            let dayToAssign = tempArray;
            if (dayType === "day1") {
              return {
                ...d,
                day1: dayToAssign,
              };
            } else if (dayType === "day2") {
              return {
                ...d,
                day2: dayToAssign,
              };
            } else if (dayType === "day3") {
              return {
                ...d,
                day3: dayToAssign,
              };
            } else if (dayType === "day4") {
              return {
                ...d,
                day4: dayToAssign,
              };
            } else if (dayType === "day5") {
              return {
                ...d,
                day5: dayToAssign,
              };
            } else if (dayType === "day6") {
              return {
                ...d,
                day6: dayToAssign,
              };
            } else if (dayType === "day7") {
              return {
                ...d,
                day7: dayToAssign,
              };
            } else {
            }
          } else {
          }
          return d;
        });
        this.setState((curr: any) => ({ ...curr, tableData: newTableData }))
       }else{
         this.cellEditModalShow(
           schdeule,
          row,
          dayType,
          type,
          shiftType)
       }
      } else {
        
        if (scheduleComponents.checkMporAlert(row, schdeule)) {
          let newTableData = [...this.state.tableData];
            newTableData = newTableData.map((d, index) => {
              if (index === rowIndex) {
                let tempRow = [...row[dayType]];
                let multipeIndex: any;
                for (let i = 0; i < tempRow.length; i++) {
                  if (Number(tempRow[i].uniqueno) === Number(schdeule.uniqueno)) {
                    multipeIndex = i;
                    break;
                  }
                }
                let tempDay = { ...row[dayType][multipeIndex] };
                tempDay.optionsItems = "editMPORAlert";
                tempRow[multipeIndex] = tempDay;
                let dayToAssign = tempRow;
                if (dayType === "day1") {
                  return {
                    ...d,
                    multipleShiftVisibility: "editwarning",
                    day1: dayToAssign,
                  };
                } else if (dayType === "day2") {
                  return {
                    ...d,
                    multipleShiftVisibility: "editwarning",
                    day2: dayToAssign,
                  };
                } else if (dayType === "day3") {
                  return {
                    ...d,
                    multipleShiftVisibility: "editwarning",
                    day3: dayToAssign,
                  };
                } else if (dayType === "day4") {
                  return {
                    ...d,
                    multipleShiftVisibility: "editwarning",
                    day4: dayToAssign,
                  };
                } else if (dayType === "day5") {
                  return {
                    ...d,
                    multipleShiftVisibility: "editwarning",
                    day5: dayToAssign,
                  };
                } else if (dayType === "day6") {
                  return {
                    ...d,
                    multipleShiftVisibility: "editwarning",
                    day6: dayToAssign,
                  };
                } else if (dayType === "day7") {
                  return {
                    ...d,
                    multipleShiftVisibility: "editwarning",
                    day7: dayToAssign,
                  };
                } else {
                }
              } else {
              }
              return d;
            });
            this.setState((curr: any) => ({ ...curr, tableData: newTableData }));

        }else{
          this.cellEditModalShow(schdeule, row, dayType, type, shiftType);
        }
  }}
      // if (
      //   dateCompareResult &&
      //   row.shiftType !== "UnAssigned" &&
      //   type !== "scrollHeader"
      // ) {
      //   Utils.toastError("Schedule can only be edited for a future time", {
      //     position: toast.POSITION.BOTTOM_RIGHT,
      //     containerId: "scheduleMain",
      //   });
      // } else {
      //   let scheduleInDate = new Date(schdeule.indate);
      //   let nonEditableResult = currentOffSet > scheduleInDate;
      //   let nonEditableProp = "canEdit";
      //   if (nonEditableResult) {
      //     nonEditableProp = "canNotEdit";
      //   }
      //   if (schdeule.actualPunches === "Yes") {
      //     nonEditableProp = "canNotEdit";
      //   }
      //   this.props.openAddEditForm(
      //     "edit",
      //     schdeule,
      //     shiftType,
      //     row,
      //     dayType,
      //     nonEditableProp
      //   );
      // }
    } else if (item === "Reassign") {
      // if (
      //   dateCompareResult &&
      //   row.shiftType !== "UnAssigned" &&
      //   type !== "scrollHeader"
      // ) {
      //   Utils.toastError("Schedule can only be reassigned for a future time", {
      //     position: toast.POSITION.BOTTOM_RIGHT,
      //     containerId: "scheduleMain",
      //   });

      if (scheduleComponents.checkMporAlert(row, schdeule)) {
        this.showMOPRAssignAlert(
          schdeule,
          row,
          rowIndex,
          dayType,
          type,
          dateCompareResult
        );
      } else {
        this.cellReassignShow(
          schdeule,
          row,
          rowIndex,
          dayType,
          type,
          dateCompareResult
        );
       }
      




      // } else {
      //   if (type === "scrollHeader") {
      //     this.changeInScrollData("reassign", schdeule, row, dayType);
      //   } else if (type === "multipleShift") {
      //     let newTableData = [...this.state.tableData];
      //     newTableData = newTableData.map((d, index) => {
      //       if (index === rowIndex) {
      //         let tempRow = [...row[dayType]];
      //         let multipeIndex: any;
      //         for (let i = 0; i < tempRow.length; i++) {
      //           if (Number(tempRow[i].uniqueno) === Number(schdeule.uniqueno)) {
      //             multipeIndex = i;
      //             break;
      //           }
      //         }
      //         let tempDay = { ...row[dayType][multipeIndex] };
      //         tempDay.optionsItems = "reassignUserList";
      //         tempRow[multipeIndex] = tempDay;
      //         let dayToAssign = tempRow;
      //         if (dayType === "day1") {
      //           return {
      //             ...d,
      //             multipleShiftVisibility: "ReassignDropdown",
      //             day1: dayToAssign,
      //           };
      //         } else if (dayType === "day2") {
      //           return {
      //             ...d,
      //             multipleShiftVisibility: "ReassignDropdown",
      //             day2: dayToAssign,
      //           };
      //         } else if (dayType === "day3") {
      //           return {
      //             ...d,
      //             multipleShiftVisibility: "ReassignDropdown",
      //             day3: dayToAssign,
      //           };
      //         } else if (dayType === "day4") {
      //           return {
      //             ...d,
      //             multipleShiftVisibility: "ReassignDropdown",
      //             day4: dayToAssign,
      //           };
      //         } else if (dayType === "day5") {
      //           return {
      //             ...d,
      //             multipleShiftVisibility: "ReassignDropdown",
      //             day5: dayToAssign,
      //           };
      //         } else if (dayType === "day6") {
      //           return {
      //             ...d,
      //             multipleShiftVisibility: "ReassignDropdown",
      //             day6: dayToAssign,
      //           };
      //         } else if (dayType === "day7") {
      //           return {
      //             ...d,
      //             multipleShiftVisibility: "ReassignDropdown",
      //             day7: dayToAssign,
      //           };
      //         } else {
      //         }
      //       } else {
      //       }
      //       return d;
      //     });
      //     this.setState((curr: any) => ({ ...curr, tableData: newTableData }));
      //   } else {
      //     let newTableData = [...this.state.tableData];
      //     newTableData = newTableData.map((d, index) => {
      //       if (index === rowIndex) {
      //         let tempDay = { ...row[dayType][0] };
      //         tempDay.optionsItems = "reassignUserList";
      //         let tempArray: any = [];
      //         tempArray.push(tempDay);
      //         let dayToAssign = tempArray;
      //         if (dayType === "day1") {
      //           return {
      //             ...d,
      //             day1: dayToAssign,
      //           };
      //         } else if (dayType === "day2") {
      //           return {
      //             ...d,
      //             day2: dayToAssign,
      //           };
      //         } else if (dayType === "day3") {
      //           return {
      //             ...d,
      //             day3: dayToAssign,
      //           };
      //         } else if (dayType === "day4") {
      //           return {
      //             ...d,
      //             day4: dayToAssign,
      //           };
      //         } else if (dayType === "day5") {
      //           return {
      //             ...d,
      //             day5: dayToAssign,
      //           };
      //         } else if (dayType === "day6") {
      //           return {
      //             ...d,
      //             day6: dayToAssign,
      //           };
      //         } else if (dayType === "day7") {
      //           return {
      //             ...d,
      //             day7: dayToAssign,
      //           };
      //         } else {
      //         }
      //       } else {
      //       }
      //       return d;
      //     });
      //     this.setState((curr: any) => ({ ...curr, tableData: newTableData }));
      //   }
      //}
    }  else if (item === "Duplicate") {
      
          let result = Schedule.createDuplicateShift(
            schdeule,
            row,
            rowIndex,
            dayType,
            type,
            this.props.mainViewState.navigationCalenderDates,
            this.props.mainParentState
          );
          result.then(async (res) => {
            let resp = await res;
            if(resp != null && resp.saveStatus === "Success"){
              toast.success("Schedule saved successfully",{
                position:toast.POSITION.BOTTOM_RIGHT
              })
              
              this.getPosWiseScheduleData("addShiftRefresh");
            } else {
              Utils.toastError(resp.message, {
                position: toast.POSITION.BOTTOM_RIGHT,
                // // containerId: cntrId,
              });
            }
            resolve();
          }).catch((err: any) => {
            Utils.toastError(`Server Error, ${err}`, {
              position: toast.POSITION.BOTTOM_RIGHT,
              // // containerId: cntrId,
            });
            reject();
          });
        }
    else if (item === "Delete") {
      if (schdeule.actualPunches === "Yes") {
        Utils.toastError("Actual punches added for the employee shift, Schedule can not be deleted.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "scheduleMain",
        });
      } else {
        if (type === "scrollHeader") {
          this.changeInScrollData("delete", schdeule, row, dayType);
        } else if (type === "multipleShift") {
          let newTableData = [...this.state.tableData];
          newTableData = newTableData.map((d, index) => {
            if (index === rowIndex) {
              let tempRow = [...row[dayType]];
              let multipeIndex: any;
              for (let i = 0; i < tempRow.length; i++) {
                if (Number(tempRow[i].uniqueno) === Number(schdeule.uniqueno)) {
                  multipeIndex = i;
                  break;
                }
              }
              let tempDay = { ...row[dayType][multipeIndex] };
              tempDay.optionsItems = "deleteScheduleModal";
              tempRow[multipeIndex] = tempDay;
              let dayToAssign = tempRow;
              if (dayType === "day1") {
                return {
                  ...d,
                  multipleShiftVisibility: "DeleteDropdown",
                  day1: dayToAssign,
                };
              } else if (dayType === "day2") {
                return {
                  ...d,
                  multipleShiftVisibility: "DeleteDropdown",
                  day2: dayToAssign,
                };
              } else if (dayType === "day3") {
                return {
                  ...d,
                  multipleShiftVisibility: "DeleteDropdown",
                  day3: dayToAssign,
                };
              } else if (dayType === "day4") {
                return {
                  ...d,
                  multipleShiftVisibility: "DeleteDropdown",
                  day4: dayToAssign,
                };
              } else if (dayType === "day5") {
                return {
                  ...d,
                  multipleShiftVisibility: "DeleteDropdown",
                  day5: dayToAssign,
                };
              } else if (dayType === "day6") {
                return {
                  ...d,
                  multipleShiftVisibility: "DeleteDropdown",
                  day6: dayToAssign,
                };
              } else if (dayType === "day7") {
                return {
                  ...d,
                  multipleShiftVisibility: "DeleteDropdown",
                  day7: dayToAssign,
                };
              } else {
              }
            } else {
            }
            return d;
          });
          this.setState((curr: any) => ({ ...curr, tableData: newTableData }));
        } else {
          let newTableData = [...this.state.tableData];
          newTableData = newTableData.map((d, index) => {
            if (index === rowIndex) {
              let tempDay = { ...row[dayType][0] };
              tempDay.optionsItems = "deleteScheduleModal";
              let tempArray: any = [];
              tempArray.push(tempDay);
              let dayToAssign = tempArray;
              if (dayType === "day1") {
                return {
                  ...d,
                  day1: dayToAssign,
                };
              } else if (dayType === "day2") {
                return {
                  ...d,
                  day2: dayToAssign,
                };
              } else if (dayType === "day3") {
                return {
                  ...d,
                  day3: dayToAssign,
                };
              } else if (dayType === "day4") {
                return {
                  ...d,
                  day4: dayToAssign,
                };
              } else if (dayType === "day5") {
                return {
                  ...d,
                  day5: dayToAssign,
                };
              } else if (dayType === "day6") {
                return {
                  ...d,
                  day6: dayToAssign,
                };
              } else if (dayType === "day7") {
                return {
                  ...d,
                  day7: dayToAssign,
                };
              } else {
              }
            } else {
            }
            return d;
          });
          this.setState((curr: any) => ({ ...curr, tableData: newTableData }));
        }
      }
    } else if (item === "Change Log") {

      this.props.showHideChangeLogModal(schdeule.uniqueno, schdeule?.shiftDate);
    }
  };

  singleBulkSelect = (
    e: any,
    row: any,
    rowIndex: any,
    dayType: any,
    shiftType: any,
    schedule: any
  ) => {
    let currentStatus = this.state.bulkSelctShiftsCount;
    let tempScheduleArray = [...this.state.bulkSelectShiftArray];
    if (e.target.checked) {
      currentStatus = currentStatus + 1;
      let tempSchedule = { ...schedule };
      tempSchedule.employeeName = row.employeeName;
      tempScheduleArray.push(tempSchedule);

      if (shiftType === "multipleShift") {
        let newTableData = [...this.state.tableData];
        newTableData = newTableData.map((d, index) => {
          if (index === rowIndex) {
            let tempRow = [...row[dayType]];
            let multipeIndex: any;
            for (let i = 0; i < tempRow.length; i++) {
              if (Number(tempRow[i].uniqueno) === Number(schedule.uniqueno)) {
                multipeIndex = i;
                break;
              }
            }

            let tempDay = { ...row[dayType][multipeIndex] };
            tempDay.shiftbulkSelect = true;
            tempRow[multipeIndex] = tempDay;
            let dayToAssign = tempRow;

            if (dayType === "day1") {
              return {
                ...d,
                day1: dayToAssign,
              };
            } else if (dayType === "day2") {
              return {
                ...d,
                day2: dayToAssign,
              };
            } else if (dayType === "day3") {
              return {
                ...d,
                day3: dayToAssign,
              };
            } else if (dayType === "day4") {
              return {
                ...d,
                day4: dayToAssign,
              };
            } else if (dayType === "day5") {
              return {
                ...d,
                day5: dayToAssign,
              };
            } else if (dayType === "day6") {
              return {
                ...d,
                day6: dayToAssign,
              };
            } else if (dayType === "day7") {
              return {
                ...d,
                day7: dayToAssign,
              };
            } else {
            }
          } else {
          }
          return d;
        });
        this.setState(
          (curr: any) => ({ ...curr, tableData: newTableData }),
          () => {
            this.getScrollData();
          }
        );
      } else {
        let newTableData = [...this.state.tableData];
        newTableData = newTableData.map((d, index) => {
          if (index === rowIndex) {
            let tempDay = { ...row[dayType][0] };
            tempDay.shiftbulkSelect = true;
            let tempArray: any = [];
            tempArray.push(tempDay);
            let dayToAssign = tempArray;
            if (dayType === "day1") {
              return {
                ...d,
                day1: dayToAssign,
              };
            } else if (dayType === "day2") {
              return {
                ...d,
                day2: dayToAssign,
              };
            } else if (dayType === "day3") {
              return {
                ...d,
                day3: dayToAssign,
              };
            } else if (dayType === "day4") {
              return {
                ...d,
                day4: dayToAssign,
              };
            } else if (dayType === "day5") {
              return {
                ...d,
                day5: dayToAssign,
              };
            } else if (dayType === "day6") {
              return {
                ...d,
                day6: dayToAssign,
              };
            } else if (dayType === "day7") {
              return {
                ...d,
                day7: dayToAssign,
              };
            } else {
            }
          } else {
          }
          return d;
        });
        this.setState(
          (curr: any) => ({ ...curr, tableData: newTableData }),
          () => {
            this.getScrollData();
          }
        );
      }
    } else {
      let removalIndex: any = -1;

      for (let i = 0; i < tempScheduleArray.length; i++) {
        if (schedule.uniqueno === tempScheduleArray[i].uniqueno) {
          removalIndex = i;
          break;
        }
      }

      if (removalIndex > -1) {
        tempScheduleArray.splice(removalIndex, 1);
        currentStatus = currentStatus - 1;
      }

      if (shiftType === "multipleShift") {
        let newTableData = [...this.state.tableData];
        newTableData = newTableData.map((d, index) => {
          if (index === rowIndex) {
            let tempRow = [...row[dayType]];
            let multipeIndex: any;
            for (let i = 0; i < tempRow.length; i++) {
              if (Number(tempRow[i].uniqueno) === Number(schedule.uniqueno)) {
                multipeIndex = i;
                break;
              }
            }
            let tempDay = { ...row[dayType][multipeIndex] };
            tempDay.shiftbulkSelect = false;
            tempRow[multipeIndex] = tempDay;
            let dayToAssign = tempRow;

            if (dayType === "day1") {
              return {
                ...d,
                day1: dayToAssign,
              };
            } else if (dayType === "day2") {
              return {
                ...d,
                day2: dayToAssign,
              };
            } else if (dayType === "day3") {
              return {
                ...d,
                day3: dayToAssign,
              };
            } else if (dayType === "day4") {
              return {
                ...d,
                day4: dayToAssign,
              };
            } else if (dayType === "day5") {
              return {
                ...d,
                day5: dayToAssign,
              };
            } else if (dayType === "day6") {
              return {
                ...d,
                day6: dayToAssign,
              };
            } else if (dayType === "day7") {
              return {
                ...d,
                day7: dayToAssign,
              };
            } else {
            }
          } else {
          }
          return d;
        });
        this.setState(
          (curr: any) => ({ ...curr, tableData: newTableData }),
          () => {
            this.getScrollData();
          }
        );
      } else {
        let newTableData = [...this.state.tableData];
        newTableData = newTableData.map((d, index) => {
          if (index === rowIndex) {
            let tempDay = { ...row[dayType][0] };
            tempDay.shiftbulkSelect = false;
            let tempArray: any = [];
            tempArray.push(tempDay);
            let dayToAssign = tempArray;
            if (dayType === "day1") {
              return {
                ...d,
                day1: dayToAssign,
              };
            } else if (dayType === "day2") {
              return {
                ...d,
                day2: dayToAssign,
              };
            } else if (dayType === "day3") {
              return {
                ...d,
                day3: dayToAssign,
              };
            } else if (dayType === "day4") {
              return {
                ...d,
                day4: dayToAssign,
              };
            } else if (dayType === "day5") {
              return {
                ...d,
                day5: dayToAssign,
              };
            } else if (dayType === "day6") {
              return {
                ...d,
                day6: dayToAssign,
              };
            } else if (dayType === "day7") {
              return {
                ...d,
                day7: dayToAssign,
              };
            } else {
            }
          } else {
          }
          return d;
        });
        this.setState(
          (curr: any) => ({ ...curr, tableData: newTableData }),
          () => {
            this.getScrollData();
          }
        );
      }
    }
    this.setState({
      bulkSelctShiftsCount: currentStatus,
      bulkSelectShiftArray: tempScheduleArray,
    });

    // Condition for checkbox of footer check box in bulk select
    if (currentStatus === Number(this.state.totalPossibleBulks)) {
      $("#footerBulkCheckBox")
        .prop("indeterminate", false)
        .prop("checked", true);
    } else if (currentStatus > 0) {
      $("#footerBulkCheckBox")
        .prop("checked", false)
        .prop("indeterminate", true);
    } else {
      $("#footerBulkCheckBox")
        .prop("checked", false)
        .prop("indeterminate", false);
    }
  };
  multipleBulkSelect = (
    e: any,
    row: any,
    rowIndex: any,
    dayType: any,
    multiSchedule: any
  ) => {
    let currentStatus = this.state.bulkSelctShiftsCount;
    let tempScheduleArray = [...this.state.bulkSelectShiftArray];

    if (e.target.checked) {
      for (let i = 0; i < multiSchedule.length; i++) {
        if (
          multiSchedule[i].shiftPosition.trim() !== "+" ||
          multiSchedule[i].shiftPosition.trim() !== ""
        ) {
          let removalIndex = -1;
          for (let j = tempScheduleArray.length - 1; j >= 0; j--) {
            if (multiSchedule[i].uniqueno === tempScheduleArray[j].uniqueno) {
              removalIndex = j;
              break;
            }
          }

          if (removalIndex > -1) {
            tempScheduleArray.splice(removalIndex, 1);
            currentStatus = currentStatus - 1;
          }
        }
      }

      for (let i = 0; i < multiSchedule.length; i++) {
        if (
          multiSchedule[i].actualPunches === "Yes" ||
          multiSchedule[i].shiftPosition.trim() === "" ||
          multiSchedule[i].shiftPosition.trim() === "+" ||
          multiSchedule[i].shiftPosition.trim() === "PTO" ||
          multiSchedule[i].shiftPosition.trim() === "UTO" ||
          multiSchedule[i].shiftPosition.trim() === "Do not schedule".trim()
        ) {
        } else {
          let tempMuliSchedule = { ...multiSchedule[i] };
          tempMuliSchedule.employeeName = row.employeeName;
          tempScheduleArray.push(tempMuliSchedule);
          currentStatus = currentStatus + 1;
        }
      }

      let newTableData = [...this.state.tableData];
      newTableData = newTableData.map((d, index) => {
        if (index === rowIndex) {
          let tempRow = [...row[dayType]];
          for (let i = 0; i < tempRow.length; i++) {
            if (
              tempRow[i].actualPunches === "Yes" ||
              tempRow[i].shiftPosition.trim() === "" ||
              tempRow[i].shiftPosition.trim() === "+" ||
              tempRow[i].shiftPosition.trim() === "PTO" ||
              tempRow[i].shiftPosition.trim() === "UTO" ||
              tempRow[i].shiftPosition.trim() === "Do not schedule".trim()
            ) {
            } else {
              let tempDay = { ...row[dayType][i] };
              tempDay.shiftbulkSelect = true;
              tempRow[i] = tempDay;
            }
          }
          let dayToAssign = tempRow;
          if (dayType === "day1") {
            return {
              ...d,
              day1: dayToAssign,
            };
          } else if (dayType === "day2") {
            return {
              ...d,
              day2: dayToAssign,
            };
          } else if (dayType === "day3") {
            return {
              ...d,
              day3: dayToAssign,
            };
          } else if (dayType === "day4") {
            return {
              ...d,
              day4: dayToAssign,
            };
          } else if (dayType === "day5") {
            return {
              ...d,
              day5: dayToAssign,
            };
          } else if (dayType === "day6") {
            return {
              ...d,
              day6: dayToAssign,
            };
          } else if (dayType === "day7") {
            return {
              ...d,
              day7: dayToAssign,
            };
          } else {
          }
        } else {
        }
        return d;
      });
      this.setState(
        (curr: any) => ({ ...curr, tableData: newTableData }),
        () => {
          this.getScrollData();
        }
      );
    } else {
      for (let i = 0; i < multiSchedule.length; i++) {
        if (
          multiSchedule[i].shiftPosition.trim() !== "+" ||
          multiSchedule[i].shiftPosition.trim() !== ""
        ) {
          let removalIndex = -1;
          for (let j = tempScheduleArray.length - 1; j >= 0; j--) {
            if (multiSchedule[i].uniqueno === tempScheduleArray[j].uniqueno) {
              removalIndex = j;
              break;
            }
          }

          if (removalIndex > -1) {
            tempScheduleArray.splice(removalIndex, 1);
            currentStatus = currentStatus - 1;
          }
        }
      }

      let newTableData = [...this.state.tableData];
      newTableData = newTableData.map((d, index) => {
        if (index === rowIndex) {
          let tempRow = [...row[dayType]];
          for (let i = 0; i < tempRow.length; i++) {
            if (
              tempRow[i].actualPunches === "Yes" ||
              tempRow[i].shiftPosition.trim() === "" ||
              tempRow[i].shiftPosition.trim() === "+" ||
              tempRow[i].shiftPosition.trim() === "PTO" ||
              tempRow[i].shiftPosition.trim() === "UTO" ||
              tempRow[i].shiftPosition.trim() === "Do not schedule".trim()
            ) {
            } else {
              let tempDay = { ...row[dayType][i] };
              tempDay.shiftbulkSelect = false;
              tempRow[i] = tempDay;
            }
          }
          let dayToAssign = tempRow;
          if (dayType === "day1") {
            return {
              ...d,
              day1: dayToAssign,
            };
          } else if (dayType === "day2") {
            return {
              ...d,
              day2: dayToAssign,
            };
          } else if (dayType === "day3") {
            return {
              ...d,
              day3: dayToAssign,
            };
          } else if (dayType === "day4") {
            return {
              ...d,
              day4: dayToAssign,
            };
          } else if (dayType === "day5") {
            return {
              ...d,
              day5: dayToAssign,
            };
          } else if (dayType === "day6") {
            return {
              ...d,
              day6: dayToAssign,
            };
          } else if (dayType === "day7") {
            return {
              ...d,
              day7: dayToAssign,
            };
          } else {
          }
        } else {
        }
        return d;
      });
      this.setState(
        (curr: any) => ({ ...curr, tableData: newTableData }),
        () => {
          this.getScrollData();
        }
      );
    }
    this.setState({
      bulkSelctShiftsCount: currentStatus,
      bulkSelectShiftArray: tempScheduleArray,
    });

    // Condition for checkbox of footer check box in bulk select
    if (currentStatus === Number(this.state.totalPossibleBulks)) {
      $("#footerBulkCheckBox")
        .prop("indeterminate", false)
        .prop("checked", true);
    } else if (currentStatus > 0) {
      $("#footerBulkCheckBox")
        .prop("checked", false)
        .prop("indeterminate", true);
    } else {
      $("#footerBulkCheckBox")
        .prop("checked", false)
        .prop("indeterminate", false);
    }
  };

  scrollMultiBulkSelect = (e: any, dayType: any, multipleSchedules: any) => {
    let currentStatus = this.state.bulkSelctShiftsCount;
    let tempScheduleArray = [...this.state.bulkSelectShiftArray];

    if (e.target.checked) {
      for (let i = 0; i < multipleSchedules.length; i++) {
        if (
          multipleSchedules[i].shiftPosition.trim() !== "+" ||
          multipleSchedules[i].shiftPosition.trim() !== ""
        ) {
          let removalIndex = -1;
          for (let j = tempScheduleArray.length - 1; j >= 0; j--) {
            if (
              multipleSchedules[i].uniqueno === tempScheduleArray[j].uniqueno
            ) {
              removalIndex = j;
              break;
            }
          }

          if (removalIndex > -1) {
            tempScheduleArray.splice(removalIndex, 1);
            currentStatus = currentStatus - 1;
          }
        }
      }
      for (let i = 0; i < multipleSchedules.length; i++) {
        if (
          multipleSchedules[i].actualPunches === "Yes" ||
          multipleSchedules[i].shiftPosition.trim() === "" ||
          multipleSchedules[i].shiftPosition.trim() === "+" ||
          multipleSchedules[i].shiftPosition.trim() === "PTO" ||
          multipleSchedules[i].shiftPosition.trim() === "UTO" ||
          multipleSchedules[i].shiftPosition.trim() === "Do not schedule".trim()
        ) {
        } else {
          let tempMuliSchedule = { ...multipleSchedules[i] };
          tempMuliSchedule.employeeName = "Unassigned Shifts";
          tempScheduleArray.push(tempMuliSchedule);
          currentStatus = currentStatus + 1;
        }
      }

      let newTableData = [...this.state.tableData];
      newTableData = newTableData.map((d) => {
        if (d.employeeName === "Unassigned Shifts") {
          let tempDay = { ...d[dayType][0] };
          tempDay.shiftbulkSelect = true;
          let tempArray: any = [];
          tempArray.push(tempDay);
          let dayToAssign = tempArray;
          if (dayType === "day1") {
            return {
              ...d,
              day1: dayToAssign,
            };
          } else if (dayType === "day2") {
            return {
              ...d,
              day2: dayToAssign,
            };
          } else if (dayType === "day3") {
            return {
              ...d,
              day3: dayToAssign,
            };
          } else if (dayType === "day4") {
            return {
              ...d,
              day4: dayToAssign,
            };
          } else if (dayType === "day5") {
            return {
              ...d,
              day5: dayToAssign,
            };
          } else if (dayType === "day6") {
            return {
              ...d,
              day6: dayToAssign,
            };
          } else if (dayType === "day7") {
            return {
              ...d,
              day7: dayToAssign,
            };
          } else {
          }
        } else {
        }

        return d;
      });
      this.setState(
        (curr: any) => ({ ...curr, tableData: newTableData }),
        () => {
          this.getScrollData();
        }
      );
    } else {
      for (let i = 0; i < multipleSchedules.length; i++) {
        if (
          multipleSchedules[i].shiftPosition.trim() !== "+" ||
          multipleSchedules[i].shiftPosition.trim() !== ""
        ) {
          let removalIndex = -1;
          for (let j = tempScheduleArray.length - 1; j >= 0; j--) {
            if (
              multipleSchedules[i].uniqueno === tempScheduleArray[j].uniqueno
            ) {
              removalIndex = j;
              break;
            }
          }

          if (removalIndex > -1) {
            tempScheduleArray.splice(removalIndex, 1);
            currentStatus = currentStatus - 1;
          }
        }
      }

      let newTableData = [...this.state.tableData];
      newTableData = newTableData.map((d) => {
        if (d.employeeName === "Unassigned Shifts") {
          let tempDay = { ...d[dayType][0] };
          tempDay.shiftbulkSelect = false;
          let tempArray: any = [];
          tempArray.push(tempDay);
          let dayToAssign = tempArray;
          if (dayType === "day1") {
            return {
              ...d,
              day1: dayToAssign,
            };
          } else if (dayType === "day2") {
            return {
              ...d,
              day2: dayToAssign,
            };
          } else if (dayType === "day3") {
            return {
              ...d,
              day3: dayToAssign,
            };
          } else if (dayType === "day4") {
            return {
              ...d,
              day4: dayToAssign,
            };
          } else if (dayType === "day5") {
            return {
              ...d,
              day5: dayToAssign,
            };
          } else if (dayType === "day6") {
            return {
              ...d,
              day6: dayToAssign,
            };
          } else if (dayType === "day7") {
            return {
              ...d,
              day7: dayToAssign,
            };
          } else {
          }
        } else {
        }

        return d;
      });
      this.setState(
        (curr: any) => ({ ...curr, tableData: newTableData }),
        () => {
          this.getScrollData();
        }
      );
    }

    this.setState({
      bulkSelctShiftsCount: currentStatus,
      bulkSelectShiftArray: tempScheduleArray,
    });

    // Condition for checkbox of footer check box in bulk select
    if (currentStatus === Number(this.state.totalPossibleBulks)) {
      $("#footerBulkCheckBox")
        .prop("indeterminate", false)
        .prop("checked", true);
    } else if (currentStatus > 0) {
      $("#footerBulkCheckBox")
        .prop("checked", false)
        .prop("indeterminate", true);
    } else {
      $("#footerBulkCheckBox")
        .prop("checked", false)
        .prop("indeterminate", false);
    }
  };

  scrollSingleBulkSelect = (
    e: any,
    dayType: any,
    schdeule: any,
    index: any
  ) => {
    let currentStatus = this.state.bulkSelctShiftsCount;
    let tempScheduleArray = [...this.state.bulkSelectShiftArray];

    if (e.target.checked) {
      let tempSchedule = { ...schdeule };
      tempSchedule.employeeName = "Unassigned Shifts";
      tempScheduleArray.push(tempSchedule);
      currentStatus = currentStatus + 1;

      let newTableData = [...this.state.tableData];
      newTableData = newTableData.map((d, id) => {
        if (id === index) {
          let tempDay = { ...d[dayType][0] };
          tempDay.shiftbulkSelect = true;
          let tempArray: any = [];
          tempArray.push(tempDay);
          let dayToAssign = tempArray;
          if (dayType === "day1") {
            return {
              ...d,
              day1: dayToAssign,
            };
          } else if (dayType === "day2") {
            return {
              ...d,
              day2: dayToAssign,
            };
          } else if (dayType === "day3") {
            return {
              ...d,
              day3: dayToAssign,
            };
          } else if (dayType === "day4") {
            return {
              ...d,
              day4: dayToAssign,
            };
          } else if (dayType === "day5") {
            return {
              ...d,
              day5: dayToAssign,
            };
          } else if (dayType === "day6") {
            return {
              ...d,
              day6: dayToAssign,
            };
          } else if (dayType === "day7") {
            return {
              ...d,
              day7: dayToAssign,
            };
          } else {
          }
        } else {
        }

        return d;
      });
      this.setState(
        (curr: any) => ({ ...curr, tableData: newTableData }),
        () => {
          this.getScrollData();
        }
      );
    } else {
      let removalIndex = -1;
      for (let i = 0; i < tempScheduleArray.length; i++) {
        if (schdeule.uniqueno === tempScheduleArray[i].uniqueno) {
          removalIndex = i;
          break;
        }
      }

      if (removalIndex > -1) {
        tempScheduleArray.splice(removalIndex, 1);
        currentStatus = currentStatus - 1;
      }

      let newTableData = [...this.state.tableData];
      newTableData = newTableData.map((d, id) => {
        if (id === index) {
          let tempDay = { ...d[dayType][0] };
          tempDay.shiftbulkSelect = false;
          let tempArray: any = [];
          tempArray.push(tempDay);
          let dayToAssign = tempArray;
          if (dayType === "day1") {
            return {
              ...d,
              day1: dayToAssign,
            };
          } else if (dayType === "day2") {
            return {
              ...d,
              day2: dayToAssign,
            };
          } else if (dayType === "day3") {
            return {
              ...d,
              day3: dayToAssign,
            };
          } else if (dayType === "day4") {
            return {
              ...d,
              day4: dayToAssign,
            };
          } else if (dayType === "day5") {
            return {
              ...d,
              day5: dayToAssign,
            };
          } else if (dayType === "day6") {
            return {
              ...d,
              day6: dayToAssign,
            };
          } else if (dayType === "day7") {
            return {
              ...d,
              day7: dayToAssign,
            };
          } else {
          }
        } else {
        }

        return d;
      });
      this.setState(
        (curr: any) => ({ ...curr, tableData: newTableData }),
        () => {
          this.getScrollData();
        }
      );
    }

    this.setState({
      bulkSelctShiftsCount: currentStatus,
      bulkSelectShiftArray: tempScheduleArray,
    });

    // Condition for checkbox of footer check box in bulk select
    if (currentStatus === Number(this.state.totalPossibleBulks)) {
      $("#footerBulkCheckBox")
        .prop("indeterminate", false)
        .prop("checked", true);
    } else if (currentStatus > 0) {
      $("#footerBulkCheckBox")
        .prop("checked", false)
        .prop("indeterminate", true);
    } else {
      $("#footerBulkCheckBox")
        .prop("checked", false)
        .prop("indeterminate", false);
    }
  };

  footerBulkSelectAll = (e: any) => {
    if (e.target.checked) {
      let schduelBulkArray: any = [];

      let newTableData = [...this.state.tableData];
      newTableData = newTableData.map((d) => {
        let day1: any = [];
        let day2: any = [];
        let day3: any = [];
        let day4: any = [];
        let day5: any = [];
        let day6: any = [];
        let day7: any = [];
        for (let j = 1; j <= 7; j++) {
          let dayValue = `day${j}`;
          let tempRow = [...d[dayValue]];

          for (let i = 0; i < tempRow.length; i++) {
            let lockDayCondition = false;
            if (this.props.mainViewState.lockDays.includes(dayValue)) {
              lockDayCondition = true;
            }
            if (
              lockDayCondition ||
              tempRow[i].actualPunches === "Yes" ||
              tempRow[i].shiftPosition.trim() === "" ||
              tempRow[i].shiftPosition.trim() === "+" ||
              tempRow[i].shiftPosition.trim() === "PTO" ||
              tempRow[i].shiftPosition.trim() === "UTO" ||
              tempRow[i].shiftPosition.trim() === "Do not schedule".trim()
            ) {
            } else {
              let tempDay = { ...d[dayValue][i] };
              tempDay.shiftbulkSelect = true;
              tempRow[i] = tempDay;

              let tempSchedule = { ...tempDay };
              tempSchedule.employeeName = d.employeeName;
              schduelBulkArray.push(tempSchedule);
            }
          }
          let dayToAssign = tempRow;
          if (dayValue === "day1") {
            day1 = dayToAssign;
          } else if (dayValue === "day2") {
            day2 = dayToAssign;
          } else if (dayValue === "day3") {
            day3 = dayToAssign;
          } else if (dayValue === "day4") {
            day4 = dayToAssign;
          } else if (dayValue === "day5") {
            day5 = dayToAssign;
          } else if (dayValue === "day6") {
            day6 = dayToAssign;
          } else if (dayValue === "day7") {
            day7 = dayToAssign;
          } else {
          }
        }

        return {
          ...d,
          day1: day1,
          day2: day2,
          day3: day3,
          day4: day4,
          day5: day5,
          day6: day6,
          day7: day7,
        };
      });
      this.setState(
        (curr: any) => ({
          ...curr,
          tableData: newTableData,
          bulkSelctShiftsCount: this.state.totalPossibleBulks,
          bulkSelectShiftArray: schduelBulkArray,
        }),
        () => {
          this.getScrollData();
        }
      );
    } else {
      let schduelBulkArray: any = [];

      let newTableData = [...this.state.tableData];
      newTableData = newTableData.map((d) => {
        let day1: any = [];
        let day2: any = [];
        let day3: any = [];
        let day4: any = [];
        let day5: any = [];
        let day6: any = [];
        let day7: any = [];
        for (let j = 1; j <= 7; j++) {
          let dayValue = `day${j}`;
          let tempRow = [...d[dayValue]];

          for (let i = 0; i < tempRow.length; i++) {
            let lockDayCondition = false;
            if (this.props.mainViewState.lockDays.includes(dayValue)) {
              lockDayCondition = true;
            }
            if (
              lockDayCondition ||
              tempRow[i].actualPunches === "Yes" ||
              tempRow[i].shiftPosition.trim() === "" ||
              tempRow[i].shiftPosition.trim() === "+" ||
              tempRow[i].shiftPosition.trim() === "PTO" ||
              tempRow[i].shiftPosition.trim() === "UTO" ||
              tempRow[i].shiftPosition.trim() === "Do not schedule".trim()
            ) {
            } else {
              let tempDay = { ...d[dayValue][i] };
              tempDay.shiftbulkSelect = false;
              tempRow[i] = tempDay;

              let tempSchedule = { ...tempDay[i] };
              tempSchedule.employeeName = d.employeeName;
              schduelBulkArray.push(tempSchedule);
            }
          }
          let dayToAssign = tempRow;
          if (dayValue === "day1") {
            day1 = dayToAssign;
          } else if (dayValue === "day2") {
            day2 = dayToAssign;
          } else if (dayValue === "day3") {
            day3 = dayToAssign;
          } else if (dayValue === "day4") {
            day4 = dayToAssign;
          } else if (dayValue === "day5") {
            day5 = dayToAssign;
          } else if (dayValue === "day6") {
            day6 = dayToAssign;
          } else if (dayValue === "day7") {
            day7 = dayToAssign;
          } else {
          }
        }

        return {
          ...d,
          day1: day1,
          day2: day2,
          day3: day3,
          day4: day4,
          day5: day5,
          day6: day6,
          day7: day7,
        };
      });
      this.setState(
        (curr: any) => ({
          ...curr,
          tableData: newTableData,
          bulkSelctShiftsCount: 0,
          bulkSelectShiftArray: [],
        }),
        () => {
          this.getScrollData();
        }
      );
    }
  };

  bulkSeclectReassignModalShow = () => {
    // let rowObject: any = {};
    // rowObject.employeeName = "";

    // this.setState({ footerAssignRow: rowObject }, () => {
    //   this.setState({ viewAssignDropdown: true });
    // });


    let bulkSelectedArray = this.state.bulkSelectShiftArray;
    let isMPORshiftArray = bulkSelectedArray.filter((item:any) => {
      return item.isMPOR === true;
    });

    if (isMPORshiftArray.length) {
      this.setState({viewReassignConfirmModal:true})

    } else {
      this.bulkSelectAssignDropdownShow()
    }

    
  };

  bulkSeclectUnassignModalShow = () => {
    ////debuggergger;
    let bulkSelectedArray = this.state.bulkSelectShiftArray;
    let isMPORshiftArray = bulkSelectedArray.filter((item: any) => {
      return item.isMPOR === true;
    });
    if (isMPORshiftArray.length) {
      this.setState({ viewUnassignConfirmModal: true });
    } else {
      this.bulkSeclectOption("", "Unassigned");
    }
  };
  bulkSelectAssignDropdownShow = () => {
    let rowObject: any = {};
    rowObject.employeeName = "";

    this.setState({ footerAssignRow: rowObject }, () => {
      this.setState({ viewAssignDropdown: true });
    });
  };

  bulkSelectAssignDropdownHide = () => {
    this.setState({ footerAssignRow: {}, 
      viewAssignDropdown: false,
      viewDeleteConfirmModal: false,
      viewReassignConfirmModal: false,
      viewUnassignConfirmModal: false
    });
  };

  bulkSeclectDeleteModalShow = () => {
    // 
    let bulkSelectedArray = this.state.bulkSelectShiftArray;
    let isMPORshiftArray = bulkSelectedArray.filter((item:any) => {
      return item.isMPOR === true;
    });
    if (isMPORshiftArray.length) {
      this.setState({viewDeleteConfirmModal:true})
    } else {
      this.bulkSeclectOption("", "delete");
    }
  };

  bulkSeclectOption = (eName: any, type: any) => {
    this.footerBulkClose();
// <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<AUTO GENERATED BY CONFLICT EXTENSION<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< TestingUI

    // let Checkflag: any = "Unassigned";
// ====================================AUTO GENERATED BY CONFLICT EXTENSION====================================
    // let Checkflag: any = "Unassigned";
// >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>AUTO GENERATED BY CONFLICT EXTENSION>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> Feature-T1-#1851
    let Checkflag: any = "Unassigned";
    let bulkSchedules = [...this.state.bulkSelectShiftArray];
    let requestArray: any = [];

    for (let i = 0; i < bulkSchedules.length; i++) {
      let requestObject = {} as ILabourBulkSelectSchedule;

      let storage = JSON.parse(localStorage.getItem("storage")!);
      let tenantID = storage === null ? 0 : (storage.tenantID as any);
      requestObject.tenantID = tenantID;
      requestObject.hotelID = this.props.mainParentState.hidValue;
      requestObject.date = bulkSchedules[i].shiftDate;
      requestObject.inDate = bulkSchedules[i].indate;
      requestObject.outDate = bulkSchedules[i].outdate;
      requestObject.Uniqueno = bulkSchedules[i].uniqueno;
      requestObject.actionType = type;
      requestObject.employeeToAssign = eName;
      requestObject.employee = bulkSchedules[i].employeeName;
      requestObject.sheduleType = bulkSchedules[i].shiftType;
      requestObject.WeekStartDate = this.props.mainViewState.navigationCalenderDates[0];
      requestObject.WeekEndDate = this.props.mainViewState.navigationCalenderDates[1];
      requestObject.deptId = bulkSchedules[i].deptid;
      requestObject.positionId = this.props.row.posId;
      requestObject.viewType = this.props.mainViewState.scheduleView;
      if (bulkSchedules[i].employeeName !== "Unassigned Shifts") {
        Checkflag = "Assigned";
      }


      requestArray.push(requestObject);
    }
    LaborSchedule.LaborScheduleBulkSelect(requestArray)

      .then(async (result: any | null) => {
        this.getPosWiseScheduleData("bulkSelectAction");
        if (result != null && result.saveStatus === "Success") {
          if (Checkflag !== "Unassigned" && type === "Unassigned") {
            this.props.isPublishChange(true);
          }
          if (Checkflag !== "Unassigned" && type === "delete") {
            this.props.isPublishChange(true);
          }
          if (Checkflag !== "Unassigned" && type === "Assigned") {
            this.props.isPublishChange(true);
          }

// <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<AUTO GENERATED BY CONFLICT EXTENSION<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< TestingUI
          // if (Checkflag !== "Unassigned" && type === "Unassigned") {
          //   this.props.isPublishChange(true);
          // }
          // if (Checkflag !== "Unassigned" && type === "delete") {
          //   this.props.isPublishChange(true);
          // }
          // if (Checkflag !== "Unassigned" && type === "Assigned") {
          //   this.props.isPublishChange(true);
          // }
// ====================================AUTO GENERATED BY CONFLICT EXTENSION====================================

// >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>AUTO GENERATED BY CONFLICT EXTENSION>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> Feature-T1-#1851


          this.props.refreshMainDepartmentView("bulkSelect");
          let successToastMessage = "Shifts(s) unassigned successfully";
          if (type === "Assigned") {
            successToastMessage = "Shifts(s) assigned successfully";
          }
          if (type === "delete") {
            // successToastMessage = "Shifts(s) removed successfully";
            successToastMessage = "Shift(s) deleted successfully";
          }

          toast.success(successToastMessage, {
            // // position: toast.POSITION.BOTTOM_RIGHT,
            // // containerId: "scheduleMain",
          });
        } else {
          Utils.toastError(
            "Bulk action failed validation. Page has been refreshed, please try again.",
            {
              // // position: toast.POSITION.BOTTOM_RIGHT,
              // // containerId: "scheduleMain",
            }
          );
        }
        resolve();
      })
      .catch((err: any) => {
        this.getPosWiseScheduleData("bulkSelectAction");
        Utils.toastError(
          "Bulk action failed validation. Page has been refreshed, please try again.",
          {
            // // position: toast.POSITION.BOTTOM_RIGHT,
            // // containerId: "scheduleMain",
          }
        );
        reject();
      });
  };

  openAddOnBlankClick = (
    selectedShift: any,
    assignedType: any,
    row: any,
    dayName: any
  ) => {
    if (assignedType === "Assigned") {
      this.props.openAddEditForm(
        "edit",
        selectedShift,
        assignedType,
        row,
        dayName,
        "canEdit"
      );
    } else {
      this.props.openAddEditForm(
        "add",
        selectedShift,
        assignedType,
        row,
        dayName,
        "canEdit"
      );
    }
  };

  openAddOnptoClick = (schedule: any, row: any) => {
    this.props.openSlideOut(schedule, row);
  };

  openEditPTOModal = (schedule: any, row: any) => {
    this.props.openEditPTOModal(schedule, row);
  };

  dragCompletionSave = () => {
    // get TableData Value from commonFunction
    let tableDataResult = dragDrop.dragDropTableCompletion(this.state);

    this.setState(
      {
        tableData: tableDataResult,
        dragStartSchedule: {},
      },
      () => {
        this.getScrollData();
      }
    );
  };

  scrollHeaderSave = () => {
    let tableDataResult = dragDrop.dragDropScrollHeaderCompletion(this.state);
    this.setState(
      {
        tableData: tableDataResult,
        dragStartSchedule: {},
      },
      () => {
        this.getScrollData();
      }
    );
  };

  getAfterDragResponse = (result: any) => {
    ;
    let tableData = this.state.tableData;

    let { newDragDropArray, data } = dragDrop.afterDragDropResult(
      this.state,
      dragDropArray,
      result,
      "positionView"
    );

    if (data === undefined) {
      data = tableData;
    }
    this.tolalHourCalculateONFooter(dragDropArray,result);
    if (newDragDropArray !== undefined) {
      dragDropArray = newDragDropArray;
    }

    this.setState(
      {
        tableData: data,
      },
      () => {
        this.getScrollData();
      }
    );
  };



  tolalHourCalculateONFooter=(dragDropArray: any,result :any)=>{
    debugger;
    let tempFinalEmployeeTypeTotal="";
    let tempEndTime="";
    let finalTime="";
     // Adding employee time only if shift is not for unassigned+
     let newDragDropArray = [...dragDropArray];
     let dragDropIndex = -1;
 
     if (dragDropArray.length > 0) {
       for (let i = 0; i <= dragDropArray.length; i++) {
         if (Number(dragDropArray[i].uniqueno) === Number(result.old_uniqueno)) {
           dragDropIndex = i;
           break;
         }
       }
     }
       if (dragDropIndex > -1) {
         newDragDropArray.splice(dragDropIndex, 1);
       }
 
     let { endDay, endRow, startDay, startRow, uniqueno } = dragDropArray[
       dragDropIndex
     ];
 
 // start row coding
 
 if (startRow.employeeName !== "Unassigned Shifts") {
 
   let employeeType=startRow.employeePayType;
     let tempEmployeeTypeTotal = this.state.EmployeeTypeTotal.split("#");
 
     if(employeeType==="Salaried" || employeeType==="SalariedNonExempt" ) {   
      tempEndTime = tempEmployeeTypeTotal[0].split("/");
      let x=tempEndTime[0].split(":")[1]+":"+tempEndTime[0].split(":")[2];
      finalTime= x.replace(".", ":");
     }
    else if(employeeType==="HourlyWage" || employeeType==="Contractor") {   
       tempEndTime = tempEmployeeTypeTotal[1].split("/");
       let x=tempEndTime[0].split(":")[1]+":"+tempEndTime[0].split(":")[2];
       finalTime= x.replace(".", ":");
      }

    else if(employeeType==="ExcludefromPayroll") {   
        tempEndTime = tempEmployeeTypeTotal[2].split("/");
        let x=tempEndTime[1].split(":")[1]+":"+tempEndTime[1].split(":")[2];
        finalTime= x.replace(".", ":");
       }
 
     let endRowTimeInMInutes: any = schConversions.convertHourToMInute(
       finalTime
     );
    
     let resultRowTimesInHHMM =  result.oldHours.replace(".", ":");
     let resultRowTimeInMInutes = schConversions.convertHourToMInute(
       resultRowTimesInHHMM
     );
 
     let newTimeinMinutes = endRowTimeInMInutes-resultRowTimeInMInutes;
     let endToCalculate = schConversions.convertMinuteToHour(
       newTimeinMinutes
     );
     if(employeeType==="Salaried" || employeeType==="SalariedNonExempt" ) {   
     tempFinalEmployeeTypeTotal="S: "+`${endToCalculate} /${tempEndTime[1]}`+"#"+tempEmployeeTypeTotal[1]+"#"+tempEmployeeTypeTotal[2];
     }
     else if(employeeType==="HourlyWage" || employeeType==="Contractor") {  
       tempFinalEmployeeTypeTotal=tempEmployeeTypeTotal[0]+"#"+"H: "+`${endToCalculate} /${tempEndTime[1]}`+"#"+tempEmployeeTypeTotal[2];
       }
     else if(employeeType==="ExcludefromPayroll") {  
        tempFinalEmployeeTypeTotal=tempEmployeeTypeTotal[0]+"#"+tempEmployeeTypeTotal[1]+"#"+"E/P: "+`${endToCalculate} /${tempEndTime[1]}`;
     }
 
       this.setState({EmployeeTypeTotal:tempFinalEmployeeTypeTotal});
 }
 //End here
 if (endRow.employeeName !== "Unassigned Shifts") {
   let employeeType=endRow.employeePayType;
     let tempEmployeeTypeTotal = this.state.EmployeeTypeTotal.split("#");
 
     if(employeeType==="Salaried" || employeeType==="SalariedNonExempt" ) {   
      tempEndTime = tempEmployeeTypeTotal[0].split("/");
      let x=tempEndTime[0].split(":")[1]+":"+tempEndTime[0].split(":")[2];
      finalTime= x.replace(".", ":");
     }
     else if(employeeType==="HourlyWage" || employeeType==="Contractor") {  
       tempEndTime = tempEmployeeTypeTotal[1].split("/");
       let x=tempEndTime[0].split(":")[1]+":"+tempEndTime[0].split(":")[2];
       finalTime= x.replace(".", ":");
      }
      else if(employeeType==="ExcludefromPayroll") {   
        tempEndTime = tempEmployeeTypeTotal[2].split("/");
        let x=tempEndTime[1].split(":")[1]+":"+tempEndTime[1].split(":")[2];
        finalTime= x.replace(".", ":");
       }
 
     let endRowTimeInMInutes: any = schConversions.convertHourToMInute(
       finalTime
     );
    
     let resultRowTimesInHHMM = result.newHours.replace(".", ":");
     let resultRowTimeInMInutes = schConversions.convertHourToMInute(
       resultRowTimesInHHMM
     );
 
     let newTimeinMinutes = endRowTimeInMInutes + resultRowTimeInMInutes;
     let endToCalculate = schConversions.convertMinuteToHour(
       newTimeinMinutes
     );
     if(employeeType==="Salaried" || employeeType==="SalariedNonExempt" ) {    
     tempFinalEmployeeTypeTotal="S: "+`${endToCalculate} /${tempEndTime[1]}`+"#"+tempEmployeeTypeTotal[1]+"#"+tempEmployeeTypeTotal[2];
     }
     else if(employeeType==="HourlyWage" || employeeType==="Contractor") {  
       tempFinalEmployeeTypeTotal=tempEmployeeTypeTotal[0]+"#"+"H: "+`${endToCalculate} /${tempEndTime[1]}`+"#"+tempEmployeeTypeTotal[2];
       }
       else if(employeeType==="ExcludefromPayroll") {  
        tempFinalEmployeeTypeTotal=tempEmployeeTypeTotal[0]+"#"+tempEmployeeTypeTotal[1]+"#"+"E/P: "+`${endToCalculate} /${tempEndTime[1]}`;
        }
 
   this.setState({EmployeeTypeTotal:tempFinalEmployeeTypeTotal});
 }  
 }





  saveAfterDragDrop = (type: string) => {
    let {
      dragStartRow,
      dragStartSchedule,
      dragEndRow,
      dragEndDay,
      dragEndScrollDay,
      dragType,
    } = this.state;

    let dragRequest = {} as ILaborScheduleScheduleDragRequestDto;

    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    dragRequest.tenantID = tenantID;
    dragRequest.deptId = dragStartSchedule.deptId;
    dragRequest.positionId = dragStartSchedule.positionId;
    dragRequest.Uniqueno = dragStartSchedule.uniqueno;
    dragRequest.date = dragStartSchedule.shiftDate;
    dragRequest.inDate = dragStartSchedule.indate;
    dragRequest.outDate = dragStartSchedule.outdate;
    dragRequest.inTime = dragStartSchedule.shiftInTime;
    dragRequest.outTime = dragStartSchedule.shiftOutTime;
    dragRequest.isAssignedStatus = dragStartSchedule.shiftType;
    dragRequest.employeeName =
      dragType === "scrollHeader"
        ? "Unassigned Shifts"
        : dragStartRow.employeeName;
    dragRequest.hotelID = this.props.mainParentState.hidValue;
    dragRequest.payPeriodStartDate = this.props.mainViewState.navigationCalenderDates[0];
    dragRequest.entryType = "Schedule";
    dragRequest.isPublishShift =
      dragStartSchedule.shiftType === "published" ||
        dragStartSchedule.shiftType === "hideShowPublished"
        ? "Yes"
        : "No";
    dragRequest.offRepeat = "No";
    dragRequest.ptoType = -1;
    dragRequest.viewType = this.props.mainViewState.scheduleView;

    if (type === "scrollHeader") {
      let indexOfDay = Number(
        dragEndScrollDay.slice(
          dragEndScrollDay.length - 1,
          dragEndScrollDay.length
        ) - 1
      );
      dragRequest.dropShiptDate = this.props.mainViewState.headerFullDates[
        indexOfDay
      ];
      dragRequest.dropShiptEmployee = "Unassigned";
      dragRequest.isAssignedShift = "No";
    } else {
      let indexOfDay = Number(
        dragEndDay.slice(dragEndDay.length - 1, dragEndDay.length) - 1
      );
      dragRequest.dropShiptDate = this.props.mainViewState.headerFullDates[
        indexOfDay
      ];
      dragEndRow.shiftType === "UnAssigned"
        ? (dragRequest.isAssignedShift = "No")
        : (dragRequest.isAssignedShift = "Yes");

      dragEndRow.shiftType === "UnAssigned"
        ? (dragRequest.dropShiptEmployee = "Unassigned")
        : (dragRequest.dropShiptEmployee = dragEndRow.employeeName);
    }

    let requestArray: any = [];
    requestArray.push(dragRequest);



    LaborSchedule.SaveLaborScheduleDragAndDropDetails(requestArray)
      .then(async (result: any | null) => {
        ;
        if (result != null && result.saveStatus === "Success") {

// <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<AUTO GENERATED BY CONFLICT EXTENSION<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< TestingUI

// ====================================AUTO GENERATED BY CONFLICT EXTENSION====================================
//           if (dragRequest.employeeName === "Unassigned Shifts" && dragRequest.dropShiptEmployee !== "Unassigned") {
//             this.props.isPublishChange(true);
//           }
//           if (dragRequest.employeeName !== "Unassigned Shifts" && dragRequest.dropShiptEmployee === "Unassigned") {
//             this.props.isPublishChange(true);
//           }
//           if (dragRequest.employeeName !== "Unassigned Shifts" && dragRequest.dropShiptEmployee !== "Unassigned") {
//             this.props.isPublishChange(true);
//           }
          
// >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>AUTO GENERATED BY CONFLICT EXTENSION>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> Feature-T1-#1851
          if (dragRequest.employeeName === "Unassigned Shifts" && dragRequest.dropShiptEmployee !== "Unassigned") {
            this.props.isPublishChange(true);
          }
          if (dragRequest.employeeName !== "Unassigned Shifts" && dragRequest.dropShiptEmployee === "Unassigned") {
            this.props.isPublishChange(true);
          }
          if (dragRequest.employeeName !== "Unassigned Shifts" && dragRequest.dropShiptEmployee !== "Unassigned") {
            this.props.isPublishChange(true);
          }

          this.props.refreshMainDepartmentView("dragDrop");
          this.getAfterDragResponse(result);
        } else if (result.message === "OverLap") {
          this.getPosWiseScheduleData("DragDropError");
          Utils.toastError(
            "The shift cannot be moved to the selected user as the shift times are overlapping",
            {
              // // position: toast.POSITION.BOTTOM_RIGHT,
              // // containerId: "scheduleMain",
            }
          );
        } else {
          this.getPosWiseScheduleData("DragDropError");
          Utils.toastError(result.message, {
            // // position: toast.POSITION.BOTTOM_RIGHT,
            // // containerId: "scheduleMain",
          });
        }
        resolve();
      })
      .catch((err: any) => {
        this.getPosWiseScheduleData("DragDropError");
        Utils.toastError(`Server Error, ${err}`, {
          // // position: toast.POSITION.BOTTOM_RIGHT,
          // // containerId: "scheduleMain",
        });
        reject();
      });
  };

  scrollHeaderDragStart = (dayType: any, schedule: any, index: any) => {
    let dragStartRow = this.state.tableData[index][dayType][0];
    dragStartRow.employeeName = "Unassigned Shifts";

    this.setState({
      dragType: "scrollHeader",
      dragStartScrollDay: dayType,
      dragStartScrollIndex: index,
      dragStartSchedule: schedule,
      dragStartRow,
    });
  };

  scrollHeaderDrag = (dayType: any, schdeule: any, data: any) => {
    let dayChild =
      Number(dayType.slice(dayType.length - 1, dayType.length)) + 1;

    let tempRow = [...data.dayValues];
    let scheduleIndex: any;
    for (let i = 0; i < tempRow.length; i++) {
      if (Number(tempRow[i].uniqueno) === Number(schdeule.uniqueno)) {
        scheduleIndex = i;
        break;
      }
    }
    scheduleIndex = scheduleIndex + 1;
    $(
      "#scrollHeaderUnassigned div:nth-child(" +
      dayChild +
      ") div div div a div:nth-child(" +
      scheduleIndex +
      ")"
    ).addClass("dragged");
  };

  scrollHeaderDragLeave = (dayType: any) => {
    let dayChild =
      Number(dayType.slice(dayType.length - 1, dayType.length)) + 1;

    $("#scrollHeaderUnassigned div:nth-child(" + dayChild + ")").removeClass(
      "dragEnter"
    );
    $(
      "#scrollHeaderUnassigned div:nth-child(" +
      dayChild +
      ") div div div a div"
    ).removeClass("dragEnter");
  };

  scrollHeaderDragEnd = (dayType: any, schdeule: any, data: any) => {
    let dayChild =
      Number(dayType.slice(dayType.length - 1, dayType.length)) + 1;

    let tempRow = [...data.dayValues];
    let scheduleIndex: any = -1;
    for (let i = 0; i < tempRow.length; i++) {
      if (Number(tempRow[i].uniqueno) === Number(schdeule.uniqueno)) {
        scheduleIndex = i;
        break;
      }
    }
    scheduleIndex = scheduleIndex + 1;
    $(
      "#scrollHeaderUnassigned div:nth-child(" +
      dayChild +
      ") div div div a div:nth-child(" +
      scheduleIndex +
      ")"
    ).removeClass("dragged");
    $("#scrollHeaderUnassigned div:nth-child(" + dayChild + ")").removeClass(
      "dragEnter"
    );
    $(
      "#scrollHeaderUnassigned div:nth-child(" +
      dayChild +
      ") div div div a div"
    ).removeClass("dragEnter");
  };

  scrollHeaderDrop = (dayType: any, cellType: any, data: any) => {
    // e.preventDefault();
    // e.stopPropagation();

    let {
      dragType,
      dragStartScrollDay,
      dragStartScrollIndex,
      dragStartDay,
      dragStartRow,
      dragStartRowIndex,
      dragStartSchedule,
    } = this.state;
    if(dragStartSchedule.isMPOR){
      dragStartSchedule.isMPOR = false
    }
    this.scrollHeaderDragEnd(dayType, dragStartSchedule, data);
    let scheduleLength = Object.keys(dragStartSchedule).length;

    if (scheduleLength !== 0) {
      this.setState(
        { dragEndScrollDay: dayType, dragEndCellType: cellType },
        () => {
          let { isValidate, errorMessage } = dragDrop.validateDragDrop(
            this.state,
            "scrollHeaderDrop"
          );

          if (isValidate) {
            let row: any = {};
            let rowIndex: any = -1;
            let unassignedData: any = this.state.tableData.filter(
              (data: any) => data.shiftType === "UnAssigned"
            );

            let length = unassignedData.length;
            if (length <= 1) {
              rowIndex = 0;
              row = this.state.tableData[0];
            } else {
              for (let i = 0; i < length; i++) {
                for (let j = 0; j < length - i - 1; j++) {
                  let currentRow = this.state.tableData[j];
                  let nextRow = this.state.tableData[j + 1];
                  let currnetRowPosition = currentRow[dayType][0].shiftPosition;
                  let nextRowPosition = nextRow[dayType][0].shiftPosition;

                  if (
                    currnetRowPosition.trim() === "" ||
                    nextRowPosition.trim() === "+"
                  ) {
                    rowIndex = i + 1;
                    row = this.state.tableData[i + 1];
                  }
                }
              }
            }

            let dragDropObject: any = {};
            dragDropObject.uniqueno = dragStartSchedule.uniqueno;
            dragDropObject.startDay =
              dragType === "scrollHeader" ? dragStartScrollDay : dragStartDay;
            dragDropObject.startRow =
              dragType === "scrollHeader"
                ? this.state.tableData[dragStartScrollIndex]
                : dragStartRow;
            dragDropObject.startRowIndex =
              dragType === "scrollHeader"
                ? dragStartScrollIndex
                : dragStartRowIndex;
            dragDropObject.endDay = dayType;

            dragDropObject.endRow = row;
            dragDropObject.endRowIndex = rowIndex;

            dragDropArray.push(dragDropObject);

            this.scrollHeaderSave();
            this.saveAfterDragDrop("scrollHeader");
          } else {
            if (errorMessage !== "") {
              Utils.toastError(errorMessage, {
                // // position: toast.POSITION.BOTTOM_RIGHT,
                // // containerId: "scheduleMain",
              });
            }
            return false;
          }
        }
      );
    } else {
      return false;
    }
  };

  CheckMPORonScrollHeaderDrop=(e: any, dayType: any, cellType: any, data: any)=>{
    e.preventDefault();
    e.stopPropagation();
    // 
    let {
      dragType,
      dragStartScrollDay,
      dragStartScrollIndex,
      dragStartDay,
      dragStartRow,
      dragStartRowIndex,
      dragStartSchedule,
      scrollUnassigned
    } = this.state;
    if(scheduleComponents.checkMporAlert(dragStartRow,dragStartSchedule)){
      // changeInScrollData("UnassignedAlert",schdeule,
      //   row: any,
      //   dayType:
      let indexOfDay =
        Number(dayType.slice(dayType.length - 1, dayType.length)) - 1;
      // let dayValues = [...row.dayValues];
      // let multipeIndex: any;
      // for (let i = 0; i < dayValues.length; i++) {
      //   if (Number(dayValues[i].uniqueno) === Number(schdeule.uniqueno)) {
      //     multipeIndex = i;
      //     break;
      //   }
      // }
      // dayValues[multipeIndex].optionsItems = "reassignModalPopUp";
      scrollUnassigned[indexOfDay].dropMPORWarning = "showMPORWarningOnDrop";
      // scrollUnassigned[indexOfDay].dayValues = dayValues;
// data.renderType = "showMPORWarningOnDrop";
this.setState({ scrollUnassigned: scrollUnassigned });
    }else{
      this.scrollHeaderDrop(dayType,cellType,data)
    }
  };

  reassignWarningSubmitFromScrollHeader=(schdeule: any, data: any, dayType: any,mode )=>{
    let {
      dragStartSchedule,
    } = this.state;
    if(mode){
      this.scrollHeaderDrop(dayType,"multiple",data)
    } else{
      this.scrollHeaderDragEnd(dayType, dragStartSchedule, data);
      this.scrollHeaderOutsideClick(schdeule,data,dayType)
    }

  }

  onDragStart = (row: any, rowIndex: any, dayType: any, schdeule: any) => {
    this.setState({
      dragType: "table",
      dragStartRow: row,
      dragStartDay: dayType,
      dragStartRowIndex: rowIndex,
      dragStartSchedule: schdeule,
    });
  };

  onDrag = (
    row: any,
    rowIndex: any,
    dayType: any,
    schdeule: any,
    shiftType: any
  ) => {
    let trChild = Number(rowIndex + 1);
    let tdChild = Number(dayType.slice(dayType.length - 1, dayType.length)) + 1;
    if (shiftType === "multiple") {
      let tempRow = [...row[dayType]];
      let scheduleIndex: any;
      for (let i = 0; i < tempRow.length; i++) {
        if (Number(tempRow[i].uniqueno) === Number(schdeule.uniqueno)) {
          scheduleIndex = i;
          break;
        }
      }
      scheduleIndex = scheduleIndex + 1;
      $(
        "#positionExpendedRow tbody tr:nth-child(" +
        trChild +
        ") td:nth-child(" +
        tdChild +
        ") div div div div a div:nth-child(" +
        scheduleIndex +
        ")"
      ).addClass("dragged");
    } else {
      $(
        "#positionExpendedRow tbody tr:nth-child(" +
        trChild +
        ") td:nth-child(" +
        tdChild +
        ") div div"
      ).addClass("dragged");
    }
  };

  dragOver = (
    e: any,
    dropStatus: any,
    rowIndex: any,
    dayType: any,
    viewType: any
  ) => {
    if (dropStatus) {
      e.preventDefault();

      let trChild = Number(rowIndex + 1);
      let tdChild =
        Number(dayType.slice(dayType.length - 1, dayType.length)) + 1;

      if (viewType === "table") {
        $(
          "#positionExpendedRow tbody tr:nth-child(" +
          trChild +
          ") td:nth-child(" +
          tdChild +
          ") div div"
        ).addClass("dragEnter");
      } else {
        $("#scrollHeaderUnassigned div:nth-child(" + tdChild + ")").addClass(
          "dragEnter"
        );
        $(
          "#scrollHeaderUnassigned div:nth-child(" +
          tdChild +
          ") div div div a div"
        ).addClass("dragEnter");
      }
    } else {
      return false;
    }
  };

  onDragLeave = (rowIndex: any, dayType: any) => {
    let trChild = Number(rowIndex + 1);
    let tdChild = Number(dayType.slice(dayType.length - 1, dayType.length)) + 1;

    $(
      "#positionExpendedRow tbody tr:nth-child(" +
      trChild +
      ") td:nth-child(" +
      tdChild +
      ") div div"
    ).removeClass("dragEnter");
  };

  onDragEnd = (
    row: any,
    rowIndex: any,
    dayType: any,
    schdeule: any,
    shiftType: any
  ) => {
    let trChild = Number(rowIndex + 1);
    let tdChild = Number(dayType.slice(dayType.length - 1, dayType.length)) + 1;
    if (shiftType === "multiple") {
      let tempRow = [...row[dayType]];
      let scheduleIndex: any = -1;
      for (let i = 0; i < tempRow.length; i++) {
        if (
          Number(tempRow[i].uniqueno) === Number(schdeule.uniqueno) ||
          tempRow[i].uniqueno.toString() ===
          schdeule.uniqueno.toString() + "wfres"
        ) {
          scheduleIndex = i;
          break;
        }
      }
      scheduleIndex = scheduleIndex + 1;
      $(
        "#positionExpendedRow tbody tr:nth-child(" +
        trChild +
        ") td:nth-child(" +
        tdChild +
        ") div div div div a div:nth-child(" +
        scheduleIndex +
        ")"
      ).removeClass("dragged");
    } else {
      $(
        "#positionExpendedRow tbody tr:nth-child(" +
        trChild +
        ") td:nth-child(" +
        tdChild +
        ") div div"
      )
        .removeClass("dragged")
        .removeClass("dragEnter");
    }
    $("#positionExpendedRow tbody").removeClass("dragEnter");
  };

  drop = ( row: any, rowIndex: any, dayType: any, shiftType: any) => {
    // e.preventDefault();
    // e.stopPropagation();
    
    let {
      dragType,
      dragStartDay,
      dragStartRow,
      dragStartRowIndex,
      dragStartSchedule,
      dragStartScrollIndex,
      dragStartScrollDay,
    } = this.state;
  // 
 
    // Removing Drag Enter Class on Drop Event
    this.onDragEnd(row, rowIndex, dayType, dragStartSchedule, shiftType);

    let result: any;
    let scheduleLength = Object.keys(dragStartSchedule).length;
    if (dragType === "scrollHeader") {
      let startComparision = `${dragStartScrollIndex}${dragStartScrollDay}`;
      let endComparision = `${rowIndex}${dayType}`;
      result = startComparision === endComparision;
    } else {
      let startComparision = `${dragStartRowIndex}${dragStartDay}`;
      let endComparision = `${rowIndex}${dayType}`;
      result = startComparision === endComparision;
    }

    if (!result && scheduleLength !== 0) {
      this.setState(
        { dragEndRow: row, dragEndRowIndex: rowIndex, dragEndDay: dayType },
        () => {
          let { isValidate, errorMessage } = dragDrop.validateDragDrop(
            this.state,
            "tableDrop"
          );

          if (isValidate) {
            if (row.shiftType !== dragStartRow.shiftType) {
              if (dragStartSchedule.isMPOR) {
                dragStartSchedule.isMPOR = false
            }
            } else {
              if (rowIndex !== dragStartRowIndex || dayType !== dragStartDay) {
                if (dragStartSchedule.isMPOR) {
                  dragStartSchedule.isMPOR = false
                }
              }
            }
            let dragDropObject: any = {};
            dragDropObject.uniqueno = dragStartSchedule.uniqueno;
            dragDropObject.startDay =
              dragType === "scrollHeader" ? dragStartScrollDay : dragStartDay;
            dragDropObject.startRow = dragStartRow;
            dragDropObject.startRowIndex = dragStartRowIndex;
            dragDropObject.endDay = dayType;
            dragDropObject.endRow = row;
            dragDropObject.endRowIndex = rowIndex;

            dragDropArray.push(dragDropObject);

            this.dragCompletionSave();
            this.saveAfterDragDrop("table");
          } else {
            if (errorMessage !== "") {
              Utils.toastError(errorMessage, {
                // // position: toast.POSITION.BOTTOM_RIGHT,
                // // containerId: "scheduleMain",
              });
            }
            return false;
          }
        }
      );
    } else {
      return false;
    }
  };

  checkMPORonDrop = (
    e: any,
    row: any,
    rowIndex: any,
    dayType: any,
    shiftType: any
  ) => {
    e.preventDefault();
    e.stopPropagation();
    
    let {
      dragType,
      dragStartRow,
      dragStartDay,
      dragStartRowIndex,
      dragStartSchedule,
      dragStartScrollIndex,
      dragStartScrollDay,
    } = this.state;
    if (
      dragStartSchedule.actualPunches === "Yes"
    ) {
     
      Utils.toastError("Actual punches added for the employee shift, Schedule can not be moved.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "scheduleMain",
      })
    
    this.onDragEnd(row, rowIndex, dayType, dragStartSchedule, shiftType);
      ;
    }else{
    if (rowIndex !== dragStartRowIndex || dayType !== dragStartDay) {
      if(row.shiftType === dragStartRow.shiftType){
        if(shiftType === "single"){
      if (scheduleComponents.checkMporAlert(dragStartRow, dragStartSchedule)) {
        let newTableData = [...this.state.tableData];
        newTableData = newTableData.map((d, index) => {
          if (index === rowIndex) {
            let tempDay = { ...row[dayType][0] };
            tempDay.optionsItems = "onDropMPORAlert";
            let tempArray: any = [];
            tempArray.push(tempDay);
            let dayToAssign = tempArray;
            if (dayType === "day1") {
              return {
                ...d,
                day1: dayToAssign,
              };
            } else if (dayType === "day2") {
              return {
                ...d,
                day2: dayToAssign,
              };
            } else if (dayType === "day3") {
              return {
                ...d,
                day3: dayToAssign,
              };
            } else if (dayType === "day4") {
              return {
                ...d,
                day4: dayToAssign,
              };
            } else if (dayType === "day5") {
              return {
                ...d,
                day5: dayToAssign,
              };
            } else if (dayType === "day6") {
              return {
                ...d,
                day6: dayToAssign,
              };
            } else if (dayType === "day7") {
              return {
                ...d,
                day7: dayToAssign,
              };
            } else {
            }
          } else {
          }
          return d;
        });
        this.setState((curr: any) => ({ ...curr, tableData: newTableData }));
      } else {
        this.drop( row, rowIndex, dayType, "single");
      }} else{
        if (scheduleComponents.checkMporAlert(dragStartRow, dragStartSchedule)) {
          let newTableData = [...this.state.tableData];
          // 
        newTableData = newTableData.map((d, index) => {
          if (index === rowIndex) {
            let tempRow = [...row[dayType]];
            let multipeIndex: any=tempRow.length -1;
            // for (let i = 0; i < tempRow.length; i++) {
            //   if (Number(tempRow[i].uniqueno) === Number(dragStartSchedule.uniqueno)) {
            //     multipeIndex = i;
            //     break;
            //   }
            // }
            let tempDay = { ...row[dayType][multipeIndex] };
            tempDay.optionsItems = "mporAlert";
            tempRow[multipeIndex] = tempDay;
            let dayToAssign = tempRow;
            if (dayType === "day1") {
              return {
                ...d,
                multipleShiftVisibility: "onMultipleDropMPORAlert",
                day1: dayToAssign,
              };
            } else if (dayType === "day2") {
              return {
                ...d,
                multipleShiftVisibility: "onMultipleDropMPORAlert",
                day2: dayToAssign,
              };
            } else if (dayType === "day3") {
              return {
                ...d,
                multipleShiftVisibility: "onMultipleDropMPORAlert",
                day3: dayToAssign,
              };
            } else if (dayType === "day4") {
              return {
                ...d,
                multipleShiftVisibility: "onMultipleDropMPORAlert",
                day4: dayToAssign,
              };
            } else if (dayType === "day5") {
              return {
                ...d,
                multipleShiftVisibility: "onMultipleDropMPORAlert",
                day5: dayToAssign,
              };
            } else if (dayType === "day6") {
              return {
                ...d,
                multipleShiftVisibility: "onMultipleDropMPORAlert",
                day6: dayToAssign,
              };
            } else if (dayType === "day7") {
              return {
                ...d,
                multipleShiftVisibility: "onMultipleDropMPORAlert",
                day7: dayToAssign,
              };
            } else {
            }
          } else {
          }
          return d;
        });
        
        this.setState((curr: any) => ({ ...curr, tableData: newTableData }));
      } else{
        this.drop(row, rowIndex, dayType, "multiple");
      }}
    } else {
      if (scheduleComponents.checkMporAlert(dragStartRow, dragStartSchedule)) {
        let newTableData = [...this.state.tableData];
        newTableData = newTableData.map((d, index) => {
          if (index === rowIndex) {
            let tempDay = { ...row[dayType][0] };
            tempDay.optionsItems = "onUnassignedMPORAlert";
            let tempArray: any = [];
            tempArray.push(tempDay);
            let dayToAssign = tempArray;
            if (dayType === "day1") {
              return {
                ...d,
                day1: dayToAssign,
              };
            } else if (dayType === "day2") {
              return {
                ...d,
                day2: dayToAssign,
              };
            } else if (dayType === "day3") {
              return {
                ...d,
                day3: dayToAssign,
              };
            } else if (dayType === "day4") {
              return {
                ...d,
                day4: dayToAssign,
              };
            } else if (dayType === "day5") {
              return {
                ...d,
                day5: dayToAssign,
              };
            } else if (dayType === "day6") {
              return {
                ...d,
                day6: dayToAssign,
              };
            } else if (dayType === "day7") {
              return {
                ...d,
                day7: dayToAssign,
              };
            } else {
            }
          } else {
          }
          return d;
        });
        this.setState((curr: any) => ({ ...curr, tableData: newTableData }));
        //   let  confirmA = window.confirm("are you sure");
        //   if(confirmA){
        //     this.drop(e, row, rowIndex, dayType, "single")
        //   }else{
        // this.onDragEnd(row, rowIndex, dayType, dragStartSchedule, shiftType);
        //   }
      } else {
        this.drop(row, rowIndex, dayType, "single");
      }
    }
  } else {
    this.drop(row, rowIndex, dayType, "single");
  }
}
  };

  onDropWarningSubmit = (schedule:any, row:any,rowIndex:any, dayType:any, shiftType:any) => {

    // 
      this.drop( row,rowIndex, dayType, "single")
  };

  addUserFooter = () => {
    let blankObect: any = {};
    blankObect.deptId = this.props.row.deptId;
    blankObect.displayTime = "";
    blankObect.indate = "";
    blankObect.optionsItems = "showOptions";
    blankObect.outdate = "";
    blankObect.positionId = this.props.row.posId;
    blankObect.shiftAction = "";
    blankObect.shiftDate = "";
    blankObect.shiftDay = "";
    blankObect.shiftInTime = "";
    blankObect.shiftIsMultiple = "";
    blankObect.shiftOutTime = "";
    blankObect.shiftPosition = "+";
    blankObect.shiftType = "blankShift";
    blankObect.uniqueno = "";
    this.props.openAddEditForm(
      "add",
      blankObect,
      "shiftType",
      "row",
      "dayType",
      "canEdit"
    );
  };

  selectFromScrollSearch = (type: any, item: any) => {
    this.props.scrollSearch(type, item);
  };

  employeeNameReassign = (row: any) => {
    let showReassignOption = false;
    for (let j = 1; j <= 7; j++) {
      let dayValue = `day${j}`;
      let day = row[dayValue];
      if (day.length === 1) {
        const schedule: any = day[0];
        if (
          !(
            schedule.shiftPosition.trim() === "+" ||
            schedule.shiftPosition.trim() === ""
          )
        ) {
          showReassignOption = true;
          return showReassignOption;
        }
      } else {
        showReassignOption = true;
        return showReassignOption;
      }
    }
    return showReassignOption;
  };

  employeeNameForematter = (cell: any, row: any, rowIndex: any) => {
    let showOvertime = true;
    if( row.employeePayType === "Contractor" && row.isOVertimeAllowed === "No"){
      showOvertime = false;
    }
    if (row.shiftType === "UnAssigned") {
      return (
        <div className="unassigned-shift-title" draggable={false}>
          <span>{row.employeeName}</span>
        </div>
      );
    } else {
      const confirmModalContent = [
        {
          title: `Remove ${row.employeeName}`,
          desc: "Are you sure you want to remove this user from the schedule ?",
          cancleAction: "Cancel",
          ActionTrue: "Remove User",
        },
      ];
    let showReassignOption = this.employeeNameReassign(row);
      let salariedEmployeeTooltip = (<Tooltip id="salariedEmpTooltip">Salaried Employee</Tooltip>);

      return (
        <div className="employee-set d-flex" draggable={false}>
          <div className="employee-image">
            <img
              className={
                row.employeeImage === null || row.employeeImage.trim() === ""
                  ? "default"
                  : ""
              }
              src={
                row.employeeImage === null || row.employeeImage.trim() === ""
                  ? profile
                  : row.employeeImage
              }
              alt=""
            />
            {/* <img src={row.employeeImage} alt="" /> */}
          </div>
          <div className="employee-details mr-auto">
          {/* {row.employeePayType === "Salaried"  && 
            <div className="pip-salaried-employee">
            <OverlayTrigger placement="bottom" overlay={salariedEmployeeTooltip}>
              <span className="pip"></span>
            </OverlayTrigger>
          </div>} */}
          {row.employeePayType === "Salaried"  || row.employeePayType === "SalariedNonExempt" ?
                <div className="pip-salaried-employee">
                  <div className="circle">
                    <OverlayTrigger placement="bottom" overlay={salariedEmployeeTooltip}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                        <circle cx="7.5" cy="7.5" r="7.5" fill="#15A4FA"/>
                        <path d="M6.72443 12V5.45455H8.53977V12H6.72443ZM7.63636 4.6108C7.36648 4.6108 7.13494 4.52131 6.94176 4.34233C6.75142 4.16051 6.65625 3.94318 6.65625 3.69034C6.65625 3.44034 6.75142 3.22585 6.94176 3.04688C7.13494 2.86506 7.36648 2.77415 7.63636 2.77415C7.90625 2.77415 8.13636 2.86506 8.3267 3.04688C8.51989 3.22585 8.61648 3.44034 8.61648 3.69034C8.61648 3.94318 8.51989 4.16051 8.3267 4.34233C8.13636 4.52131 7.90625 4.6108 7.63636 4.6108Z" fill="white"/>
                      </svg>
                  </OverlayTrigger>
                  </div>
              </div>
              : <></>
             }
            <EllipsisWithTooltip placement="bottom">
              <span
                className={
                  row.timeDetailsSummary === "undertime"
                    ? " employeeName"
                    : showOvertime ? "employeeName red" :"employeeName"
                }
              >
                {row.employeeName}
              </span>
            </EllipsisWithTooltip>
            <span
               className={
                row.timeDetailsSummary === "undertime"
                  ? " employeeTimeDetails"
                  :  showOvertime ? "employeeTimeDetails red" :"employeeTimeDetails"
              }
            >
              {row.timeDetails}
            </span>
          </div>
          {row.showUserList === "showOptions" &&
            this.props.mainParentState.permissionManageSchedule &&
            !this.props.mainViewState.isPageLock &&
            !row.bulkSelect && (
              <div className="pop-menu">
                <Dropdown className="more-action" alignRight>
                  <Dropdown.Toggle
                    className="btn-outline-primary btn btn-primary more"
                    id="dropdown-more"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                      <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                      <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                    </svg>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {showReassignOption && (
                      <Dropdown.Item
                        id="reassignAllShiftDDN"
                        onClick={(e: any) =>
                          this.employeeNameSelection(e, rowIndex,row)
                        }
                      >
                        Reassign All Shifts
                      </Dropdown.Item>
                    )}
                    <Dropdown.Item
                      onClick={(e: any) =>
                        this.employeeNameSelection(e, rowIndex,row)
                      }
                    >
                      Remove From Schedule
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            )}
            {row.showUserList === "showMPORAlert" && !this.state.isPageLock && (
            <div className="pop-menu">
              <Dropdown className="more-action" alignRight show>
                <Dropdown.Toggle
                  className="btn-outline-primary btn btn-primary more fa-trash"
                  id="dropdown-more"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                    <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                    <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                  </svg>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <OutsideClickHandler
                    onOutsideClick={this.employeeNameHideOutside}
                  >
                    <ConfirmationModal
                      confirmModalContent={scheduleComponents.confirmationInfo(
                        "singleShift",
                        row,
                        {},
                        "moprAssignAlert"
                      )}
                      // confirmModalContent={confirmModalContent}
                      ishandleDeletePosition={this.reassingAllMPORAlertSubmit.bind(
                        this,
                        rowIndex,
                        row.employeeName
                      )}
                    />
                  </OutsideClickHandler>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          )}
          {row.showUserList === "showEmployeeList" &&
            !this.props.mainViewState.isPageLock && (
              <div className="pop-menu">
                <Dropdown className="single-select-image" alignRight show>
                  <Dropdown.Toggle
                    className="btn-outline-primary btn btn-primary more"
                    id="dropdown-more"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                      <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                      <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                    </svg>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <OutsideClickHandler
                      onOutsideClick={this.employeeNameHideOutside}
                    >
                      <div className="showUserList">
                        <ReassignAllModal
                          row={row}
                          parentState={this.props.mainParentState}
                          hidValue={this.props.mainParentState.hidValue}
                          requestType="LaborSchedule"
                          handleSelectedItem={this.slectFromSingleSearch.bind(
                            this,
                            row
                          )}
                        />
                      </div>
                    </OutsideClickHandler>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            )}
          {row.showUserList === "showConfirmationModalBox" &&
            !this.props.mainViewState.isPageLock && (
              <div className="pop-menu">
                <Dropdown className="more-action" alignRight show>
                  <Dropdown.Toggle
                    className="btn-outline-primary btn btn-primary more fa-trash"
                    id="dropdown-more"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                      <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                      <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                    </svg>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <OutsideClickHandler
                      onOutsideClick={this.employeeNameHideOutside}
                    >
                      <ConfirmationModal
                       confirmModalContent={scheduleComponents.confirmationInfo(
                        "singleShift",
                        row,
                        {},
                        "shiftRow"
                      )}
                        // confirmModalContent={confirmModalContent}
                        ishandleDeletePosition={this.userRemoveFromSchedule.bind(
                          this,
                          row
                        )}
                      />
                    </OutsideClickHandler>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            )}
        </div>
      );
    }
  };

  dayFormatter = (cell: any, row: any, rowIndex: any, dayType: any) => {
    const confirmModalContent = [
      {
        title: "Delete Schedule",
        desc: `Are you sure you want to delete this schedule for ${row.employeeName} ?`,
        cancleAction: "Cancel",
        ActionTrue: "Delete Schedule",
      },
    ];
    let currentRow = row[dayType];

    if (currentRow.length === 1) {
      const schedule = row[dayType][0];
      let draggable = true;
      let droppable = true;
      let viewOptions = true;
      let showModalOnClick = false;
      let showPTOOnClick = false;
      let showEditPTOModal = false;
      let showPosition = true;

      if (
        schedule.shiftPosition.trim() === "+" ||
        schedule.shiftPosition.trim() === "" ||
        schedule.shiftPosition.trim() === "PTO" ||
        schedule.shiftPosition.trim() === "UTO" ||
        schedule.shiftPosition.trim() === "Do not schedule".trim()
      ) {
        draggable = false;
        viewOptions = false;
        if (schedule.shiftPosition.trim() === "+") {
          showModalOnClick = true;
        }
        // if (schedule.shiftPosition.trim() === "PTO") {
        //   if (schedule.shiftType === "ptoApproved") {
        //     showEditPTOModal = true;
        //   } else {
        //     showPTOOnClick = true;
        //   }
        // }
      }

      // if (schedule.shiftPosition.trim() === "Do not schedule".trim()) {
      //   if (schedule.typeMaster === "8") {
      //     showEditPTOModal = true;
      //   } else {
      //     showPTOOnClick = true;
      //   }
      // }

      // if (schedule.shiftPosition.trim() === "UTO") {
      //   if (schedule.typeMaster === "6") {
      //     showEditPTOModal = true;
      //   } else {
      //     showPTOOnClick = true;
      //   }
      // }

      if (
        schedule.typeMaster === "3" ||
        schedule.typeMaster === "5" ||
        schedule.typeMaster === "10"
      ) {
        showPTOOnClick = true;
      }
      if (
        schedule.typeMaster === "4" ||
        schedule.typeMaster === "6" ||
        schedule.typeMaster === "8"
      ) {
        showEditPTOModal = true;
      }

      if (
        this.props.mainViewState.lockDays.includes(dayType) ||
        this.props.mainViewState.importForecastBanner
      ) {
        viewOptions = false;
        showModalOnClick = false;
        if (this.props.mainViewState.lockDays.includes(dayType)) {
          showPTOOnClick = false;
          showEditPTOModal = false;
        }

        if (
          schedule.shiftPosition.trim() === "+" ||
          schedule.shiftPosition.trim() === ""
        ) {
          showPosition = false;
        }
        if (row.shiftType !== "UnAssigned") {
          droppable = false;
          draggable = false;
        }
      }

      if (currentRow[0].shiftType === "unassigned") {
        if (
          schedule.shiftPosition.trim() === "+" ||
          schedule.shiftPosition.trim() === ""
        ) {
          droppable = false;
        }
      }

      if (row.bulkSelect) {
        draggable = false;
        droppable = false;
        viewOptions = false;
        showModalOnClick = false;
        showPTOOnClick = false;
        showEditPTOModal = false;
      }

      if (schedule.shiftAction === "wfres") {
        draggable = false;
        droppable = false;
        viewOptions = false;
        showModalOnClick = false;
        showPTOOnClick = false;
        showEditPTOModal = false;
      }

      // Schedule Classes

      let scheduleClassName: any = `schedule-type ${currentRow[0].shiftType}`;
      if (row.shiftType === "UnAssigned") {
        if (
          this.props.mainViewState.lockDays.includes(dayType) ||
          this.props.mainViewState.importForecastBanner
        ) {
          if (schedule.shiftPosition.trim() === "") {
            scheduleClassName = `schedule-type ${currentRow[0].shiftType} dayLockedUnassignedBlankShifts`;
          } else {
            scheduleClassName = `schedule-type ${currentRow[0].shiftType} dayLockedUnassignedNonBlankShifts`;
          }
        } else {
          if (schedule.shiftPosition.trim() === "") {
            scheduleClassName = `schedule-type ${currentRow[0].shiftType} unassignedBlankShifts`;
          }
        }
      } else {
        if (
          schedule.shiftPosition.trim() === "PTO" ||
          schedule.shiftPosition.trim() === "UTO" ||
          schedule.shiftPosition.trim() === "Do not schedule".trim()
        ) {
          if (this.props.mainViewState.lockDays.includes(dayType)) {
            scheduleClassName = `schedule-type ${currentRow[0].shiftType} dayLocked`;
          }
        } else {
          if (
            this.props.mainViewState.lockDays.includes(dayType) ||
            this.props.mainViewState.importForecastBanner
          ) {
            if (schedule.shiftPosition.trim() === "+") {
              scheduleClassName = `schedule-type ${currentRow[0].shiftType} dayLockedBlankShift`;
            } else {
              scheduleClassName = `schedule-type ${currentRow[0].shiftType} dayLocked`;
            }
          }
        }
      }

      // Role Permission Settings, please don't add lines below it

      if (!this.props.mainParentState.permissionManageSchedule) {
        draggable = false;
        droppable = false;
        viewOptions = false;
        showModalOnClick = false;
        // showPTOOnClick = false;
        // showEditPTOModal = false;

        if (schedule.typeMaster === "8") {
          showEditPTOModal = false;
        }

        scheduleClassName = `${scheduleClassName} c-default`;
      }

      if (!this.props.mainParentState.permissionManageTimeOff) {
        if (schedule.typeMaster === "4" || schedule.typeMaster === "6") {
          showEditPTOModal = false;

          scheduleClassName = `${scheduleClassName} c-default`;
        }
      }

      return (
        <div className="singleShift">
          {schedule.optionsItems === "showOptions" && (
            <div
              className={
                schedule.shiftbulkSelect
                  ? `${scheduleClassName} ${schedule.shiftAction} bulkTrue`
                  : `${scheduleClassName} ${schedule.shiftAction}`
              }
              draggable={draggable}
              onDragStart={() =>
                this.onDragStart(row, rowIndex, dayType, schedule)
              }
              onDrag={() =>
                this.onDrag(row, rowIndex, dayType, schedule, "single")
              }
              onDragOver={(e) =>
                this.dragOver(e, droppable, rowIndex, dayType, "table")
              }
              onDragLeave={() => this.onDragLeave(rowIndex, dayType)}
              onDragEnd={() =>
                this.onDragEnd(row, rowIndex, dayType, schedule, "single")
              }
              onDrop={(e) => this.checkMPORonDrop(e, row, rowIndex, dayType, "single")}
              onClick={() => {
                if (showModalOnClick) {
                  this.openAddOnBlankClick(
                    schedule,
                    row.shiftType,
                    row,
                    dayType
                  );
                }
                if (showPTOOnClick) {
                  this.openAddOnptoClick(schedule, row);
                }
                if (showEditPTOModal) {
                  this.openEditPTOModal(schedule, row);
                }
              }}
            >
              <Dropdown className="more-action">
                <Dropdown.Toggle
                  className="btn-outline-primary btn btn-primary more"
                  id="dropdown-more"
                >
                  <div className="d-flex">
                    {schedule.shiftAction === "bulkSelect" && (
                      <div>
                        <Form.Check
                          id="singleShiftBulkSelect"
                          type="checkbox"
                          label=""
                          checked={schedule.shiftbulkSelect}
                          onClick={(e: any) => {
                            e.stopPropagation();
                            this.singleBulkSelect(
                              e,
                              row,
                              rowIndex,
                              dayType,
                              "singleShift",
                              schedule
                            );
                          }}
                        />
                      </div>
                    )}
                    <div className="details">
                      <span className="schedule-time">
                        {schedule.displayTime}
                      </span>
                      {showPosition && (
                        <EllipsisWithTooltip placement="bottom">
                          <span className="schedule-details">
                            {schedule.shiftPosition}
                          </span>
                        </EllipsisWithTooltip>
                      )}
                    </div>
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu
                  className={"SchMenu"}
                >
                  {viewOptions ?
                    this.state.cellDropdownList.map((item: any, idx: any) => (
                      <Dropdown.Item
                        eventKey={item}
                        onClick={() =>
                          this.cellDropdownSelection(
                            item,
                            schedule,
                            row.shiftType,
                            row,
                            rowIndex,
                            dayType,
                            "singleShift"
                          )
                        }
                        key={idx}
                      >
                        {item === "Reassign"
                          ? row.shiftType === "UnAssigned"
                            ? "Assign"
                            : item
                          : item}
                      </Dropdown.Item>
                    )) :
                    <>
                      {
                        !(schedule.shiftPosition.trim() === "PTO" ||
                          schedule.shiftPosition.trim() === "UTO" ||
                          schedule.shiftPosition.trim() === "+" ||
                          schedule.shiftPosition.trim() === "Do not schedule")
                        &&
                        <Dropdown.Item
                          eventKey={"Change Log"}
                          onClick={() =>
                            this.cellDropdownSelection(
                              "Change Log",
                              schedule,
                              row.shiftType,
                              row,
                              rowIndex,
                              dayType,
                              "singleShift"
                            )
                          }
                          key={1}
                        >
                          Change Log
                        </Dropdown.Item>
                      }

                    </>
// <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<AUTO GENERATED BY CONFLICT EXTENSION<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< TestingUI
                  // }
// {/* ====================================AUTO GENERATED BY CONFLICT EXTENSION==================================== */}
                }
                </Dropdown.Menu>
              </Dropdown>
            </div>
          )}
 {schedule.optionsItems === "onDropMPORAlert" && (
            <div
              className={`schedule-type ${currentRow[0].shiftType}`}
              draggable={false}
            >
              <Dropdown className="single-select-image singleShiftPosFix" show>
                <Dropdown.Toggle
                  className="btn-outline-primary btn btn-primary more"
                  id="dropdown-more"
                >
                  <div className="d-flex">
                    <div className="details">
                      <span className="schedule-time">
                        {schedule.displayTime}
                      </span>
                      <EllipsisWithTooltip placement="bottom">
                        <span className="schedule-details">
                          {schedule.shiftPosition}
                        </span>
                      </EllipsisWithTooltip>
                    </div>

                    <Dropdown.Menu>
                      <div className="single-select-image">
                        <div className="showReassignShiftList">
                          <OutsideClickHandler
                            onOutsideClick={() =>
                              this.scheduleUserListHideOutside(
                                row,
                                rowIndex,
                                dayType
                              )
                            }
                          >
                            <ConfirmationModal
                              confirmModalContent={scheduleComponents.confirmationInfo(
                                "singleShift",
                                row,
                                schedule,
                                "ondropMPORAlert"
                              )}
                              // confirmModalContent={confirmModalContent}
                              ishandleDeletePosition={this.moprAlertSubmit.bind(
                                this,
                                schedule,
                                dayType,
                                row,
                                rowIndex,
                                "singleShift",
                                "dropWarningSubmit"
                              )}
                            />
                            {/* <ShiftReassignPopUp
                            schedule={schedule}
                            row={row}
                            parentState={this.state}
                            hidValue={this.props.parentState.hidValue}
                            handleSelectedItem={this.reassignShcedule.bind(
                              this,
                              schedule,
                              row,
                              rowIndex,
                              dayType,
                              "singleSchedule"
                            )}
                          /> */}
                          </OutsideClickHandler>
                        </div>
                      </div>
                    </Dropdown.Menu>
                  </div>
                </Dropdown.Toggle>
              </Dropdown>
            </div>
          )}
{ schedule.optionsItems === "editMPORAlert" && (
            <div
              className={`schedule-type ${currentRow[0].shiftType}`}
              draggable={false}
            >
              <Dropdown className="single-select-image singleShiftPosFix" show>
                <Dropdown.Toggle
                  className="btn-outline-primary btn btn-primary more"
                  id="dropdown-more"
                >
                  <div className="d-flex">
                    <div className="details">
                      <span className="schedule-time">
                        {schedule.displayTime}
                      </span>
                      <EllipsisWithTooltip placement="bottom">
                        <span className="schedule-details">
                          {schedule.shiftPosition}
                        </span>
                      </EllipsisWithTooltip>
                    </div>

                    <Dropdown.Menu>
                      <div className="single-select-image">
                        <div className="showReassignShiftList">
                          <OutsideClickHandler
                            onOutsideClick={() =>
                              this.scheduleUserListHideOutside(
                                row,
                                rowIndex,
                                dayType
                              )
                            }
                          >
                            <ConfirmationModal
                              confirmModalContent={scheduleComponents.confirmationInfo(
                                "singleShift",
                                row,
                                schedule,
                                "moprEditAlert"
                              )}
                              // confirmModalContent={confirmModalContent}
                              ishandleDeletePosition={this.moprAlertSubmit.bind(
                                this,
                                schedule,
                                dayType,
                                row,
                                rowIndex,
                                "singleShift",
                                "editWarningSubmit"
                              )}
                            />
                            {/* <ShiftReassignPopUp
                            schedule={schedule}
                            row={row}
                            parentState={this.state}
                            hidValue={this.props.parentState.hidValue}
                            handleSelectedItem={this.reassignShcedule.bind(
                              this,
                              schedule,
                              row,
                              rowIndex,
                              dayType,
                              "singleSchedule"
                            )}
                          /> */}
                          </OutsideClickHandler>
                        </div>
                      </div>
                    </Dropdown.Menu>
                  </div>
                </Dropdown.Toggle>
              </Dropdown>
            </div>
          )}
                {schedule.optionsItems === "onUnassignedMPORAlert" && (
            <div
              className={`schedule-type ${currentRow[0].shiftType}`}
              draggable={false}
            >
              <Dropdown className="single-select-image singleShiftPosFix" show>
                <Dropdown.Toggle
                  className="btn-outline-primary btn btn-primary more"
                  id="dropdown-more"
                >
                  <div className="d-flex">
                    <div className="details">
                      <span className="schedule-time">
                        {schedule.displayTime}
                      </span>
                      <EllipsisWithTooltip placement="bottom">
                        <span className="schedule-details">
                          {schedule.shiftPosition}
                        </span>
                      </EllipsisWithTooltip>
                    </div>

                    <Dropdown.Menu>
                      <div className="single-select-image">
                        <div className="showReassignShiftList">
                          <OutsideClickHandler
                            onOutsideClick={() =>
                              this.scheduleUserListHideOutside(
                                row,
                                rowIndex,
                                dayType
                              )
                            }
                          >
                            <ConfirmationModal
                              confirmModalContent={scheduleComponents.confirmationInfo(
                                "singleShift",
                                row,
                                schedule,
                                "onUnassignedMPORAlert"
                              )}
                              // confirmModalContent={confirmModalContent}
                              ishandleDeletePosition={this.moprAlertSubmit.bind(
                                this,
                                schedule,
                                dayType,
                                row,
                                rowIndex,
                                "singleShift",
                                "dropWarningSubmit"
                              )}
                            />
                            {/* <ShiftReassignPopUp
                            schedule={schedule}
                            row={row}
                            parentState={this.state}
                            hidValue={this.props.parentState.hidValue}
                            handleSelectedItem={this.reassignShcedule.bind(
                              this,
                              schedule,
                              row,
                              rowIndex,
                              dayType,
                              "singleSchedule"
                            )}
                          /> */}
                          </OutsideClickHandler>
                        </div>
                      </div>
                    </Dropdown.Menu>
                  </div>
                </Dropdown.Toggle>
              </Dropdown>
            </div>
          )}
          {schedule.optionsItems === "mporAlert" && (
            <div
              className={`schedule-type ${currentRow[0].shiftType}`}
              draggable={false}
            >
              <Dropdown className="single-select-image singleShiftPosFix" show>
                <Dropdown.Toggle
                  className="btn-outline-primary btn btn-primary more"
                  id="dropdown-more"
                >
                  <div className="d-flex">
                    <div className="details">
                      <span className="schedule-time">
                        {schedule.displayTime}
                      </span>
                      <EllipsisWithTooltip placement="bottom">
                        <span className="schedule-details">
                          {schedule.shiftPosition}
                        </span>
                      </EllipsisWithTooltip>
                    </div>

                    <Dropdown.Menu>
                      <div className="single-select-image">
                        <div className="showReassignShiftList">
                          <OutsideClickHandler
                            onOutsideClick={() =>
                              this.scheduleUserListHideOutside(
                                row,
                                rowIndex,
                                dayType
                              )
                            }
// {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>AUTO GENERATED BY CONFLICT EXTENSION>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> Feature-T1-#1851 */}
                          >
                            <ConfirmationModal
                              confirmModalContent={scheduleComponents.confirmationInfo(
                                "singleShift",
                                row,
                                schedule,
                                "moprAssignAlert"
                              )}
                              // confirmModalContent={confirmModalContent}
                              ishandleDeletePosition={this.moprAlertSubmit.bind(
                                this,
                                schedule,
                                dayType,
                                row,
                                rowIndex,
                                "singleShift",
                                "reassignWarningSubmit"
                              )}
                            />
                            {/* <ShiftReassignPopUp
                            schedule={schedule}
                            row={row}
                            parentState={this.state}
                            hidValue={this.props.parentState.hidValue}
                            handleSelectedItem={this.reassignShcedule.bind(
                              this,
                              schedule,
                              row,
                              rowIndex,
                              dayType,
                              "singleSchedule"
                            )}
                          /> */}
                          </OutsideClickHandler>
                        </div>
                      </div>
                    </Dropdown.Menu>
                  </div>
                </Dropdown.Toggle>
              </Dropdown>
            </div>
          )}


          
          {schedule.optionsItems === "reassignUserList" && (
            <div
              className={`schedule-type ${currentRow[0].shiftType}`}
              draggable={false}
            >
              <Dropdown className="single-select-image singleShiftPosFix" show>
                <Dropdown.Toggle
                  className="btn-outline-primary btn btn-primary more"
                  id="dropdown-more"
                >
                  <div className="d-flex">
                    <div className="details">
                      <span className="schedule-time">
                        {schedule.displayTime}
                      </span>
                      <EllipsisWithTooltip placement="bottom">
                        <span className="schedule-details">
                          {schedule.shiftPosition}
                        </span>
                      </EllipsisWithTooltip>
                    </div>

                    <Dropdown.Menu>
                      <div className="single-select-image">
                        <div className="showReassignShiftList">
                          <OutsideClickHandler
                            onOutsideClick={() =>
                              this.scheduleUserListHideOutside(
                                row,
                                rowIndex,
                                dayType
                              )
                            }
                          >


                            {/* <ConfirmationModal
                              confirmModalContent={scheduleComponents.confirmationInfo(
                                "singleShift",
                                row,
                                schedule,
                                "moprAssignAlert"
                              )}
                              // confirmModalContent={confirmModalContent}
                              ishandleDeletePosition={this.moprAlertSubmit.bind(
                                this,
                                schedule,
                                dayType,
                                row,
                                rowIndex,
                                "singleShift"
                              )}
                            /> */}



                            <ShiftReassignPopUp
                              schedule={schedule}
                              row={row}
                              parentState={this.props.mainViewState}
                              hidValue={this.props.mainParentState.hidValue}
                              handleSelectedItem={this.reassignShcedule.bind(
                                this,
                                schedule,
                                row,
                                rowIndex,
                                dayType,
                                "singleShift"
                              )}
                            />
                          </OutsideClickHandler>
                        </div>
                      </div>
                    </Dropdown.Menu>
                  </div>
                </Dropdown.Toggle>
              </Dropdown>
            </div>
          )}
          {schedule.optionsItems === "deleteScheduleModal" && (
            <div
              className={`schedule-type ${currentRow[0].shiftType} `}
              draggable={false}
            >
              <Dropdown className="more-action singleShiftPosFix" show>
                <Dropdown.Toggle
                  className="btn-outline-primary btn btn-primary more"
                  id="dropdown-more"
                >
                  <div className="details">
                    <span className="schedule-time">
                      {schedule.displayTime}
                    </span>
                    <EllipsisWithTooltip placement="bottom">
                      <span className="schedule-details">
                        {schedule.shiftPosition}
                      </span>
                    </EllipsisWithTooltip>
                  </div>
                  <Dropdown.Menu>
                    <div className="showReassignShiftList">
                      <OutsideClickHandler
                        onOutsideClick={() =>
                          this.scheduleUserListHideOutside(
                            row,
                            rowIndex,
                            dayType
                          )
                        }
                      >
                        {/* <ConfirmationModal
                          confirmModalContent={confirmModalContent}
                          ishandleDeletePosition={this.deleteSchedule.bind(
                            this,
                            schedule,
                            dayType,
                            row,
                            rowIndex,
                            "singleShift"
                          )}
                        /> */}

                    <ConfirmationModal
                          confirmModalContent={scheduleComponents.confirmationInfo(
                            "singleShift",
                            row,
                            schedule,
                            "ShiftCell"
                          )}
                          // confirmModalContent={confirmModalContent}
                          ishandleDeletePosition={this.deleteSchedule.bind(
                            this,
                            schedule,
                            dayType,
                            row,
                            rowIndex,
                            "singleShift"
                          )}
                        />




                      </OutsideClickHandler>
                    </div>
                  </Dropdown.Menu>
                </Dropdown.Toggle>
              </Dropdown>
            </div>
          )}
        </div>
      );
    } else {
      let shiftBulkSelectArray: any = [];
      let shiftPositionArray: any = [];
      let shiftClassArray: any = [];
      let shiftActionArray: any = [];
      let dropDownClassName: any = "";
      let shiftCount: any = 0;
      let bulkSelectParent: any = "fullCheck";

      currentRow.forEach((data: any) => {
        if (
          data.shiftPosition.trim() === "" ||
          data.shiftPosition.trim() === "+"
        ) {
        } else {
          shiftPositionArray.push(data.shiftPosition);
          shiftClassArray.push(data.shiftType);
          shiftActionArray.push(data.shiftAction);
          shiftBulkSelectArray.push(data.shiftbulkSelect);
          shiftCount = shiftCount + 1;
        }
      });

      if (shiftPositionArray.includes("+")) {
        let indexOfPlus = shiftPositionArray.indexOf("+");
        if (indexOfPlus > -1) {
          shiftPositionArray.splice(indexOfPlus, 1);
        }
      }
      if (shiftClassArray.includes("blankShift")) {
        let indexOfBlank = shiftClassArray.indexOf("blankShift");
        if (indexOfBlank > -1) {
          shiftClassArray.splice(indexOfBlank, 1);
        }
      }

      const uniqueShiftBulkSelect: any = new Set(shiftBulkSelectArray);
      const shiftBulkSelect = [...uniqueShiftBulkSelect];
      const uniqueShiftPoition: any = new Set(shiftPositionArray);
      const shiftPositions = [...uniqueShiftPoition];
      const uniqueShiftType: any = new Set(shiftClassArray);
      const shiftTypes = [...uniqueShiftType];
      const uniqueShiftAction: any = new Set(shiftActionArray);
      const shiftActions = [...uniqueShiftAction];

      if (shiftBulkSelect.length === 1) {
        if (shiftBulkSelect[0] === false) {
          bulkSelectParent = "noCheck";
        }
      } else {
        if (shiftBulkSelect.includes(true)) {
          bulkSelectParent = "halfCheck";
        }
      }

      if (
        shiftTypes.includes("unpublished") ||
        shiftTypes.includes("ptoRequest") ||
        shiftTypes.includes("hideShowDeptUnpublished")
      ) {
        dropDownClassName =
          "btn-outline-primary btn btn-primary more unpublished";
      } else {
        dropDownClassName =
          "btn-outline-primary btn btn-primary more published";
      }

      if (shiftActions.includes("wfres")) {
        dropDownClassName = "btn-outline-primary btn btn-primary more wfres";
      }

      let parentDrop = true;
      let isDayLock = false;
      let bulkSelectShow = true;

      if (this.props.mainViewState.lockDays.includes(dayType)) {
        isDayLock = true;
        parentDrop = false;
        bulkSelectShow = false;
      }
      if (
        shiftPositions.length === 1 &&
        (shiftPositions[0].trim() === "PTO" ||
          shiftPositions[0].trim() === "UTO" ||
          shiftPositions[0].trim() === "Do not schedule".trim())
      ) {
        bulkSelectShow = false;
      }

      if (shiftActions.length === 1 && shiftActions[0].trim() === "") {
        bulkSelectShow = false;
      }

      if (shiftActions.includes("wfres")) {
        parentDrop = false;
      }

      // Role Permission Settings, please don't add lines below it
      if (!this.props.mainParentState.permissionManageSchedule) {
        parentDrop = false;
      }

      return (
        <div className="multipleShift">
          {row.multipleShiftVisibility === "hideDropdown" && (
            <div
              className={
                isDayLock ? "mulitpleShift dayLockedMultiple" : "mulitpleShift"
              }
              onDragOver={(e) =>
                this.dragOver(e, parentDrop, rowIndex, dayType, "table")
              }
              onDragLeave={() => this.onDragLeave(rowIndex, dayType)}
              onDrop={(e) => 
                this.checkMPORonDrop(e, row, rowIndex, dayType, "multiple")
                // this.drop( row, rowIndex, dayType, "multiple")
              }
            >
              <Dropdown className="multiple-shift-dropdown" draggable={false}>
                <Dropdown.Toggle
                  className={
                    row.bulkSelect && bulkSelectShow
                      ? `${dropDownClassName} bulkSelect ${bulkSelectParent}`
                      : dropDownClassName
                  }
                  id="dropdown-more"
                  draggable={false}
                >
                  {row.bulkSelect && bulkSelectShow && (
                    <div>
                      <Form.Check
                        className={bulkSelectParent}
                        id="multiShiftBulkSelect"
                        type="checkbox"
                        label=""
                        onClick={(e: any) => {
                          e.stopPropagation();
                          this.multipleBulkSelect(
                            e,
                            row,
                            rowIndex,
                            dayType,
                            currentRow
                          );
                        }}
                      />
                    </div>
                  )}
                  <div className="details">
                    <EllipsisWithTooltip placement="bottom">
                      <span className="schedule-time">
                        {shiftCount <= 1
                          ? `${shiftCount} Shift`
                          : `${shiftCount} Shifts`}
                      </span>
                    </EllipsisWithTooltip>
                    <EllipsisWithTooltip placement="bottom">
                      <span className="schedule-details">
                        {shiftPositions.length > 1
                          ? `${shiftPositions.length} Positions`
                          : shiftPositions[0]}
                      </span>
                    </EllipsisWithTooltip>
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu draggable={false}>
                  <Dropdown.Item draggable={false} className="ifCusOver">
                    {currentRow.map((schdeule: any, index: any) => {
                      let className = `schedule-type ${schdeule.shiftType} ${schdeule.shiftAction}`;

                      let draggable = true;
                      let droppable = true;
                      let viewOptions = true;

                      if (this.props.mainViewState.lockDays.includes(dayType)) {
                        droppable = false;
                        draggable = false;
                        viewOptions = false;
                      }

                      if (
                        schdeule.shiftAction === "bulkSelect" ||
                        schdeule.shiftAction === "wfres"
                      ) {
                        droppable = false;
                        draggable = false;
                        viewOptions = false;
                      }

                      if (
                        schdeule.shiftPosition.trim() === "+" ||
                        schdeule.shiftPosition.trim() === "PTO" ||
                        schdeule.shiftPosition.trim() === "UTO" ||
                        schdeule.shiftPosition.trim() ===
                        "Do not schedule".trim()
                      ) {
                        draggable = false;
                        viewOptions = false;
                      }

                      if (isDayLock) {
                        className = `schedule-type ${schdeule.shiftType} dayLocked`;
                      }

                      // Role Permission Settings, please don't add lines below it
                      if (
                        !this.props.mainParentState.permissionManageSchedule
                      ) {
                        droppable = false;
                        draggable = false;
                        viewOptions = false;

                        className = `${className} c-default`;
                      }

                      return (
                        <div
                          key={index}
                          className={
                            schdeule.shiftbulkSelect
                              ? `${className} bulkTrue`
                              : className
                          }
                          draggable={draggable}
                          onDragStart={() =>
                            this.onDragStart(row, rowIndex, dayType, schdeule)
                          }
                          onDrag={() =>
                            this.onDrag(
                              row,
                              rowIndex,
                              dayType,
                              schdeule,
                              "multiple"
                            )
                          }
                          onDragOver={(e) =>
                            this.dragOver(
                              e,
                              droppable,
                              rowIndex,
                              dayType,
                              "table"
                            )
                          }
                          onDragEnd={() =>
                            this.onDragEnd(
                              row,
                              rowIndex,
                              dayType,
                              schdeule,
                              "multiple"
                            )
                          }
                          onDrop={(e) =>
                            this.drop( row, rowIndex, dayType, "multiple")
                          }
                        >
                          <Dropdown
                            className="more-action dropdownItemDefaultPadding"
                            onClick={(e: any) => {
                              e.stopPropagation();
                              
                            this.props.isPublishmaltishiftChange("multipleshift")
                              if (!row.bulkSelect) {
                                if (schdeule.shiftPosition === "+") {
                                  this.openAddOnBlankClick(
                                    schdeule,
                                    row.shiftType,
                                    row,
                                    dayType
                                  );
                                }
                                if (
                                  schdeule.typeMaster === "3" ||
                                  schdeule.typeMaster === "5" ||
                                  schdeule.typeMaster === "10"
                                ) {
                                  this.openAddOnptoClick(schdeule, row);
                                }
                                if (
                                  schdeule.typeMaster === "4" ||
                                  schdeule.typeMaster === "6" ||
                                  schdeule.typeMaster === "8"
                                ) {
                                  if (
                                    schdeule.typeMaster === "8" &&
                                    this.props.mainParentState
                                      .permissionManageSchedule
                                  ) {
                                    this.openEditPTOModal(schdeule, row);
                                  }
                                  if (
                                    (schdeule.typeMaster === "4" ||
                                      schdeule.typeMaster === "6") &&
                                    this.props.mainParentState
                                      .permissionManageTimeOff
                                  ) {
                                    this.openEditPTOModal(schdeule, row);
                                  }
                                }
                              }
                              // if (
                              //   schdeule.shiftPosition === "+" &&
                              //   !row.bulkSelect
                              // ) {
                              //   this.openAddOnBlankClick(
                              //     schdeule,
                              //     row.shiftType,
                              //     row,
                              //     dayType
                              //   );
                              // }
                              // if (
                              //   schdeule.shiftPosition.trim() === "PTO" &&
                              //   !row.bulkSelect
                              // ) {
                              //   if (schdeule.shiftType === "ptoApproved") {
                              //     this.openEditPTOModal(schdeule, row);
                              //   } else {
                              //     this.openAddOnptoClick(schdeule, row);
                              //   }
                              // }

                              // if (
                              //   schdeule.shiftPosition.trim() ===
                              //   "Do not schedule".trim()
                              // ) {
                              //   if (schdeule.typeMaster === "8") {
                              //     this.openEditPTOModal(schdeule, row);
                              //   } else {
                              //     this.openAddOnptoClick(schdeule, row);
                              //   }
                              // }

                              // if (schdeule.shiftPosition.trim() === "UTO") {
                              //   if (schdeule.typeMaster === "6") {
                              //     this.openEditPTOModal(schdeule, row);
                              //   } else {
                              //     this.openAddOnptoClick(schdeule, row);
                              //   }
                              // }
                            }}
                          >
                            <Dropdown.Toggle
                              className="btn-outline-primary btn btn-primary more"
                              id="dropdown-more"
                            >
                              {schdeule.shiftAction === "bulkSelect" && (
                                <div>
                                  <Form.Check
                                    id="multipleShiftBulkSelect"
                                    type="checkbox"
                                    label=""
                                    checked={schdeule.shiftbulkSelect}
                                    onClick={(e: any) => {
                                      e.stopPropagation();
                                      this.singleBulkSelect(
                                        e,
                                        row,
                                        rowIndex,
                                        dayType,
                                        "multipleShift",
                                        schdeule
                                      );
                                    }}
                                  />
                                </div>
                              )}
                              <div className="details">
                                <span className="schedule-time">
                                  {schdeule.displayTime}
                                </span>
                                <EllipsisWithTooltip placement="bottom">
                                  <span className="schedule-details">
                                    {schdeule.shiftPosition}
                                  </span>
                                </EllipsisWithTooltip>
                              </div>
                            </Dropdown.Toggle>
                            <Dropdown.Menu
                              className={"SchMenu"
                              }
                            >
                              {viewOptions &&
                                schdeule.shiftPosition.trim() !== "+" &&
                                schdeule.shiftPosition.trim() !== "PTO" &&
                                schdeule.shiftPosition.trim() !== "UTO" &&
                                schdeule.shiftPosition.trim() !==
                                "Do not schedule".trim() ?
                                this.state.cellDropdownList.map(
                                  (item: any, idx: any) => (
                                    <Dropdown.Item
                                      eventKey={item}
                                      onClick={() =>
                                        this.cellDropdownSelection(
                                          item,
                                          schdeule,
                                          schdeule.shiftType,
                                          row,
                                          rowIndex,
                                          dayType,
                                          "multipleShift"
                                        )
                                      }
                                      key={idx}
                                    >
                                      {item}
                                    </Dropdown.Item>
                                  )
                                ) :
                                <>
                                  {
                                    !(schdeule.shiftPosition.trim() === "PTO" ||
                                      schdeule.shiftPosition.trim() === "UTO" ||
                                      schdeule.shiftPosition.trim() === "+" ||
                                      schdeule.shiftPosition.trim() === "Do not schedule")
                                    &&
                                    <Dropdown.Item
                                      eventKey={"Change Log"}
                                      onClick={() =>
                                        this.cellDropdownSelection(
                                          "Change Log",
                                          schdeule,
                                          schdeule.shiftType,
                                          row,
                                          rowIndex,
                                          dayType,
                                          "multipleShift"
                                        )
                                      }
                                      key={1}
                                    >
                                      Change Log
                                    </Dropdown.Item>
                                  }

                                </>
                              }
                               
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      );
                    })}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          )}

            {row.multipleShiftVisibility === "parentMporAlert" && (
            <div className="mulitpleShift">
              <Dropdown
                className="multiple-shift-dropdown"
                draggable={false}
                show={dayType === this.state.clickedDay}
              >
                <Dropdown.Toggle
                  className={dropDownClassName}
                  id="dropdown-more"
                  draggable={false}
                >
                  <div className="details">
                    <EllipsisWithTooltip placement="bottom">
                      <span className="schedule-time">
                        {shiftCount <= 1
                          ? `${shiftCount} Shift`
                          : `${shiftCount} Shifts`}
                      </span>
                    </EllipsisWithTooltip>
                    <EllipsisWithTooltip placement="bottom">
                      <span className="schedule-details">
                        {shiftPositions.length > 1
                          ? `${shiftPositions.length} Positions`
                          : shiftPositions[0]}
                      </span>
                    </EllipsisWithTooltip>
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu draggable={false}>
                  <Dropdown.Item draggable={false} className="ifCusOver">
                    {currentRow.map((schdeule: any, index: any) => {
                      return (
                        <div
                          key={index}
                          className={`schedule-type ${schdeule.shiftType}`}
                          draggable={false}
                        >
                          <Dropdown
                            className="single-select-image"
                            onClick={(e: any) => {
                              e.stopPropagation();
                            }}
                            show={schdeule.optionsItems === "mporAlert"}
                          >
                            <Dropdown.Toggle
                              className="btn-outline-primary btn btn-primary more"
                              id="dropdown-more"
                            >
                              <div className="details">
                                <span className="schedule-time">
                                  {schdeule.displayTime}
                                </span>
                                <EllipsisWithTooltip placement="bottom">
                                  <span className="schedule-details">
                                    {schdeule.shiftPosition}
                                  </span>
                                </EllipsisWithTooltip>
                              </div>
                            </Dropdown.Toggle>
                            {schdeule.optionsItems === "mporAlert" && (
                              <Dropdown.Menu>
                                <div className="single-select-image dropdownItemPaddingRemove">
                                  <div className="showReassignShiftList">
                                    <OutsideClickHandler
                                      onOutsideClick={() =>
                                        this.multipleClickOutside(
                                          row,
                                          rowIndex,
                                          dayType,
                                          schdeule
                                        )
                                      }
                                    >
                                      <ConfirmationModal
                                        confirmModalContent={scheduleComponents.confirmationInfo(
                                          "multipleShift",
                                          row,
                                          schdeule,
                                          "moprAssignAlert"
                                        )}
                                        // confirmModalContent={confirmModalContent}
                                        ishandleDeletePosition={this.moprAlertSubmit.bind(
                                          this,
                                          schdeule,
                                          dayType,
                                          row,
                                          rowIndex,
                                          "multipleShift",
                                          "reassignWarningSubmit"
                                        )}
                                      />

                                      {/* <ShiftReassignPopUp
                                        schedule={schdeule}
                                        row={row}
                                        parentState={this.state}
                                        hidValue={
                                          this.props.parentState.hidValue
                                        }
<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<AUTO GENERATED BY CONFLICT EXTENSION<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< TestingUI

====================================AUTO GENERATED BY CONFLICT EXTENSION====================================
                                        handleSelectedItem={this.reassignShcedule.bind(
                                          this,
                                          schdeule,
                                          row,
                                          rowIndex,
                                          dayType,
                                          "multipleSchedule"
                                        )}
                                      /> */}
                                    </OutsideClickHandler>
                                  </div>
                                </div>
{/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>AUTO GENERATED BY CONFLICT EXTENSION>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> Feature-T1-#1851 */}
                              </Dropdown.Menu>
                            )}
                          </Dropdown>
                        </div>
                      );
                    })}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          )}



          {row.multipleShiftVisibility === "ReassignDropdown" && (
            <div className="mulitpleShift">
              <Dropdown
                className="multiple-shift-dropdown"
                draggable={false}
                show={dayType === this.state.clickedDay}
              >
                <Dropdown.Toggle
                  className={dropDownClassName}
                  id="dropdown-more"
                  draggable={false}
                >
                  <div className="details">
                    <EllipsisWithTooltip placement="bottom">
                      <span className="schedule-time">
                        {shiftCount <= 1
                          ? `${shiftCount} Shift`
                          : `${shiftCount} Shifts`}
                      </span>
                    </EllipsisWithTooltip>
                    <EllipsisWithTooltip placement="bottom">
                      <span className="schedule-details">
                        {shiftPositions.length > 1
                          ? `${shiftPositions.length} Positions`
                          : shiftPositions[0]}
                      </span>
                    </EllipsisWithTooltip>
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu draggable={false}>
                  <Dropdown.Item draggable={false} className="ifCusOver">
                    {currentRow.map((schdeule: any, index: any) => {
                      return (
                        <div
                          key={index}
                          className={`schedule-type ${schdeule.shiftType}`}
                          draggable={false}
                        >
                          <Dropdown
                            className="more-action single-select-image"
                            onClick={(e: any) => {
                              e.stopPropagation();
                            }}
                            show={schdeule.optionsItems === "reassignUserList"}
                          >
                            <Dropdown.Toggle
                              className="btn-outline-primary btn btn-primary more"
                              id="dropdown-more"
                            >
                              <div className="details">
                                <span className="schedule-time">
                                  {schdeule.displayTime}
                                </span>
                                <EllipsisWithTooltip placement="bottom">
                                  <span className="schedule-details">
                                    {schdeule.shiftPosition}
                                  </span>
                                </EllipsisWithTooltip>
                              </div>
                            </Dropdown.Toggle>
                            {schdeule.optionsItems === "reassignUserList" && (
                              <Dropdown.Menu>
                                <div className="single-select-image dropdownItemPaddingRemove">
                                  <div className="showReassignShiftList">
                                    <OutsideClickHandler
                                      onOutsideClick={() =>
                                        this.multipleClickOutside(
                                          row,
                                          rowIndex,
                                          dayType,
                                          schdeule
                                        )
                                      }
                                    >
                                      <ShiftReassignPopUp
                                        schedule={schdeule}
                                        row={row}
                                        parentState={this.props.mainViewState}
                                        hidValue={
                                          this.props.mainParentState.hidValue
                                        }
                                        handleSelectedItem={this.reassignShcedule.bind(
                                          this,
                                          schdeule,
                                          row,
                                          rowIndex,
                                          dayType,
                                          "multipleShift"
                                        )}
                                      />
                                    </OutsideClickHandler>
                                  </div>
                                </div>
                              </Dropdown.Menu>
                            )}
                          </Dropdown>
                        </div>
                      );
                    })}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          )}
          {row.multipleShiftVisibility === "DeleteDropdown" && (
            <div className="mulitpleShift">
              <Dropdown
                className="multiple-shift-dropdown"
                draggable={false}
                show={dayType === this.state.clickedDay}
              >
                <Dropdown.Toggle
                  className={dropDownClassName}
                  id="dropdown-more"
                  draggable={false}
                >
                  <div className="details">
                    <EllipsisWithTooltip placement="bottom">
                      <span className="schedule-time">
                        {shiftCount <= 1
                          ? `${shiftCount} Shift`
                          : `${shiftCount} Shifts`}
                      </span>
                    </EllipsisWithTooltip>
                    <EllipsisWithTooltip placement="bottom">
                      <span className="schedule-details">
                        {shiftPositions.length > 1
                          ? `${shiftPositions.length} Positions`
                          : shiftPositions[0]}
                      </span>
                    </EllipsisWithTooltip>
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu draggable={false}>
                  <Dropdown.Item draggable={false} className="ifCusOver">
                    {currentRow.map((schdeule: any, index: any) => {
                      return (
                        <div
                          key={index}
                          className={`schedule-type ${schdeule.shiftType}`}
                          draggable={false}
                        >
                          <Dropdown
                            className="more-action"
                            onClick={(e: any) => {
                              e.stopPropagation();
                            }}
                            show={
                              schdeule.optionsItems === "deleteScheduleModal"
                            }
                          >
                            <Dropdown.Toggle
                              className="btn-outline-primary btn btn-primary more"
                              id="dropdown-more"
                            >
                              <div className="details">
                                <span className="schedule-time">
                                  {schdeule.displayTime}
                                </span>
                                <EllipsisWithTooltip placement="bottom">
                                  <span className="schedule-details">
                                    {schdeule.shiftPosition}
                                  </span>
                                </EllipsisWithTooltip>
                              </div>
                            </Dropdown.Toggle>
                            {schdeule.optionsItems ===
                              "deleteScheduleModal" && (
                                <Dropdown.Menu>
                                  <div className="showDeleteModal">
                                    <OutsideClickHandler
                                      onOutsideClick={() =>
                                        this.multipleClickOutside(
                                          row,
                                          rowIndex,
                                          dayType,
                                          schdeule
                                        )
                                      }
                                    >
                                      <ConfirmationModal
                                        confirmModalContent={confirmModalContent}
                                        ishandleDeletePosition={this.deleteSchedule.bind(
                                          this,
                                          schdeule,
                                          dayType,
                                          row,
                                          rowIndex,
                                          "multipleShift"
                                        )}
                                      />
                                    </OutsideClickHandler>
                                  </div>
                                </Dropdown.Menu>
                              )}
                          </Dropdown>
                        </div>
                      );
                    })}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          )}
            {row.multipleShiftVisibility === "editwarning" && (
            <div className="mulitpleShift">
              <Dropdown
                className="multiple-shift-dropdown"
                draggable={false}
                show={dayType === this.state.clickedDay}
              >
                <Dropdown.Toggle
                  className={dropDownClassName}
                  id="dropdown-more"
                  draggable={false}
                >
                  <div className="details">
                    <EllipsisWithTooltip placement="bottom">
                      <span className="schedule-time">
                        {shiftCount <= 1
                          ? `${shiftCount} Shift`
                          : `${shiftCount} Shifts`}
                      </span>
                    </EllipsisWithTooltip>
                    <EllipsisWithTooltip placement="bottom">
                      <span className="schedule-details">
                        {shiftPositions.length > 1
                          ? `${shiftPositions.length} Positions`
                          : shiftPositions[0]}
                      </span>
                    </EllipsisWithTooltip>
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu draggable={false}>
                  <Dropdown.Item draggable={false} className="ifCusOver">
                    {currentRow.map((schdeule: any, index: any) => {
                      return (
                        <div
                          key={index}
                          className={`schedule-type ${schdeule.shiftType}`}
                          draggable={false}
                        >
                          <Dropdown
                            className="more-action"
                            onClick={(e: any) => {
                              e.stopPropagation();
                            }}
                            show={
                              schdeule.optionsItems === "editMPORAlert"
                            }
                          >
                            <Dropdown.Toggle
                              className="btn-outline-primary btn btn-primary more"
                              id="dropdown-more"
                            >
                              <div className="details">
                                <span className="schedule-time">
                                  {schdeule.displayTime}
                                </span>
                                <EllipsisWithTooltip placement="bottom">
                                  <span className="schedule-details">
                                    {schdeule.shiftPosition}
                                  </span>
                                </EllipsisWithTooltip>
                              </div>
                            </Dropdown.Toggle>
                            {schdeule.optionsItems ===
                              "editMPORAlert" && (
                              <Dropdown.Menu>
                                <div className="showDeleteModal">
                                  <OutsideClickHandler
                                    onOutsideClick={() =>
                                      this.multipleClickOutside(
                                        row,
                                        rowIndex,
                                        dayType,
                                        schdeule
                                      )
                                    }
                                  >
                                    <ConfirmationModal
                              confirmModalContent={scheduleComponents.confirmationInfo(
                                "mulitpleShift",
                                row,
                                schdeule,
                                "moprEditAlert"
                              )}
                              // confirmModalContent={confirmModalContent}
                              ishandleDeletePosition={this.moprAlertSubmit.bind(
                                this,
                                schdeule,
                                dayType,
                                row,
                                rowIndex,
                                "multipleShift",
                                "editWarningSubmit"
                              )}
                            />
                                  </OutsideClickHandler>
                                </div>
                              </Dropdown.Menu>
                            )}
                          </Dropdown>
                        </div>
                      );
                    })}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          )}
           {row.multipleShiftVisibility === "onMultipleDropMPORAlert" && (
              // tempDay.optionsItems = "mporAlert";
              // multipleShiftVisibility: "onMultipleDropMPORAlert",
            <div className="mulitpleShift ">
              <Dropdown
                className="multiple-shift-dropdown"
                draggable={false}
                show
              >
                <Dropdown.Toggle
                  className={dropDownClassName}
                  id="dropdown-more"
                  draggable={false}
                >
                  <div className="details">
                    <EllipsisWithTooltip placement="bottom">
                      <span className="schedule-time">
                        {shiftCount <= 1
                          ? `${shiftCount} Shift`
                          : `${shiftCount} Shifts`}
                      </span>
                    </EllipsisWithTooltip>
                    <EllipsisWithTooltip placement="bottom">
                      <span className="schedule-details">
                        {shiftPositions.length > 1
                          ? `${shiftPositions.length} Positions`
                          : shiftPositions[0]}
                      </span>
                    </EllipsisWithTooltip>
                  </div>
                  </Dropdown.Toggle>
                {currentRow.map((schdeule: any, index: any) => {
    if(schdeule.optionsItems === "mporAlert"){
                    return (
                        <Dropdown.Menu show>
                                        <div className="showDeleteModal">
                                  <OutsideClickHandler
                                    onOutsideClick={() =>
                                      this.multipleClickOutside(
                                        row,
                                        rowIndex,
                                        dayType,
                                        {}
                                      )
                                    }
                                  >
                                    <ConfirmationModal
                                      confirmModalContent={scheduleComponents.confirmationInfo(
                                        "mulitpleShift",
                                        row,
                                        {},
                                        "bulkReassignAlert"
                                      )}
                                      // confirmModalContent={confirmModalContent}
                                      ishandleDeletePosition={this.moprAlertSubmit.bind(
                                        this,
                                        {},
                                        dayType,
                                        row,
                                        rowIndex,
                                        "multipleShift",
                                        "dropWarningSubmit"
                                      )}
                                    />
                                  </OutsideClickHandler>
                            </div>
                          </Dropdown.Menu>
                                        )
                  }
                })}
              
              </Dropdown>
            </div>
          )}
        </div>
      );
    }
  };

  render() {
    const rowClasses = (row: any, rowIndex: any) => {
      if (row.shiftType === "UnAssigned") {
        return "unassigned-row";
      } else {
        return "assigned-row";
      }
    };

    const columns = [
      {
        dataField: "employeeName",
        text: "",
        formatter: (cell: any, row: any, rowIndex: any) =>
          this.employeeNameForematter(cell, row, rowIndex),
      },
      {
        dataField: "day1",
        text: "",
        formatter: (cell: any, row: any, rowIndex: any) =>
          this.dayFormatter(cell, row, rowIndex, "day1"),
      },
      {
        dataField: "day2",
        text: "",
        formatter: (cell: any, row: any, rowIndex: any) =>
          this.dayFormatter(cell, row, rowIndex, "day2"),
      },
      {
        dataField: "day3",
        text: "",
        formatter: (cell: any, row: any, rowIndex: any) =>
          this.dayFormatter(cell, row, rowIndex, "day3"),
      },
      {
        dataField: "day4",
        text: "",
        formatter: (cell: any, row: any, rowIndex: any) =>
          this.dayFormatter(cell, row, rowIndex, "day4"),
      },
      {
        dataField: "day5",
        text: "",
        formatter: (cell: any, row: any, rowIndex: any) =>
          this.dayFormatter(cell, row, rowIndex, "day5"),
      },
      {
        dataField: "day6",
        text: "",
        formatter: (cell: any, row: any, rowIndex: any) =>
          this.dayFormatter(cell, row, rowIndex, "day6"),
      },
      {
        dataField: "day7",
        text: "",
        formatter: (cell: any, row: any, rowIndex: any) =>
          this.dayFormatter(cell, row, rowIndex, "day7"),
      },
    ];

    return (
      <>
        {this.state.loaderTrue ? (
          <ReactPageLoader useas={"posAfterExpend"} />
        ) : (
          <div className="userViewTable" ref={this.positionExpendedRef}>
            <div className="schedule-user-view-table">
              <ToolkitProvider
                keyField="rowNo"
                data={this.state.tableData}
                columns={columns}
              >
                {(props: {
                  searchProps: JSX.IntrinsicAttributes;
                  baseProps: JSX.IntrinsicAttributes;
                }) => (
                  <div>
                    {/* Scroll Header Starts */}
                    <div
                      className={
                        this.state.scrollHeaderDisplay
                          ? "scrollHeader display"
                          : "scrollHeader hide"
                      }
                    >
                      <div className="headerDays">
                        <div className="headerDates d-flex">
                          <div
                            className={
                              this.props.mainViewState.isBulkSelect
                                ? "schedule-table-search p-none"
                                : "schedule-table-search"
                            }
                          >
                            <DepartmentSearchView
                              id="expendedView"
                              ref={this.positionSearchExpended}
                              parentState={this.props.mainViewState}
                              hidValue={this.props.mainParentState.hidValue}
                              selectFromSearchBar={this.selectFromScrollSearch.bind(
                                this,
                                "scrollHeader"
                              )}
                            />
                          </div>
                          {this.state.scrollDays.map(
                            (data: any, index: any) => (
                              <div className="column-header" key={index}>
                                <div className="header-data">
                                  {data.isLocked && (
                                    <span
                                      className="schedule-lock"
                                      data-tip={tooltipMessage}
                                    >
                                      <ReactTooltip
                                        effect="solid"
                                        event="mouseover mouseenter"
                                        eventOff="mouseleave mouseout scroll mousewheel blur"
                                        place="bottom"
                                        multiline={true}
                                      />
                                      <img
                                        src={ForecastLock}
                                        alt="ScheduleLock"
                                      />
                                    </span>
                                  )}
                                  <span className="header-day">{data.day}</span>
                                </div>
                                <p className="header-date">{data.date}</p>
                              </div>
                            )
                          )}
                        </div>

                        <div className="departmentHeader d-flex">
                          <div className="deptNameFormatter d-flex align-items-center">
                            <div className="deptDetails">
                              <div className="deptName">
                                <EllipsisWithTooltip placement="bottom">
                                  {this.props.row.posName}
                                </EllipsisWithTooltip>
                              </div>
                              <div className="deptTime">
                                {this.props.row.posOT}
                              </div>
                            </div>
                            <div className="badgeContainer d-flex">
                              {this.props.row.hasOT && (
                                <div
                                  className="deptHasOT red-badges"
                                  draggable={false}
                                >
                                  <span>OT</span>
                                </div>
                              )}
                              {this.props.row.hasUnassigned && (
                                <div
                                  className="deptHasUnassigned red-badges blue-bg"
                                  draggable={false}
                                >
                                  <span>UN</span>
                                </div>
                              )}
                            </div>
                          </div>

                          <div
                            className={
                              this.props.mainViewState.lockDays.includes("day1")
                                ? "dayFormatter dayLocked"
                                : "dayFormatter"
                            }
                          >
                            <div
                              className={
                                this.props.row.day1.dayStatus === "Overtime"
                                  ? "daySchedule red"
                                  : "daySchedule"
                              }
                            >
                              {this.props.row.day1.dayScheduleOT}
                            </div>
                            <div className="dayTotal">
                              {this.props.row.day1.dayTotalOT}
                            </div>
                          </div>
                          <div
                            className={
                              this.props.mainViewState.lockDays.includes("day2")
                                ? "dayFormatter dayLocked"
                                : "dayFormatter"
                            }
                          >
                            <div
                              className={
                                this.props.row.day2.dayStatus === "Overtime"
                                  ? "daySchedule red"
                                  : "daySchedule"
                              }
                            >
                              {this.props.row.day2.dayScheduleOT}
                            </div>
                            <div className="dayTotal">
                              {this.props.row.day2.dayTotalOT}
                            </div>
                          </div>
                          <div
                            className={
                              this.props.mainViewState.lockDays.includes("day3")
                                ? "dayFormatter dayLocked"
                                : "dayFormatter"
                            }
                          >
                            <div
                              className={
                                this.props.row.day3.dayStatus === "Overtime"
                                  ? "daySchedule red"
                                  : "daySchedule"
                              }
                            >
                              {this.props.row.day3.dayScheduleOT}
                            </div>
                            <div className="dayTotal">
                              {this.props.row.day3.dayTotalOT}
                            </div>
                          </div>
                          <div
                            className={
                              this.props.mainViewState.lockDays.includes("day4")
                                ? "dayFormatter dayLocked"
                                : "dayFormatter"
                            }
                          >
                            <div
                              className={
                                this.props.row.day4.dayStatus === "Overtime"
                                  ? "daySchedule red"
                                  : "daySchedule"
                              }
                            >
                              {this.props.row.day4.dayScheduleOT}
                            </div>
                            <div className="dayTotal">
                              {this.props.row.day4.dayTotalOT}
                            </div>
                          </div>
                          <div
                            className={
                              this.props.mainViewState.lockDays.includes("day5")
                                ? "dayFormatter dayLocked"
                                : "dayFormatter"
                            }
                          >
                            <div
                              className={
                                this.props.row.day5.dayStatus === "Overtime"
                                  ? "daySchedule red"
                                  : "daySchedule"
                              }
                            >
                              {this.props.row.day5.dayScheduleOT}
                            </div>
                            <div className="dayTotal">
                              {this.props.row.day5.dayTotalOT}
                            </div>
                          </div>
                          <div
                            className={
                              this.props.mainViewState.lockDays.includes("day6")
                                ? "dayFormatter dayLocked"
                                : "dayFormatter"
                            }
                          >
                            <div
                              className={
                                this.props.row.day6.dayStatus === "Overtime"
                                  ? "daySchedule red"
                                  : "daySchedule"
                              }
                            >
                              {this.props.row.day6.dayScheduleOT}
                            </div>
                            <div className="dayTotal">
                              {this.props.row.day6.dayTotalOT}
                            </div>
                          </div>
                          <div
                            className={
                              this.props.mainViewState.lockDays.includes("day7")
                                ? "dayFormatter dayLocked"
                                : "dayFormatter"
                            }
                          >
                            <div
                              className={
                                this.props.row.day7.dayStatus === "Overtime"
                                  ? "daySchedule red"
                                  : "daySchedule"
                              }
                            >
                              {this.props.row.day7.dayScheduleOT}
                            </div>
                            <div className="dayTotal">
                              {this.props.row.day7.dayTotalOT}
                            </div>
                          </div>
                        </div>
                        <div
                          className="unassignedShift d-flex"
                          id="scrollHeaderUnassigned"
                        >
                          <span className="unassigned-shift-title">
                            Unassigned Shifts
                          </span>
                          {this.state.scrollUnassigned.map(
                            (data: any, idx: any) => {
                              if (data.dayValues !== undefined) {
                                if (data.dayValues.length > 1) {
                                  const confirmModalContent = [
                                    {
                                      title: "Delete Schedule",
                                      desc:
                                        "Are you sure you want to delete this schedule from Unassigned Shifts ?",
                                      cancleAction: "Cancel",
                                      ActionTrue: "Delete Schedule",
                                    },
                                  ];

                                  let shiftPositionArray: any = [];
                                  let shiftBulkSelectArray: any = [];
                                  let shiftCount: any = 0;
                                  let bulkSelectParent: any = "fullCheck";

                                  data.dayValues.forEach((data: any) => {
                                    if (
                                      data.shiftPosition.trim() === "" ||
                                      data.shiftPosition.trim() === "+"
                                    ) {
                                    } else {
                                      shiftPositionArray.push(
                                        data.shiftPosition
                                      );
                                      shiftBulkSelectArray.push(
                                        data.shiftbulkSelect
                                      );
                                      shiftCount = shiftCount + 1;
                                    }
                                  });

                                  if (shiftPositionArray.includes("+")) {
                                    let indexOfPlus = shiftPositionArray.indexOf(
                                      "+"
                                    );
                                    if (indexOfPlus > -1) {
                                      shiftPositionArray.splice(indexOfPlus, 1);
                                    }
                                  }

                                  const uniqueShiftPoition: any = new Set(
                                    shiftPositionArray
                                  );
                                  const shiftPositions = [
                                    ...uniqueShiftPoition,
                                  ];
                                  const uniqueShiftBulkSelect: any = new Set(
                                    shiftBulkSelectArray
                                  );
                                  const shiftBulkSelect = [
                                    ...uniqueShiftBulkSelect,
                                  ];

                                  if (shiftBulkSelect.length === 1) {
                                    if (shiftBulkSelect[0] === false) {
                                      bulkSelectParent = "noCheck";
                                    }
                                  } else {
                                    if (shiftBulkSelect.includes(true)) {
                                      bulkSelectParent = "halfCheck";
                                    }
                                  }

                                  return (
                                    <div className="mulitpleShift" key={idx}>
                                      {data.renderType === "showOptions" && (
                                        <div
                                          draggable={false}
                                          onDrop={(e) =>
                                            this.CheckMPORonScrollHeaderDrop(
                                              e,
                                              data.dayName,
                                              "multiple",
                                              data
                                            )
                                          }
                                          onDragOver={(e) =>
                                            this.dragOver(
                                              e,
                                              true,
                                              "rowIndex",
                                              data.dayName,
                                              "viewType"
                                            )
                                          }
                                          onDragLeave={() =>
                                            this.scrollHeaderDragLeave(
                                              data.dayName
                                            )
                                          }
                                          key={idx}
                                        >
                                          <Dropdown
                                            className={
                                              data.bulkSelect
                                                ? "multiple-shift-dropdown bulkSelect"
                                                : "multiple-shift-dropdown"
                                            }
                                            draggable={false}
                                          >
                                            <Dropdown.Toggle
                                              className={
                                                data.bulkSelect
                                                  ? `btn-outline-primary btn btn-primary more unassigned ${bulkSelectParent}`
                                                  : "btn-outline-primary btn btn-primary more unassigned"
                                              }
                                              id="dropdown-more"
                                              draggable={false}
                                            >
                                              <div className="d-flex">
                                                {data.bulkSelect && (
                                                  <div>
                                                    <Form.Check
                                                      className={
                                                        bulkSelectParent
                                                      }
                                                      id="scrollMultiBulkSelect"
                                                      type="checkbox"
                                                      label=""
                                                      onClick={(e: any) => {
                                                        e.stopPropagation();
                                                        this.scrollMultiBulkSelect(
                                                          e,
                                                          data.dayName,
                                                          data.dayValues
                                                        );
                                                      }}
                                                    />
                                                  </div>
                                                )}
                                                <div className="details">
                                                  <EllipsisWithTooltip placement="bottom">
                                                    <span className="schedule-time">
                                                      {shiftCount <= 1
                                                        ? `${shiftCount} Shift`
                                                        : `${shiftCount} Shifts`}
                                                    </span>
                                                  </EllipsisWithTooltip>
                                                  <EllipsisWithTooltip placement="bottom">
                                                    <span className="schedule-details">
                                                      {shiftPositions.length > 1
                                                        ? `${shiftPositions.length} Positions`
                                                        : shiftPositions[0]}
                                                    </span>
                                                  </EllipsisWithTooltip>
                                                </div>
                                              </div>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu draggable={false}>
                                              <Dropdown.Item
                                                draggable={false}
                                                className="ifCusOver"
                                              >
                                                {data.dayValues.map(
                                                  (
                                                    schdeule: any,
                                                    index: any
                                                  ) => {
                                                    let showModalOnClick = false;
                                                    let draggable = true;
                                                    let optionsDisplay = true;
                                                    let isDayLock = false;
                                                    let bulkSelectVisible = true;

                                                    if (
                                                      schdeule.shiftPosition ===
                                                      "+"
                                                    ) {
                                                      optionsDisplay = false;
                                                      draggable = false;
                                                      showModalOnClick = true;
                                                      bulkSelectVisible = false;
                                                    }

                                                    if (
                                                      this.props.mainViewState.lockDays.includes(
                                                        data.dayName
                                                      ) ||
                                                      this.state
                                                        .importForecastBanner
                                                    ) {
                                                      optionsDisplay = false;
                                                      showModalOnClick = false;
                                                      isDayLock = true;
                                                    }
                                                    if (data.bulkSelect) {
                                                      showModalOnClick = false;
                                                      draggable = false;
                                                      optionsDisplay = false;
                                                    }

                                                    let className = `schedule-type ${schdeule.shiftType} ${schdeule.shiftAction}`;
                                                    if (isDayLock) {
                                                      className = `schedule-type ${schdeule.shiftType} unAssingedScrollHeaderDayLocked`;
                                                      if (
                                                        schdeule.shiftPosition ===
                                                        "+"
                                                      ) {
                                                        className = `schedule-type ${schdeule.shiftType} unAssingedScrollHeaderDayLockedPlus`;
                                                      }
                                                    }
                                                    return (
                                                      <div
                                                        key={index}
                                                        className={
                                                          schdeule.shiftbulkSelect
                                                            ? `${className} bulkTrue`
                                                            : className
                                                        }
                                                        draggable={draggable}
                                                        onDragStart={() =>
                                                          this.scrollHeaderDragStart(
                                                            data.dayName,
                                                            schdeule,
                                                            index
                                                          )
                                                        }
                                                        onDrag={() =>
                                                          this.scrollHeaderDrag(
                                                            data.dayName,
                                                            schdeule,
                                                            data
                                                          )
                                                        }
                                                        onDragOver={(e) =>
                                                          this.dragOver(
                                                            e,
                                                            true,
                                                            "rowIndex",
                                                            data.dayName,
                                                            "viewType"
                                                          )
                                                        }
                                                        onDragLeave={() =>
                                                          this.scrollHeaderDragLeave(
                                                            data.dayName
                                                          )
                                                        }
                                                        onDragEnd={() =>
                                                          this.scrollHeaderDragEnd(
                                                            data.dayName,
                                                            schdeule,
                                                            data
                                                          )
                                                        }
                                                      >
                                                        <Dropdown
                                                          className="more-action dropdownItemDefaultPadding"
                                                          onClick={(e: any) => {
                                                            e.stopPropagation();
                                                            this.props.isPublishmaltishiftChange("multipleshift")
                                                            if (
                                                              schdeule.shiftPosition ===
                                                              "+" &&
                                                              showModalOnClick
                                                            ) {
                                                              this.openAddOnBlankClick(
                                                                schdeule,
                                                                "unAssigned",
                                                                this.props.row,
                                                                data.dayName
                                                              );
                                                            }
                                                          }}
                                                        >
                                                          <Dropdown.Toggle
                                                            className="btn-outline-primary btn btn-primary more"
                                                            id="dropdown-more"
                                                          >
                                                            <div className="d-flex">
                                                              {data.bulkSelect &&
                                                                bulkSelectVisible && (
                                                                  <Form.Check
                                                                    id="scrollSingleBulkSelect"
                                                                    type="checkbox"
                                                                    label=""
                                                                    checked={
                                                                      schdeule.shiftbulkSelect
                                                                    }
                                                                    onClick={(
                                                                      e: any
                                                                    ) => {
                                                                      e.stopPropagation();
                                                                      this.scrollSingleBulkSelect(
                                                                        e,
                                                                        data.dayName,
                                                                        schdeule,
                                                                        index
                                                                      );
                                                                    }}
                                                                  />
                                                                )}
                                                              <div className="details">
                                                                <span className="schedule-time">
                                                                  {
                                                                    schdeule.displayTime
                                                                  }
                                                                </span>
                                                                <EllipsisWithTooltip placement="bottom">
                                                                  <span className="schedule-details">
                                                                    {
                                                                      schdeule.shiftPosition
                                                                    }
                                                                  </span>
                                                                </EllipsisWithTooltip>
                                                              </div>
                                                            </div>
                                                          </Dropdown.Toggle>
                                                          {optionsDisplay ? (
                                                            <Dropdown.Menu>
                                                              {this.state.cellDropdownList.map(
                                                                (
                                                                  item: any,
                                                                  idx: any
                                                                ) => (
                                                                  <Dropdown.Item
                                                                    eventKey={
                                                                      item
                                                                    }
                                                                    onClick={() =>
                                                                      this.cellDropdownSelection(
                                                                        item,
                                                                        schdeule,
                                                                        schdeule.shiftType,
                                                                        data,
                                                                        "rowIndex",
                                                                        data.dayName,
                                                                        "scrollHeader"
                                                                      )
                                                                    }
                                                                    key={idx}
                                                                  >
                                                                    {item ===
                                                                      "Reassign"
                                                                      ? "Assign"
                                                                      : item}
                                                                  </Dropdown.Item>
                                                                )
                                                              )}
                                                            </Dropdown.Menu>
                                                          ) :
                                                            <>
                                                              {
                                                                !(schdeule.shiftPosition.trim() === "PTO" ||
                                                                  schdeule.shiftPosition.trim() === "UTO" ||
                                                                  schdeule.shiftPosition.trim() === "+" ||
                                                                  schdeule.shiftPosition.trim() === "Do not schedule")
                                                                &&
                                                                <Dropdown.Menu>
                                                                  <Dropdown.Item
                                                                    eventKey={
                                                                      "Change Log"
                                                                    }
                                                                    onClick={() =>
                                                                      this.cellDropdownSelection(
                                                                        "Change Log",
                                                                        schdeule,
                                                                        schdeule.shiftType,
                                                                        data,
                                                                        "rowIndex",
                                                                        data.dayName,
                                                                        "scrollHeader"
                                                                      )
                                                                    }
                                                                    key={1}
                                                                  >
                                                                    Change Log
                                                                  </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                              }
                                                            </>
                                                          }
                                                        </Dropdown>
                                                      </div>
                                                    );
                                                  }
                                                )}
                                              </Dropdown.Item>
                                            </Dropdown.Menu>
                                          </Dropdown>
                                          <Dropdown show>
                                        {data.dropMPORWarning === "showMPORWarningOnDrop" && (
                                      <Dropdown.Menu
                                        //alignRight
                                        className="reassign-dropdown-box"
                                      >
                                        <div className="single-select-image dropdownItemPaddingRemove">
                                          <div className="showReassignShiftList">
                                            <OutsideClickHandler
                                              onOutsideClick={() =>
                                                this.reassignWarningSubmitFromScrollHeader("",data,data.dayName,false)
                                                // this.scrollHeaderOutsideClick(
                                                //   "",
                                                //   data,
                                                //   data.dayName
                                                // )
                                              }
                                            >
                                              <ConfirmationModal
                                                confirmModalContent={scheduleComponents.confirmationInfo(
                                                  "unAssigned",
                                                  {},
                                                  {},
                                                  "onUnassignedMPORAlert"
                                                )}
                                                ishandleDeletePosition={this.reassignWarningSubmitFromScrollHeader.bind(
                                                  this,
                                                  "",
                                                  data,data.dayName
                                                )}
                                              />
                                            </OutsideClickHandler>
                                          </div>
                                        </div>
                                        </Dropdown.Menu>)}
                                        </Dropdown>
                                        </div>
                                      )}

                                      {data.renderType === "showReassign" && (
                                        <div draggable={false} key={idx}>
                                          <Dropdown
                                            className="multiple-shift-dropdown"
                                            draggable={false}
                                            show={true}
                                          >
                                            <Dropdown.Toggle
                                              className="btn-outline-primary more"
                                              id="dropdown-more"
                                              draggable={false}
                                            >
                                              <div className="details">
                                                <EllipsisWithTooltip placement="bottom">
                                                  <span className="schedule-time">
                                                    {shiftCount <= 1
                                                      ? `${shiftCount} Shift`
                                                      : `${shiftCount} Shifts`}
                                                  </span>
                                                </EllipsisWithTooltip>
                                                <EllipsisWithTooltip placement="bottom">
                                                  <span className="schedule-details">
                                                    {shiftPositions.length > 1
                                                      ? `${shiftPositions.length} Positions`
                                                      : shiftPositions[0]}
                                                  </span>
                                                </EllipsisWithTooltip>
                                              </div>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu draggable={false}>
                                              <Dropdown.Item
                                                draggable={false}
                                                className="ifCusOver"
                                              >
                                                {data.dayValues.map(
                                                  (
                                                    schdeule: any,
                                                    index: any
                                                  ) => {
                                                    return (
                                                      <div
                                                        key={index}
                                                        className={`schedule-type ${schdeule.shiftType}`}
                                                        draggable={false}
                                                      >
                                                        <Dropdown
                                                          className="more-action single-select-image mymarker"
                                                          onClick={(e: any) => {
                                                            e.stopPropagation();
                                                          }}
                                                          show={
                                                            schdeule.optionsItems ===
                                                            "reassignModalPopUp"
                                                          }
                                                        >
                                                          <Dropdown.Toggle
                                                            className="btn-outline-primary btn btn-primary more"
                                                            id="dropdown-more"
                                                          >
                                                            <div className="details">
                                                              <span className="schedule-time">
                                                                {
                                                                  schdeule.displayTime
                                                                }
                                                              </span>
                                                              <EllipsisWithTooltip placement="bottom">
                                                                <span className="schedule-details">
                                                                  {
                                                                    schdeule.shiftPosition
                                                                  }
                                                                </span>
                                                              </EllipsisWithTooltip>
                                                            </div>
                                                          </Dropdown.Toggle>

                                                          {schdeule.optionsItems ===
                                                            "reassignModalPopUp" && (
                                                              <Dropdown.Menu
                                                                alignRight
                                                              >
                                                                <div className="single-select-image dropdownItemPaddingRemove">
                                                                  <div className="showReassignShiftList">
                                                                    <OutsideClickHandler
                                                                      onOutsideClick={() => {
                                                                        this.scrollHeaderOutsideClick(
                                                                          schdeule,
                                                                          data,
                                                                          data.dayName
                                                                        );
                                                                      }}
                                                                    >
                                                                      <ShiftReassignPopUp
                                                                        schedule={
                                                                          schdeule
                                                                        }
                                                                        row={
                                                                          "row"
                                                                        }
                                                                        parentState={
                                                                          this
                                                                            .props
                                                                            .mainViewState
                                                                        }
                                                                        hidValue={
                                                                          this
                                                                            .props
                                                                            .mainParentState
                                                                            .hidValue
                                                                        }
                                                                        handleSelectedItem={this.reassignScheduleFromHeader.bind(
                                                                          this,
                                                                          schdeule
                                                                        )}
                                                                      />
                                                                    </OutsideClickHandler>
                                                                  </div>
                                                                </div>
                                                              </Dropdown.Menu>
                                                            )}
                                                        </Dropdown>
                                                      </div>
                                                    );
                                                  }
                                                )}
                                              </Dropdown.Item>
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        </div>
                                      )}

                                      {data.renderType === "showDelete" && (
                                        <div draggable={false} key={idx}>
                                          <Dropdown
                                            className="multiple-shift-dropdown"
                                            draggable={false}
                                            show
                                          >
                                            <Dropdown.Toggle
                                              className="btn-outline-primary more"
                                              id="dropdown-more"
                                              draggable={false}
                                            >
                                              <div className="details">
                                                <EllipsisWithTooltip placement="bottom">
                                                  <span className="schedule-time">
                                                    {shiftCount <= 1
                                                      ? `${shiftCount} Shift`
                                                      : `${shiftCount} Shifts`}
                                                  </span>
                                                </EllipsisWithTooltip>
                                                <EllipsisWithTooltip placement="bottom">
                                                  <span className="schedule-details">
                                                    {shiftPositions.length > 1
                                                      ? `${shiftPositions.length} Positions`
                                                      : shiftPositions[0]}
                                                  </span>
                                                </EllipsisWithTooltip>
                                              </div>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu draggable={false}>
                                              <Dropdown.Item
                                                draggable={false}
                                                className="ifCusOver"
                                              >
                                                {data.dayValues.map(
                                                  (
                                                    schdeule: any,
                                                    index: any
                                                  ) => {
                                                    return (
                                                      <div
                                                        key={index}
                                                        className={`schedule-type ${schdeule.shiftType}`}
                                                        draggable={false}
                                                      >
                                                        <Dropdown
                                                          className="more-action"
                                                          onClick={(e: any) => {
                                                            e.stopPropagation();
                                                          }}
                                                          show={
                                                            schdeule.optionsItems ===
                                                            "deleteModalPopup"
                                                          }
                                                        >
                                                          <Dropdown.Toggle
                                                            className="btn-outline-primary btn btn-primary more"
                                                            id="dropdown-more"
                                                          >
                                                            <div className="details">
                                                              <span className="schedule-time">
                                                                {
                                                                  schdeule.displayTime
                                                                }
                                                              </span>
                                                              <EllipsisWithTooltip placement="bottom">
                                                                <span className="schedule-details">
                                                                  {
                                                                    schdeule.shiftPosition
                                                                  }
                                                                </span>
                                                              </EllipsisWithTooltip>
                                                            </div>
                                                          </Dropdown.Toggle>

                                                          {schdeule.optionsItems ===
                                                            "deleteModalPopup" && (
                                                              <Dropdown.Menu
                                                                alignRight
                                                              >
                                                                <div className="single-select-image dropdownItemPaddingRemove">
                                                                  <div className="showReassignShiftList">
                                                                    <OutsideClickHandler
                                                                      onOutsideClick={() =>
                                                                        this.scrollHeaderOutsideClick(
                                                                          schdeule,
                                                                          data,
                                                                          data.dayName
                                                                        )
                                                                      }
                                                                    >
                                                                      <ConfirmationModal
                                                                        confirmModalContent={
                                                                          confirmModalContent
                                                                        }
                                                                        ishandleDeletePosition={this.scheduleDeleteFromScrollHeader.bind(
                                                                          this,
                                                                          schdeule,
                                                                          data
                                                                        )}
                                                                      />
                                                                    </OutsideClickHandler>
                                                                  </div>
                                                                </div>
                                                              </Dropdown.Menu>
                                                            )}
                                                        </Dropdown>
                                                      </div>
                                                    );
                                                  }
                                                )}
                                              </Dropdown.Item>
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        </div>
                                      )}
                                    </div>
                                  );
                                } else {
                                  let showModalOnClick = true;
                                  let isDayLock = false;
                                  let showPlusSign = true;

                                  if (
                                    this.props.mainViewState.lockDays.includes(
                                      data.dayName
                                    ) ||
                                    this.props.mainViewState
                                      .importForecastBanner
                                  ) {
                                    showModalOnClick = false;
                                    isDayLock = true;
                                    showPlusSign = false;
                                  }

                                  if (data.bulkSelect) {
                                    showModalOnClick = false;
                                  }

                                  let className = "schedule-type blankShift";
                                  if (isDayLock) {
                                    if (
                                      data.dayValues[0].shiftPosition === "+"
                                    ) {
                                      className =
                                        "schedule-type blankShift unAssingedScrollHeaderDayLocked";
                                    }
                                  }

                                  return (
                                    // <>
                                    <div
                                      className={className}
                                      draggable={false}
                                      onDragOver={(e) =>
                                        this.dragOver(
                                          e,
                                          true,
                                          "rowIndex",
                                          data.dayName,
                                          "viewType"
                                        )
                                      }
                                      onDragLeave={() =>
                                        this.scrollHeaderDragLeave(data.dayName)
                                      }
                                      onDrop={(e) =>{
                                          this.CheckMPORonScrollHeaderDrop(
                                            e,
                                            data.dayName,
                                            "blank",
                                            data
                                          )}
                                      }
                                      // onClick={(e) => {
                                      //   if (showModalOnClick) {
                                      //     this.openAddOnBlankClick(
                                      //       data.dayValues[0],
                                      //       "unAssigned",
                                      //       this.props.row,
                                      //       data.dayName
                                      //     );
                                      //   }
                                      // }}
                                      key={idx}
                                    >
                                      <div className="details"  onClick={(e) => {
                                        if (showModalOnClick) {
                                          this.openAddOnBlankClick(
                                            data.dayValues[0],
                                            "unAssigned",
                                            this.props.row,
                                            data.dayName
                                          );
                                        }
                                      }}>
                                        <span className="schedule-time">
                                          {data.dayValues[0].displayTime}
                                        </span>
                                        <EllipsisWithTooltip placement="bottom">
                                          <span
                                            className={
                                              !showPlusSign
                                                ? "schedule-details hidePlusShift"
                                                : "schedule-details"
                                            }
                                          >
                                            {data.dayValues[0].shiftPosition}
                                          </span>
                                        </EllipsisWithTooltip>
                                      </div>
                                      {/* </div> */}
                                      <Dropdown show>
                                        {data.dropMPORWarning === "showMPORWarningOnDrop" && (
                                      <Dropdown.Menu show
                                        //alignRight
                                        className="reassign-dropdown-box"
                                      >
                                        <div className="single-select-image dropdownItemPaddingRemove">
                                          <div className="showReassignShiftList">
                                            <OutsideClickHandler
                                              onOutsideClick={() =>{
                                                this.reassignWarningSubmitFromScrollHeader("",data,data.dayName,false);
                                                // this.scrollHeaderOutsideClick(
                                                //   "",
                                                //   data,
                                                //   data.dayName
                                                //   )
                                                }
                                              }
                                            >
                                              <ConfirmationModal
                                                // confirmModalContent={
                                                //   confirmModalContent
                                                // }
                                                confirmModalContent={scheduleComponents.confirmationInfo(
                                                  "unAssigned",
                                                  {},
                                                  {},
                                                  "onUnassignedMPORAlert"
                                                )}
                                                ishandleDeletePosition={this.reassignWarningSubmitFromScrollHeader.bind(
                                                  this,
                                                  "",
                                                  data,data.dayName
                                                )}
                                              />
                                            </OutsideClickHandler>
                                          </div>
                                        </div>
                                      </Dropdown.Menu>)}
                                        </Dropdown>
                                    </div>
                                  );
                                }
                              } else {
                                return false;
                              }
                            }
                          )}
                        </div>
                      </div>
                    </div>
                    {/* ScrollHeader Ends */}

                    {this.state.tableData.length > 0 && (
                      <div>
                        <div className="table">
                          <BootstrapTable
                            {...props.baseProps}
                            keyField="rowNo"
                            hover
                            condensed
                            rowClasses={rowClasses}
                          />
                        </div>
                        {this.state.EmployeeTypeTotal!=="" &&(
                       <div className="employee-details dept-employee-details">         
                        <div className="entry">
                          <span className="lable">{this.state.EmployeeTypeTotal.split('#')[0].slice(0,2)}</span>
                          <span>{this.state.EmployeeTypeTotal.split('#')[0].slice(3)}</span>
                        </div>
                        <div className="entry">
                          <span className="lable">{this.state.EmployeeTypeTotal.split('#')[1].slice(0,2)}</span>
                          <span>{this.state.EmployeeTypeTotal.split('#')[1].slice(3)}</span>
                        </div>
                        <div className="entry">
                          <span className="lable">{this.state.EmployeeTypeTotal.split('#')[2].slice(0,4)}</span>
                          <span>{this.state.EmployeeTypeTotal.split('#')[2].slice(5)}</span>
                        </div>
                      </div>
                       )}
                        {!this.props.mainViewState.importForecastBanner &&
                          !this.props.mainViewState.isPageLock &&
                          !this.props.mainViewState.isBulkSelect &&
                          this.props.mainParentState
                            .permissionManageSchedule && (
                            <div className="addUserSec">
                              <Button
                                className="btn-ghost btn btn-primary"
                                onClick={() => this.addUserFooter()}
                              >
                                Add User
                              </Button>
                            </div>
                          )}
                      </div>
                    )}
                  </div>
                )}
              </ToolkitProvider>

              {this.state.bulkSelect && (
                <div className="tableFooter">
                  <div className="bulkSelectFooter">
                    <Form.Check
                      type="checkbox"
                      label=""
                      id="footerBulkCheckBox"
                      onClick={(e: any) => {
                        e.stopPropagation();
                        this.footerBulkSelectAll(e);
                      }}
                    />
                    <span className="shift-selected-count">
                      {this.state.bulkSelctShiftsCount}{" "}
                      {this.state.bulkSelctShiftsCount <= 1 && "shift"}
                      {this.state.bulkSelctShiftsCount > 1 && "shifts"} selected
                    </span>
                    <div className="action-group d-flex flex-row mr-auto">
                    <div className="assign-shift">
                          {this.state.viewUnassignConfirmModal && (
                            <Dropdown className="single-select-image" show>
                              <Dropdown.Menu>
                                <OutsideClickHandler
                                  onOutsideClick={
                                    this.bulkSelectAssignDropdownHide
                                  }
                                >
                                  <ConfirmationModal
                                    confirmModalContent={scheduleComponents.confirmationInfo(
                                      "bulkShift",
                                      {},
                                      {},
                                      "bulkUnassignAlert"
                                    )}
                                    // confirmModalContent={confirmModalContent}
                                    ishandleDeletePosition={this.confimationModalBulkUnassign.bind(
                                      this
                                    )}
                                  />
                                </OutsideClickHandler>
                              </Dropdown.Menu>
                            </Dropdown>
                          )}
                           <Button
                          disabled={this.state.bulkSelctShiftsCount <= 0}
                          className="unassign btn-outline-primary"
                          onClick={() =>
                            this.bulkSeclectUnassignModalShow()
                            // this.bulkSeclectOption("", "Unassigned")
                          }
                        >
                          Unassign
                        </Button>
                        </div>
                      <div className="assign-shift">
                      {this.state.viewReassignConfirmModal && (
                            <Dropdown className="single-select-image" show>
                              <Dropdown.Menu>
                                <OutsideClickHandler
                                  onOutsideClick={
                                    this.bulkSelectAssignDropdownHide
                                  }
                                >
                                  <ConfirmationModal
                                    confirmModalContent={scheduleComponents.confirmationInfo(
                                      "bulkShift",
                                      {},
                                      {},
                                      "bulkReassignAlert"
                                    )}
                                    // confirmModalContent={confirmModalContent}
                                    ishandleDeletePosition={this.confimationModalBulkReassign.bind(
                                      this
                                    )}
                                  />
                                </OutsideClickHandler>
                              </Dropdown.Menu>
                            </Dropdown>
                          )}
                        {this.state.viewAssignDropdown && (
                          <Dropdown className="single-select-image" show>
                            <Dropdown.Menu>
                              <OutsideClickHandler
                                onOutsideClick={
                                  this.bulkSelectAssignDropdownHide
                                }
                              >
                                <ReassignAllModal
                                  row={this.state.footerAssignRow}
                                  parentState={this.props.mainViewState}
                                  hidValue={this.props.mainParentState.hidValue}
                                  requestType="LaborSchedule"
                                  handleSelectedItem={this.slectFromSingleSearch.bind(
                                    this,
                                    this.state.footerAssignRow
                                  )}
                                />
                              </OutsideClickHandler>
                            </Dropdown.Menu>
                          </Dropdown>
                        )}
                        <Button
                          disabled={this.state.bulkSelctShiftsCount <= 0}
                          className="assign btn-outline-primary"
                         // onClick={() => this.bulkSelectAssignDropdownShow()}
                         onClick={() => this.bulkSeclectReassignModalShow()}
                          
                        >
                          Assign
                        </Button>
                      </div>
                      <div className="assign-shift">
                      {this.state.viewDeleteConfirmModal && (
                            <Dropdown className="single-select-image" show>
                              <Dropdown.Menu>
                                <OutsideClickHandler
                                  onOutsideClick={
                                    this.bulkSelectAssignDropdownHide
                                  }
                                >
                                  <ConfirmationModal
                                    confirmModalContent={scheduleComponents.confirmationInfo(
                                      "bulkShift",
                                      {},
                                      {},
                                      "bulkDeleteAlert"
                                    )}
                                    // confirmModalContent={confirmModalContent}
                                    ishandleDeletePosition={this.confimationModalBulkDelete.bind(
                                      this
                                    )}
                                  />
                                </OutsideClickHandler>
                              </Dropdown.Menu>
                            </Dropdown>
                          )}

                      <Button
                        disabled={this.state.bulkSelctShiftsCount <= 0}
                        className="remove btn-outline-primary"
                       // onClick={() => this.bulkSeclectOption("", "delete")}
                       onClick={() => this.bulkSeclectDeleteModalShow()}
                      >
                        Delete
                      </Button>
                      </div>
                      <div className="assign-shift">
                          {/* {this.state.viewDeleteConfirmModal && (
                            <Dropdown className="single-select-image" show>
                              <Dropdown.Menu>
                                <OutsideClickHandler
                                  onOutsideClick={
                                    this.bulkSelectAssignDropdownHide
                                  }
                                >
                                  <ConfirmationModal
                                    confirmModalContent={scheduleComponents.confirmationInfo(
                                      "bulkShift",
                                      {},
                                      {},
                                      "bulkDeleteAlert"
                                    )}
                                    // confirmModalContent={confirmModalContent}
                                    ishandleDeletePosition={this.confimationModalBulkDelete.bind(
                                      this
                                    )}
                                  />
                                </OutsideClickHandler>
                              </Dropdown.Menu>
                            </Dropdown>
                          )} */}
                          <Button
                            disabled={this.state.bulkSelctShiftsCount <= 0}
                            className="remove btn-outline-primary"
                            onClick={() =>
                            this.bulkSeclectOption("", "Duplicate")
                              //  this.bulkSeclectDeleteModalShow()
                            }
                          >
                            Duplicate
                          </Button>
                        </div>
                    </div>
                    <Button
                      className="closeButton btn-ghost-light"
                      onClick={() => this.footerBulkClose()}
                    >
                      &times;
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </>
    );
  }
}
